<template>
  <div class="table">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="container materialMasterAdd">
      <!--操作按钮-->
      <div class="searchBox_bottom">
        <el-button v-if="createParams.isSave || roterType=='copy'" type="primary" @click="save(1)" :disabled="isDisabled">{{$t('common.saveDraft')}}</el-button>
        <el-button v-if="createParams.isSubmit || !this.id || roterType=='copy'" type="primary" @click="save(2)" :disabled="isDisabled">{{$t('common.submit')}}</el-button>
        <el-button v-if="isExamine" key="showApproval" @click="showApproval = true" type="primary">{{$t('material.showApproval')}}</el-button>
        <!--选择对比物物料-->
        <el-button type="primary" @click="showContrast = true">{{$t('material.showContrast')}}</el-button>
        <!--上传附件-->
        <el-upload v-if='isShowFile&& id' style='margin:0 10px;' ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
          <el-button slot="trigger" size="mini" type="primary">{{$t('common.upload')}}</el-button>
        </el-upload>
        <!--查看附件-->
        <el-button type="primary" v-if="fileList.length>0" @click="showFileTable = true">{{$t('material.seeattachment')}}</el-button>
        <!--物料填写模版-->
        <el-link type="primary" @click="downloadTemplate('/templates/download/物料字段详解v4.pdf','物料字段详解v4.pdf')" class="MaterialTemplate">{{$t('material.MaterialTemplate')}}</el-link>
      </div>
      <el-form :model="createParams" ref="createParams" :rules="rules" :label-position="labelPosition" :disabled="disaForm">
        <el-tabs type="border-card">
          <el-tab-pane :label="$t('material.createParams')">
            <el-row>
              <!--创建人-->
              <el-col :span="6">
                <el-form-item :label="$t('common.createBy')" prop="createUserName" label-width="110px">
                  <el-input v-model.trim="createParams.createUserName" clearable disabled style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <!--创建日期-->
              <el-col :span="6">
                <el-form-item :label="$t('common.createDate')" prop="createDate" label-width="110px">
                  <el-input v-model.trim="createParams.createDate" clearable disabled style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <!--版本-->
              <el-col :span="6">
                <el-form-item :label="$t('material.edition')" prop="edition" label-width="110px">
                  <el-input v-model.trim="createParams.edition" clearable disabled style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <!--状态-->
              <el-col :span="6">
                <el-form-item :label="$t('material.conductStatus')" prop="conductStatusI18n" label-width="110px">
                  <el-input v-model.trim="createParams.conductStatusI18n" clearable disabled style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!--物料编码-->
              <el-col :span="6">
                <el-form-item :label="$t('material.eightBitCode') " prop="eightBitCode" label-width="110px">
                  <el-input v-if="($route.query.type!=='copy'&&isPop)||isEightBitCode" v-model.trim="createParams.eightBitCode" onkeyup="this.value=this.value.replace(/[^\w]/g,'');" clearable style="width: 100%;"></el-input>
                  <el-input v-else v-model.trim="createParams.eightBitCode" disabled style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <!--结算单位编码-->
              <el-col :span="6">
                <el-form-item :label="$t('material.settlementUnitCode')" prop="settlementUnitCode" label-width="110px">
                  <el-input v-model.trim="createParams.settlementUnitCode" readonly :disabled="(createParams.conductStatus=='approved'|| disaSettlementUnitCode) || createParams.isUpdateSettlementUnit" style="width: 100%;">
                    <el-button slot="append" icon="el-icon-search" @click="showSettlementUnitDialog=true" v-if="!((createParams.conductStatus=='approved'|| disaSettlementUnitCode) || createParams.conductStatus=='mdm_maintenance' || createParams.isUpdateSettlementUnit)"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <!--结算单位名称-->
              <el-col :span="6">
                <el-form-item :label="$t('material.settlementUnitName')" prop="settlementUnitName" label-width="110px">
                  <el-input v-model="createParams.settlementUnitName" disabled style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <!--工厂名称-->
              <el-col :span="6">
                <el-form-item :label="$t('material.tmPlantName')" prop="tmPlantName" label-width="110px">
                  <el-tooltip class="item" :content="createParams.tmPlantName" placement="top" v-if="createParams.tmPlantName">
                    <el-input v-model.trim="createParams.tmPlantName" clearable readonly style="width: 100%;">
                      <el-button slot="append" icon="el-icon-search" v-if="!(createParams.conductStatus=='approved'  || createParams.conductStatus=='mdm_maintenance' || disaSettlementUnitCode  || createParams.isUpdateSettlementUnit)" @click="isShowPlan(createParams.conductStatus=='approved'  || createParams.conductStatus=='mdm_maintenance' || disaSettlementUnitCode  || createParams.isUpdateSettlementUnit)"></el-button>
                    </el-input>
                  </el-tooltip>
                  <el-input v-model.trim="createParams.tmPlantName" clearable readonly v-else style="width: 100%;">
                    <el-button slot="append" icon="el-icon-search" v-if="!(createParams.conductStatus=='approved'  || createParams.conductStatus=='mdm_maintenance' || disaSettlementUnitCode  || createParams.isUpdateSettlementUnit)" @click="isShowPlan(createParams.conductStatus=='approved'  || createParams.conductStatus=='mdm_maintenance' || disaSettlementUnitCode  || createParams.isUpdateSettlementUnit)"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 工厂ID -->
              <el-col :span="6">
                <el-form-item label="工厂编码" prop="plantCodeView" label-width="110px">
                  <el-input v-model.trim="createParams.plantCodeView" disabled style="width: 100%;">
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- 产品状态 -->
              <el-col :span="6">
                <el-form-item :label="$t('material.tmMaterial')" prop="status" label-width="110px">
                  <ic-select clearable table="TM_MATERIAL" field="STATUS" v-model="createParams.status" :disabled="isSup || disaHead" style="width: 100%;"></ic-select>
                </el-form-item>
              </el-col>
              <!-- GRI-->
              <el-col :span="6">
                <el-form-item :label="$t('material.showGriDialogFun')" prop="fiveBitCode" label-width="110px">
                  <el-input v-model.trim="createParams.fiveBitCode" clearable readonly :disabled="isSup || createParams.conductStatus=='approved' || disaHead || createParams.conductStatus=='mdm_maintenance'||(createParams.conductStatus=='return'&&createParams.isUpdateSettlementUnit) " style="width: 100%;">
                    <!-- 有通过过 时 退回状态 不编辑 ；没有通过时false，退回状态 可编辑-->
                    <el-button slot="append" icon="el-icon-search" @click="showGriDialogFun" v-if="!(isSup || createParams.conductStatus=='approved' || disaHead || createParams.conductStatus=='mdm_maintenance'||(createParams.conductStatus=='return'&&createParams.isUpdateSettlementUnit) )">
                    </el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <!--是否LTO改名是否NFSC审批-->
              <el-col :span="6">
                <el-form-item label="是否NFSC审批" prop="isLto" label-width="110px">
                  <ic-select table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isLto" :disabled="$route.query.type!=='copy'&&(disaHead || (materialType=='new_conventional_material'&&(!createParams.conductStatus||createParams.conductStatus==='mdm_newly_build')))" @change="getLeaderList(),createParams.approvedBy = null,createParams.isPromotionalItem=createParams.isLto" style="width: 100%;"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 非常规物料标识 -->
              <el-col :span="6" v-if="isShow">
                <el-form-item label="非常规物料标识" prop="isConventionalMaterials" label-width="110px">
                  <el-select v-model="createParams.isConventionalMaterials" @change="isConventionalMaterialsChange" style="width: 100%;">
                    <el-option :key="index" v-for="(item,index) in isConventionalMaterialsList" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--是否赠品-->
              <!-- 非常规物料标识为Y展示 -->
              <el-col v-if="createParams.isConventionalMaterials == 'Y'" :span="6">
                <el-form-item :label="$t('material.isGift')" prop="isGift" label-width="110px">
                  <ic-select style="width: 100%;" table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isGift" :disabled="disaHead"></ic-select>
                </el-form-item>
              </el-col>
              <!--提交审批人-->
              <el-col :span="6">
                <el-form-item :label="$t('material.selectApprovedBy')" prop="approvedBy" label-width="110px">
                  <el-select v-model="createParams.approvedBy" :disabled="disaHead" @change="selectApprovedBy" style="width: 100%;">
                    <el-option :key="index" v-for="(item,index) in leaderList" :label="item.userName" :value="item.tmUserId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- CQS是否审批 -->
              <el-col :span="6" v-if="isShowParams&&createParams.isConventionalMaterials == 'Y'">
                <el-form-item label="CQS是否审批" prop="isCqsAudit" label-width="110px">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isCqsAudit" @change="isCqsAuditChange" style="width: 100%!important;"></ic-select>
                </el-form-item>
              </el-col>
              <!-- CQS审批人 -->
              <el-col :span="6" v-if="isShowParams&&createParams.isConventionalMaterials == 'Y'">
                <el-form-item label="CQS审批人" prop="cqsAuditor" label-width="110px">
                  <el-select v-model="createParams.cqsAuditor" :disabled="createParams.isCqsAudit!=='Y'" style="width: 100%;">
                    <el-option :key="index" v-for="(item,index) in cqsAuditorLists" :label="item.userName" :value="item.tmUserId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- Finance是否审批 -->
              <el-col :span="6" v-if="isShowParams&&createParams.isConventionalMaterials == 'Y'">
                <el-form-item label="Finance是否审批" prop="isFinanceAudit" label-width="110px">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isFinanceAudit" @change="isFinanceAuditChange" style="width: 100%!important;"></ic-select>
                </el-form-item>
              </el-col>
              <!-- Finance审批人- -->
              <el-col :span="6" v-if="isShowParams&&createParams.isConventionalMaterials == 'Y'">
                <el-form-item label="Finance审批人" prop="financeAuditor" label-width="110px">
                  <el-select v-model="createParams.financeAuditor" :disabled="createParams.isFinanceAudit!=='Y'" @change="selectApprovedBy" style="width: 100%;">
                    <el-option :key="index" v-for="(item,index) in financeAuditorLists" :label="item.name" :value="item.tmUserId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 是否新增DC -->
              <!-- is MDM并且审核通过可见 -->
              <el-col :span="6" v-if="emplFlag == 'M' && createParams.isUpdateSettlementUnit">
                <el-form-item label="是否新增DC" prop="isNewDc" label-width="110px">
                  <el-select v-model="createParams.isNewDc" style="width: 100%" :disabled="!id">
                    <el-option :key="index" v-for="(item,index) in isNewDcList" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
                  </el-select>
                  <span class="el-form-item__error fixed-tip">(直送DC物料仅拓展BU且运费不变，请选是)</span>
                </el-form-item>
              </el-col>
              <!-- <el-col style="text-align:right" v-if="emplFlag == 'M' && createParams.isUpdateSettlementUnit">
              </el-col> -->
              <!-- 是否促销品 -->
              <el-col :span="6">
                <el-form-item label="是否促销品" prop="isPromotionalItem" label-width="110px">
                  <ic-select table="TM_MATERIAL_RECORD" field="IS_PROMOTIONALITEM" v-model="createParams.isPromotionalItem" :disabled="$route.query.type!=='copy'&&(disaHead || (materialType=='new_conventional_material'&&(!createParams.conductStatus||createParams.conductStatus==='mdm_newly_build')))" style="width: 100%;"></ic-select>
                </el-form-item>
              </el-col>
              <!-- 供应商侧物料编码 -->
              <el-col :span="6">
                <el-form-item label="供应商侧物料编码" prop="supplierMaterialCode" label-width="110px">
                  <el-input v-model.trim="createParams.supplierMaterialCode" :disabled="disaHead" maxlength="50" style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <!-- 画稿 -->
              <el-col :span="18" v-if="emplFlag!=='S'">
                <el-form-item label="画稿" prop="drawings" label-width="110px">
                  <el-input v-model.trim="createParams.drawings" maxlength="50" show-word-limit :disabled="disaHead" style="width: 100%;"></el-input>
                </el-form-item>
              </el-col>
              <!-- 主要材质 -->
              <el-col :span="6" v-if="emplFlag!=='S'">
                <el-form-item label="主要材质" prop="mainMaterial" label-width="110px">
                  <el-input v-model.trim="createParams.mainMaterial" :disabled="disaHead" style="width: 100%;"></el-input>
                  <!-- <ic-select table="TM_MATERIAL_RECORD" field="MAIN_MATERIAL" v-model="createParams.mainMaterial" :disabled="disaHead" clearable style="width: 100%;"></ic-select> -->
                </el-form-item>
              </el-col>

            </el-row>
            <!--======数据列表===========-->
            <table style="padding-top: 15px;">
              <tr style="height: 35px">
                <th colspan="2">{{$t('material.nowVersion')}}</th>
                <th v-if="oldRecordExists">{{$t('material.LastVersion')}}</th>
                <th>{{$t('material.ComparisonMaterial')}}</th>
              </tr>
              <tr>
                <th class="card-title"></th>
              </tr>
              <tr>
                <!-- 产品中文名称 -->
                <td style="width: 230px;"><span>*</span>{{$t('material.chineseNameOfProduct')}}</td>
                <td style="width: 230px;">
                  <el-form-item prop="eightBitCodeName">
                    <el-tooltip class="item" :content="createParams.eightBitCodeName" placement="top">
                      <el-input v-model="createParams.eightBitCodeName" maxlength="100" @blur="delTrim(createParams.eightBitCodeName,'eightBitCodeName')" :disabled="isFpa" clearable></el-input>
                    </el-tooltip>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.eightBitCodeName==oldParams.eightBitCodeName?'':'red')}" style="width: 230px;">
                  {{oldParams.eightBitCodeName}}
                </td>
                <td :style="{color:(createParams.eightBitCodeName==contrastParams.eightBitCodeName?'':'red')}" style="width: 230px;">
                  {{contrastParams.eightBitCodeName}}
                </td>
              </tr>
              <tr>
                <!-- 产品英文名称 -->
                <td><span>*</span>{{$t('material.englishNameOfProduct')}}</td>
                <td>
                  <el-form-item prop="rawProductEName">
                    <el-tooltip class="item" :content="createParams.rawProductEName" placement="top">
                      <el-input v-model="createParams.rawProductEName" maxlength="100" @blur="delTrim(createParams.rawProductEName,'rawProductEName')" clearable></el-input>
                    </el-tooltip>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.rawProductEName==oldParams.rawProductEName?'':'red')}">
                  {{oldParams.rawProductEName}}
                </td>
                <td :style="{color:(createParams.rawProductEName==contrastParams.rawProductEName?'':'red')}">
                  {{contrastParams.rawProductEName}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td><span>*</span>{{$t('material.englishAbbreviationOfProduct')}}</td>
                <td>
                  <el-form-item prop="rawProductEAbbreviation">
                    <el-input v-model="createParams.rawProductEAbbreviation" maxlength="28" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.rawProductEAbbreviation==oldParams.rawProductEAbbreviation?'':'red')}">
                  {{oldParams.rawProductEAbbreviation}}
                </td>
                <td :style="{color:(createParams.rawProductEAbbreviation==contrastParams.rawProductEAbbreviation?'':'red')}">
                  {{contrastParams.rawProductEAbbreviation}}
                </td>
              </tr>
              <template v-if="isPop">
                <tr v-if="!isSup">
                  <td><span>*</span>{{$t('material.sumsSort')}}</td>
                  <td>
                    <el-form-item prop="sumsSort">
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="SUMS_SORT" v-model="createParams.sumsSort"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SUMS_SORT" v-model="oldParams.sumsSort" disabled></ic-select>
                    <span v-if="createParams.sumsSort!=oldParams.sumsSort && oldParams.sumsSort">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SUMS_SORT" v-model="contrastParams.sumsSort" disabled></ic-select>
                    <span v-if="createParams.sumsSort!=contrastParams.sumsSort && contrastParams.sumsSort">!</span>
                  </td>
                </tr>
                <tr v-if="!isSup">
                  <td><span>*</span>{{$t('material.specifiUom')}}</td>
                  <td>
                    <el-form-item prop="specifiUom">
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="SPECIFI_UOM" v-model="createParams.specifiUom"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SPECIFI_UOM" v-model="oldParams.specifiUom" disabled></ic-select>
                    <span v-if="createParams.specifiUom!=oldParams.specifiUom && oldParams.specifiUom">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SPECIFI_UOM" v-model="contrastParams.specifiUom" disabled></ic-select>
                    <span v-if="createParams.specifiUom!=contrastParams.specifiUom && contrastParams.specifiUom">!</span>
                  </td>
                </tr>
                <tr v-if="!isSup">
                  <td><span>*</span>{{$t('material.projectOrCategoryLeader')}}</td>
                  <td>
                    <el-form-item prop="projectOrCategoryLeader">
                      <el-input v-model.trim="createParams.projectOrCategoryLeader" maxlength="100" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.projectOrCategoryLeader==oldParams.projectOrCategoryLeader?'':'red')}">
                    {{oldParams.projectOrCategoryLeader}}
                  </td>
                  <td :style="{color:(createParams.projectOrCategoryLeader==contrastParams.projectOrCategoryLeader?'':'red')}">
                    {{contrastParams.projectOrCategoryLeader}}
                  </td>
                </tr>
                <tr v-show="!isSup">
                  <td><span>*</span>{{$t('material.department')}}</td>
                  <td>
                    <el-form-item prop="department">
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="DEPARTMENT" v-model="createParams.department"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="DEPARTMENT" v-model="oldParams.department" disabled></ic-select>
                    <span v-if="createParams.department!=oldParams.department && oldParams.department">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="DEPARTMENT" v-model="contrastParams.department" disabled></ic-select>
                    <span v-if="createParams.department!=contrastParams.department && contrastParams.department">!</span>
                  </td>
                </tr>
                <tr v-show="!isSup">
                  <td><span>*</span>{{$t('material.formarkets')}}</td>
                  <td>
                    <el-form-item prop="formarkets">
                      <el-select v-model="formarkets" clearable multiple class="multiple_sel" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in formarketsList" :label="item.chineseValue" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="FORMARKETS" multiple v-model="oldFormarkets" disabled class="multiple_sel" style="width:100%"></ic-select>
                    <span v-if="oldFormarketsFlag && oldFormarkets.length>0">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="FORMARKETS" multiple v-model="contrastFormarkets" disabled class="multiple_sel" style="width:100%"></ic-select>
                    <span v-if="contrastFormarketsFlag && contrastFormarkets.length>0">!</span>
                  </td>
                </tr>
                <tr v-show="!isSup">
                  <td><span>*</span>{{$t('material.sizeMm')}}</td>
                  <td>
                    <el-form-item prop="sizeMm">
                      <el-input v-model.trim="createParams.sizeMm" clearable maxlength="100"></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.sizeMm==oldParams.sizeMm?'':'red')}">
                    {{oldParams.sizeMm}}
                  </td>
                  <td :style="{color:(createParams.sizeMm==contrastParams.sizeMm?'':'red')}">
                    {{contrastParams.sizeMm}}
                  </td>
                </tr>
                <tr v-show="!isSup">
                  <td><span>*</span>{{$t('material.forStoreTier')}}</td>
                  <td>
                    <el-form-item prop="forStoreTier">
                      <el-input v-model.trim="createParams.forStoreTier" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.forStoreTier==oldParams.forStoreTier?'':'red')}">
                    {{oldParams.forStoreTier}}
                  </td>
                  <td :style="{color:(createParams.forStoreTier==contrastParams.forStoreTier?'':'red')}">
                    {{contrastParams.forStoreTier}}
                  </td>
                </tr>
                <tr v-show="!isSup">
                  <td><span>*</span>{{$t('material.internalAndExternalAreas')}}</td>
                  <td>
                    <el-form-item prop='internalAndExternalAreas'>
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="INTERNAL_AND_EXTERNAL_AREAS" v-model="createParams.internalAndExternalAreas"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="INTERNAL_AND_EXTERNAL_AREAS" v-model="oldParams.internalAndExternalAreas" disabled></ic-select>
                    <span v-if="createParams.internalAndExternalAreas!=oldParams.internalAndExternalAreas && oldParams.internalAndExternalAreas">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="INTERNAL_AND_EXTERNAL_AREAS" v-model="contrastParams.internalAndExternalAreas" disabled></ic-select>
                    <span v-if="createParams.internalAndExternalAreas!=contrastParams.internalAndExternalAreas && contrastParams.internalAndExternalAreas">!</span>
                  </td>
                </tr>
              </template>

              <tr v-if="!isSup">
                <td><span>*</span>{{$t('material.purchasingCategory')}}</td>
                <td>
                  <el-form-item prop="purchasingCategory">
                    <!-- 采购分类 -->
                    <el-tooltip class="item" :content='createParams.purchasingCategory' placement="top">
                      <el-input v-model.trim="createParams.purchasingCategory" clearable disabled></el-input>
                    </el-tooltip>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.purchasingCategory==oldParams.purchasingCategory?'':'red')}">
                  {{oldParams.purchasingCategory}}
                </td>
                <td :style="{color:(createParams.purchasingCategory==contrastParams.purchasingCategory?'':'red')}">
                  {{contrastParams.purchasingCategory}}
                </td>
              </tr>
              <tr v-if="!isSup">
                <td><span>*</span>{{$t('material.settlementClassification')}}</td>
                <td>
                  <el-form-item prop="settlementClassification">
                    <!-- 结算分类 -->
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SETTLEMENT_CLASSIFICATION" v-model="createParams.settlementClassification"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="SETTLEMENT_CLASSIFICATION" v-model="oldParams.settlementClassification" disabled></ic-select>
                  <span v-if="createParams.settlementClassification!=oldParams.settlementClassification && oldParams.settlementClassification">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="SETTLEMENT_CLASSIFICATION" v-model="contrastParams.settlementClassification" disabled></ic-select>
                  <span v-if="createParams.settlementClassification!=contrastParams.settlementClassification && contrastParams.settlementClassification">!</span>
                </td>
              </tr>
              <template v-if="!isPop">
                <tr v-if="!isSup">
                  <!-- 采购经理 -->
                  <td><span>*</span>{{$t('material.purchasingManager')}}</td>
                  <td>
                    <el-form-item prop="purchasingManager">
                      <el-input v-model.trim="createParams.purchasingManager" disabled clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <el-input v-model.trim="oldParams.purchasingManager" disabled clearable></el-input>
                    <span v-if="createParams.purchasingManager!=oldParams.purchasingManager && oldParams.purchasingManager">!</span>
                  </td>
                  <el-input v-model.trim="contrastParams.purchasingManager" disabled clearable></el-input>
                  <span v-if="createParams.purchasingManager!=contrastParams.purchasingManager && contrastParams.purchasingManager">!</span>
                </tr>
                <tr>
                  <!-- RP生效日期 -->
                  <td>{{$t('material.rpEffectiveDate')}}</td>
                  <td>
                    <el-form-item>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="createParams.rpEffectiveDate" type="date" disabled></el-date-picker>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.rpEffectiveDate==oldParams.rpEffectiveDate?'':'red')}">
                    {{oldParams.rpEffectiveDate}}
                  </td>
                  <td :style="{color:(createParams.rpEffectiveDate==contrastParams.rpEffectiveDate?'':'red')}">
                    {{contrastParams.rpEffectiveDate}}
                  </td>
                </tr>
                <tr>
                  <!-- 使用区域 -->
                  <td><span v-if="isFieldRequired('useArea')">*</span>{{$t('material.useArea')}}</td>
                  <td>
                    <el-form-item prop="useArea" :rules="isFieldRequired('useArea')?[rules.requiredRules]:[]">
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="USE_AREA" v-model="createParams.useArea"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.useArea==oldParams.useArea?'':'red')}">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="USE_AREA" v-model="oldParams.useArea" disabled></ic-select>
                  </td>
                  <td :style="{color:(createParams.useArea==contrastParams.useArea?'':'red')}">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="USE_AREA" v-model="contrastParams.useArea" disabled></ic-select>
                  </td>
                </tr>
                <tr>
                  <!-- 上市时间 -->
                  <td>{{$t('material.marketTime')}}</td>
                  <td>
                    <el-form-item>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="createParams.marketTime" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.marketTime==oldParams.marketTime?'':'red')}">
                    {{oldParams.marketTime}}
                  </td>
                  <td :style="{color:(createParams.marketTime==contrastParams.marketTime?'':'red')}">
                    {{contrastParams.marketTime}}
                  </td>
                </tr>
                <!-- 停售日期 -->
                <tr v-if="emplFlag!=='S'">
                  <td><span v-if="isFieldRequired('stopSaleDate')">*</span>{{$t('material.StopSaleDate')}}</td>
                  <td>
                    <el-form-item prop="stopSaleDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="createParams.stopSaleDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.stopSaleDate==oldParams.stopSaleDate?'':'red')}">
                    {{oldParams.stopSaleDate}}
                  </td>
                  <td :style="{color:(createParams.stopSaleDate==contrastParams.stopSaleDate?'':'red')}">
                    {{contrastParams.stopSaleDate}}
                  </td>
                </tr>
              </template>
              <tr>
                <!-- 税收分类编码 -->
                <td><span>*</span>{{$t('material.taxClassificationCode')}}</td>
                <td>
                  <el-form-item prop="taxClassificationCode">
                    <el-input v-model.trim="createParams.taxClassificationCode" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.taxClassificationCode==oldParams.taxClassificationCode?'':'red')}">
                  {{oldParams.taxClassificationCode}}
                </td>
                <td :style="{color:(createParams.taxClassificationCode==contrastParams.taxClassificationCode?'':'red')}">
                  {{contrastParams.taxClassificationCode}}
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.canCtcSettle')}}</td>
                <td>
                  <el-form-item prop="canCtcSettle" :rules="[rules.requiredRules]">
                    <!-- 是否CTC可结算 -->
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" @change="changeCanCtcSettle" v-model="createParams.canCtcSettle"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.canCtcSettle" disabled></ic-select>
                  <span v-if="createParams.canCtcSettle!=oldParams.canCtcSettle && oldParams.canCtcSettle">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.canCtcSettle" disabled></ic-select>
                  <span v-if="createParams.canCtcSettle!=contrastParams.canCtcSettle && contrastParams.canCtcSettle">!</span>
                </td>
              </tr>
              <tr v-if="createParams.canCtcSettle == 'Y'">
                <!-- 是否CTC进口 -->
                <td>{{$t('material.isCtcImport')}}</td>
                <td>
                  <el-form-item prop="isCtcImport">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isCtcImport"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isCtcImport" disabled></ic-select>
                  <span v-if="createParams.isCtcImport!=oldParams.isCtcImport && oldParams.isCtcImport">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isCtcImport" disabled></ic-select>
                  <span v-if="createParams.isCtcImport!=contrastParams.isCtcImport && contrastParams.isCtcImport">!</span>
                </td>
              </tr>
              <tr v-if="createParams.canCtcSettle == 'Y'">
                <!-- 是否CTC直采 -->
                <td>{{$t('material.isCtcDirectMining')}}</td>
                <td>
                  <el-form-item prop="isCtcDirectMining">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isCtcDirectMining"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isCtcDirectMining" disabled></ic-select>
                  <span v-if="createParams.isCtcDirectMining!=oldParams.isCtcDirectMining && oldParams.isCtcDirectMining">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isCtcDirectMining" disabled></ic-select>
                  <span v-if="createParams.isCtcDirectMining!=contrastParams.isCtcDirectMining && contrastParams.isCtcDirectMining">!</span>
                </td>
              </tr>
              <tr v-if="!isPop">
                <td>{{$t('material.remarks')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model="createParams.remarks" @blur="delTrim(createParams.remarks,'remarks')" maxlength="200" type="textarea" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.remarks==oldParams.remarks?'':'red')}">
                  {{oldParams.remarks}}
                </td>
                <td :style="{color:(createParams.remarks==contrastParams.remarks?'':'red')}">
                  {{contrastParams.remarks}}
                </td>
              </tr>
              <tr>
                <th class="card-title">{{$t('material.materialFactoryDetails')}}</th>
              </tr>
              <tr v-if="!isPop">
                <!-- 是否进口 -->
                <td>{{$t('material.importedOrNot')}}</td>
                <td>
                  <el-form-item prop="importedOrNot">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" @change="importedOrNotChange" v-model="createParams.importedOrNot"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.importedOrNot" disabled></ic-select>
                  <span v-if="createParams.importedOrNot!=oldParams.importedOrNot && oldParams.importedOrNot">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.importedOrNot" disabled></ic-select>
                  <span v-if="createParams.importedOrNot!=contrastParams.importedOrNot && contrastParams.importedOrNot">!</span>
                </td>
              </tr>

              <tr>
                <td><span v-if="createParams.importedOrNot == 'N' && !isPop">*</span>GTIN</td>
                <td>
                  <!-- pop不检验必填 -->
                  <el-form-item v-if="isPop">
                    <el-input v-model.trim="createParams.gtin" clearable :rules="rules.gtin2" onkeyup="this.value=this.value.replace(/[^\w]/g,'');">
                    </el-input>
                  </el-form-item>
                  <!-- @blur="importedOrNotBlur($event)" -->
                  <el-form-item prop="gtin" :rules="createParams.importedOrNot == 'N' ? rules.gtin : rules.gtin2" v-else>
                    <el-input v-model.trim="createParams.gtin" clearable onkeyup="this.value=this.value.replace(/[^\w]/g,'');"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.gtin==oldParams.gtin?'':'red')}">
                  {{oldParams.gtin}}
                </td>
                <td :style="{color:(createParams.gtin==contrastParams.gtin?'':'red')}">
                  {{contrastParams.gtin}}
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.extendInventory')}}</td><!-- 是否延伸库存 -->
                <td>
                  <el-form-item prop="extendInventory">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.extendInventory"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.extendInventory" disabled></ic-select>
                  <span v-if="createParams.extendInventory!=oldParams.extendInventory && oldParams.extendInventory">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.extendInventory" disabled></ic-select>
                  <span v-if="createParams.extendInventory!=contrastParams.extendInventory && contrastParams.extendInventory">!</span>
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.originCountry')}}</td>
                <td>
                  <el-form-item prop="originCountry">
                    <el-input v-model.trim="createParams.originCountry" maxlength="10" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.originCountry==oldParams.originCountry?'':'red')}">
                  {{oldParams.originCountry}}
                </td>
                <td :style="{color:(createParams.originCountry==contrastParams.originCountry?'':'red')}">
                  {{contrastParams.originCountry}}
                </td>
              </tr>
              <!-- 折算系数 -->
              <tr v-if="!isSup">
                <td><span>*</span>{{$t('material.conversionCoefficient')}}</td>
                <td>
                  <el-form-item prop="conversionCoefficient">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="CONVERSION_COEFFICIENT" v-model="createParams.conversionCoefficient"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="CONVERSION_COEFFICIENT" v-model="oldParams.conversionCoefficient" disabled></ic-select>
                  <span v-if="createParams.conversionCoefficient!=oldParams.conversionCoefficient && oldParams.conversionCoefficient">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="CONVERSION_COEFFICIENT" v-model="contrastParams.conversionCoefficient" disabled></ic-select>
                  <span v-if="createParams.conversionCoefficient!=contrastParams.conversionCoefficient && contrastParams.conversionCoefficient">!</span>
                </td>
              </tr>
              <!-- 取货周期 -->
              <tr>
                <td>{{$t('material.pickUpPeriod')}}</td>
                <td>
                  <el-form-item prop="pickUpPeriod">
                    <el-input v-model.trim="createParams.pickUpPeriod" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.pickUpPeriod==oldParams.pickUpPeriod?'':'red')}">
                  {{oldParams.pickUpPeriod}}
                </td>
                <td :style="{color:(createParams.pickUpPeriod==contrastParams.pickUpPeriod?'':'red')}">
                  {{contrastParams.pickUpPeriod}}
                </td>
              </tr>
              <tr>
                <!-- 门店存货盘点频率 -->
              <tr v-if="!isSup">
                <td>门店存货盘点频率</td>
                <td>
                  <el-form-item prop="inventoryCountingFrequency">
                    <ic-select clearable table="TM_FIVE_BIT_CODE" field="INVENTORY_COUNTING_FREQUENCY" v-model="createParams.inventoryCountingFrequency"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_FIVE_BIT_CODE" field="INVENTORY_COUNTING_FREQUENCY" v-model="oldParams.inventoryCountingFrequency" disabled></ic-select>
                  <span v-if="createParams.inventoryCountingFrequency!=oldParams.inventoryCountingFrequency && oldParams.inventoryCountingFrequency">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_FIVE_BIT_CODE" field="INVENTORY_COUNTING_FREQUENCY" v-model="contrastParams.inventoryCountingFrequency" disabled></ic-select>
                  <span v-if="createParams.inventoryCountingFrequency!=contrastParams.inventoryCountingFrequency && contrastParams.inventoryCountingFrequency">!</span>
                </td>
              </tr>
              <tr>
                <!-- 最小订单量 -->
                <td><span>*</span>{{$t('material.minimumOrders')}}</td>
                <td>
                  <el-form-item prop="minimumOrders">
                    <el-input v-model.trim="createParams.minimumOrders" clearable @blur="minimumOrdersBlur" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.minimumOrders==oldParams.minimumOrders?'':'red')}">
                  {{oldParams.minimumOrders}}
                </td>
                <td :style="{color:(createParams.minimumOrders==contrastParams.minimumOrders?'':'red')}">
                  {{contrastParams.minimumOrders}}
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.minimumOrderUnit')}}</td>
                <td>
                  <el-form-item prop="minimumOrderUnit">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="MINIMUM_ORDER_UNIT" v-model="createParams.minimumOrderUnit" :disabled="isFpa"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="MINIMUM_ORDER_UNIT" v-model="oldParams.minimumOrderUnit" disabled></ic-select>
                  <span v-if="createParams.minimumOrderUnit!=oldParams.minimumOrderUnit && oldParams.minimumOrderUnit">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="MINIMUM_ORDER_UNIT" v-model="contrastParams.minimumOrderUnit" disabled></ic-select>
                  <span v-if="createParams.minimumOrderUnit!=contrastParams.minimumOrderUnit && contrastParams.minimumOrderUnit">!</span>
                </td>
              </tr>
              <!-- 价格类型 -->
              <tr>
                <td><span>*</span>{{$t('material.priceType')}}</td>
                <td>
                  <el-form-item prop="priceType">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="PRICE_TYPE" :disabled="isFpa" v-model="createParams.priceType"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="PRICE_TYPE" v-model="oldParams.priceType" disabled></ic-select>
                  <span v-if="createParams.priceType!=oldParams.priceType && oldParams.priceType">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="PRICE_TYPE" v-model="contrastParams.priceType" disabled></ic-select>
                  <span v-if="createParams.priceType!=contrastParams.priceType && contrastParams.priceType">!</span>
                </td>
              </tr>
              <tr v-if="createParams.priceType==5">
                <!-- 价格类型为5的时候显示 留白-->
                <td></td>
                <td>
                  <el-form-item prop="priceTypeText">
                    <el-input v-model.trim="createParams.priceTypeText" clearable maxlength='50'></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.priceTypeText==oldParams.priceTypeText?'':'red')}">
                  {{oldParams.priceTypeText}}
                </td>
                <td :style="{color:(createParams.priceTypeText==contrastParams.priceTypeText?'':'red')}">
                  {{contrastParams.priceTypeText}}
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.disType')}}</td><!-- 配送类型 -->
                <td>
                  <el-form-item prop="disType">
                    <ic-select clearable table="TM_MATERIAL" field="DIS_TYPE" :disabled="isFpa||isDisType" @change="disTypeChange" v-model="createParams.disType"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL" field="DIS_TYPE" v-model="oldParams.disType" disabled></ic-select>
                  <span v-if="createParams.disType!=oldParams.disType && oldParams.disType">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL" field="DIS_TYPE" v-model="contrastParams.disType" disabled></ic-select>
                  <span v-if="createParams.disType!=contrastParams.disType && contrastParams.disType">!</span>
                </td>
              </tr>
              <tr>
                <td><span v-if="createParams.disType == 'DC_SUPPLIER_DC' ||createParams.disType == 'DC' || createParams.disType == 'SUPPLIER_DC'">*</span>DCs</td>
                <td>
                  <el-form-item prop="dcs">
                    <el-select class="multiple_sel" style="width:100%" v-model="dcs" clearable multiple filterable @change="verifyDcs" :disabled="isFpa">
                      <el-option :key="index" v-for="(item,index) in dcList" :label="item.supplierName" :value="item.tmSupplierId"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <el-select class="multiple_sel" style="width:100%" v-model="oldDcs" clearable multiple disabled>
                    <el-option :key="index" v-for="(item,index) in dcList" :label="item.supplierName" :value="item.tmSupplierId"></el-option>
                  </el-select>
                  <span v-if="oldDcsFlag && oldDcs.length>0">!</span>
                </td>
                <td>
                  <el-select class="multiple_sel" style="width:100%" v-model="contrastDcs" clearable multiple disabled>
                    <el-option :key="index" v-for="(item,index) in dcList" :label="item.supplierName" :value="item.tmSupplierId"></el-option>
                  </el-select>
                  <span v-if="contrastDcsFlag && contrastDcs.length>0">!</span>
                </td>
              </tr>
              <!-- 出厂价格 -->
              <tr v-if="!isSup">
                <!-- 供应商看不到出厂价格 -->
                <th class="card-title">{{$t('material.exFactoryPrice')}}</th>
              </tr>
              <!-- 出厂含税单价 -->
              <tr v-if="!isSup">
                <td>{{$t('material.exFactoryUnitPriceIncludingTax')}}</td>
                <td>
                  <el-form-item prop="exFactoryUnitPrice">
                    <el-input :value="createParams.exFactoryUnitPrice | toFixed(6)" type="number" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.exFactoryUnitPrice==oldParams.exFactoryUnitPrice?'':'red')}">
                  {{oldParams.exFactoryUnitPrice}}
                </td>
                <td :style="{color:(createParams.exFactoryUnitPrice==contrastParams.exFactoryUnitPrice?'':'red')}">
                  {{contrastParams.exFactoryUnitPrice}}
                </td>
              </tr>
              <!-- 采购税率-->
              <tr v-if="!isSup">
                <td><span v-if="isPop || isToys || isConventionalMaterials">*</span>{{$t('material.urchaseTaxRate')}}</td>
                <td>
                  <el-form-item prop="urchaseTaxRate" :rules="isPop|| isToys || isConventionalMaterials  ? rules.urchaseTaxRate : [{required: false}]">
                    <el-select v-model="createParams.urchaseTaxRate" @change="computePurchaseTax" placeholder="" :disabled="!(isPop || isToys || isConventionalMaterials || createParams.isLto == 'Y')">
                      <el-option :key="index" v-for="(item,index) in urchaseTaxRateList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" v-model="oldParams.urchaseTaxRate" disabled></ic-select>
                  <span v-if="createParams.urchaseTaxRate!=oldParams.urchaseTaxRate && oldParams.urchaseTaxRate">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="URCHASE_TAX_RATE" v-model="contrastParams.urchaseTaxRate" disabled></ic-select>
                  <span v-if="createParams.urchaseTaxRate!=contrastParams.urchaseTaxRate && contrastParams.urchaseTaxRate">!</span>
                </td>
              </tr>
              <!-- 出厂不含税单价 pop，玩具，非常规 必填；pop，玩具，非常规 可以填-->
              <tr v-if="!isSup">
                <td><span v-if="isPop || isToys || isConventionalMaterials">*</span>{{$t('material.exFactoryExcUnitPrice')}}</td>
                <td>
                  <el-form-item prop="exFactoryExcUnitPrice" :rules="isPop|| isToys || isConventionalMaterials ? rules.exFactoryExcUnitPrice : [{required: false}]">
                    <el-input v-model.trim="createParams.exFactoryExcUnitPrice" onkeyup="this.value= this.value.match(/\d+(\.\d{0,6})?/) ? this.value.match(/\d+(\.\d{0,6})?/)[0] : ''" maxlength="20" :disabled="!(isPop || isToys || isConventionalMaterials)||createParams.isForeignCurrency=='Y'" @blur="computePurchaseTax"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.exFactoryExcUnitPrice==oldParams.exFactoryExcUnitPrice?'':'red')}">
                  {{oldParams.exFactoryExcUnitPrice}}
                </td>
                <td :style="{color:(createParams.exFactoryExcUnitPrice==contrastParams.exFactoryExcUnitPrice?'':'red')}">
                  {{contrastParams.exFactoryExcUnitPrice}}
                </td>
              </tr>
              <!-- 采购税额 -->
              <tr v-if="!isSup">
                <td>{{$t('material.purchaseTax')}}</td>
                <td>
                  <el-form-item prop="purchaseTax">
                    <el-input :value="createParams.purchaseTax | toFixed(6)" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.purchaseTax==oldParams.purchaseTax?'':'red')}">
                  {{oldParams.purchaseTax}}
                </td>
                <td :style="{color:(createParams.purchaseTax==contrastParams.purchaseTax?'':'red')}">
                  {{contrastParams.purchaseTax}}
                </td>
              </tr>
              <!-- 配送类型：供应商直送门店时可见 -->
              <tr v-if="createParams.disType == 'SUPPLIER'">
                <!-- fpaFreight pop，玩具，非常规 且配送类型：供应商直送门店时 必填-->
                <td><span v-if="(isPop|| isToys || isConventionalMaterials)&& createParams.disType == 'SUPPLIER'">*</span>{{$t('material.Freight')}}</td>
                <td>
                  <el-form-item prop="fpaFreight" :rules="(isPop|| isToys || isConventionalMaterials)&& createParams.disType == 'SUPPLIER'? rules.fpaFreight : [{required: false}]">
                    <el-input v-model="createParams.fpaFreight" :disabled="!((isPop|| isToys || isConventionalMaterials)&& createParams.disType == 'SUPPLIER')" @blur="createParams.fpaFreight=onBlur(createParams.fpaFreight,6)" @keyup.native="createParams.fpaFreight=onInput(createParams.fpaFreight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.fpaFreight==oldParams.fpaFreight?'':'red')}">
                  {{oldParams.fpaFreight}}
                </td>
                <td :style="{color:(createParams.fpaFreight==contrastParams.fpaFreight?'':'red')}">
                  {{contrastParams.fpaFreight}}
                </td>
              </tr>
              <!-- 价格有效起始日期-->
              <tr v-if="!isSup">
                <td><span v-if="isPop || isToys || isConventionalMaterials">*</span>{{$t('material.priceEffectiveStartingTime')}}</td>
                <td>
                  <el-form-item prop="priceEffectiveStartingTime" :rules="isPop|| isToys || isConventionalMaterials  ? rules.priceEffectiveStartingTime : [{required: false}]">
                    <el-date-picker value-format="yyyy-MM-dd" :disabled="!(isPop || isToys || isConventionalMaterials)" v-model="createParams.priceEffectiveStartingTime" type="date"></el-date-picker>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.priceEffectiveStartingTime==oldParams.priceEffectiveStartingTime?'':'red')}">
                  {{oldParams.priceEffectiveStartingTime}}
                </td>
                <td :style="{color:(createParams.priceEffectiveStartingTime==contrastParams.priceEffectiveStartingTime?'':'red')}">
                  {{contrastParams.priceEffectiveStartingTime}}
                </td>
              </tr>
              <!-- 需要填写未来出厂价 -->
              <tr v-if="!isSup">
                <td><span>*</span>{{$t('material.futureFactoryRequiredPrice')}}</td>
                <td>
                  <el-form-item prop="futureFactoryRequiredPrice">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" @change="changeFutureFactoryRequiredPrice" v-model="createParams.futureFactoryRequiredPrice"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.futureFactoryRequiredPrice" disabled></ic-select>
                  <span v-if="createParams.futureFactoryRequiredPrice!=oldParams.futureFactoryRequiredPrice && oldParams.futureFactoryRequiredPrice">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.futureFactoryRequiredPrice" disabled></ic-select>
                  <span v-if="createParams.futureFactoryRequiredPrice!=contrastParams.futureFactoryRequiredPrice && contrastParams.futureFactoryRequiredPrice">!</span>
                </td>
              </tr>
              <!-- Future Ex Works Cost/Case (w/o tax) -->
              <tr v-if="!isSup && createParams.futureFactoryRequiredPrice == 'Y'">
                <td>{{$t('material.futureExWorksNotTax')}}</td>
                <td>
                  <el-form-item prop="futureExWorksNotTax">
                    <el-input v-model.trim="createParams.futureExWorksNotTax" @clear="clearfuturePurchaseTaxAmount" clearable :disabled="!(isPop || isToys || isConventionalMaterials)" :value="createParams.futureExWorksNotTax | toFixed(6)" onkeyup="this.value= this.value.match(/\d+(\.\d{0,6})?/) ? this.value.match(/\d+(\.\d{0,6})?/)[0] : ''" maxlength="20" @blur="computeFutureExWorksWithTax"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.futureExWorksNotTax==oldParams.futureExWorksNotTax?'':'red')}">
                  {{oldParams.futureExWorksNotTax}}
                </td>
                <td :style="{color:(createParams.futureExWorksNotTax==contrastParams.futureExWorksNotTax?'':'red')}">
                  {{contrastParams.futureExWorksNotTax}}
                </td>
              </tr>
              <!-- Future Ex Works Cost/Case (with tax) -->
              <tr v-if="!isSup && createParams.futureFactoryRequiredPrice == 'Y'">
                <td>{{$t('material.futureExWorksWithTax')}}</td>
                <td>
                  <el-form-item>
                    <el-input :value="createParams.futureExWorksWithTax | toFixed(6)" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.futureExWorksWithTax==oldParams.futureExWorksWithTax?'':'red')}">
                  {{oldParams.futureExWorksWithTax}}
                </td>
                <td :style="{color:(createParams.futureExWorksWithTax==contrastParams.futureExWorksWithTax?'':'red')}">
                  {{contrastParams.futureExWorksWithTax}}
                </td>
              </tr>
              <!-- FuturePriceEffectiveDate -->
              <tr v-if="!isSup && createParams.futureFactoryRequiredPrice == 'Y'">
                <td>{{$t('material.futurePriceEffectiveDate')}}</td>
                <td>
                  <el-form-item prop="futurePriceEffectiveDate">
                    <el-date-picker value-format="yyyy-MM-dd" :disabled="!(isPop || isToys || isConventionalMaterials)" v-model="createParams.futurePriceEffectiveDate" type="date"></el-date-picker>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.futurePriceEffectiveDate==oldParams.futurePriceEffectiveDate?'':'red')}">
                  {{oldParams.futurePriceEffectiveDate}}
                </td>
                <td :style="{color:(createParams.futurePriceEffectiveDate==contrastParams.futurePriceEffectiveDate?'':'red')}">
                  {{contrastParams.futurePriceEffectiveDate}}
                </td>
              </tr>
              <!-- FuturePurchaseTaxAmount -->
              <tr v-if="!isSup && createParams.futureFactoryRequiredPrice == 'Y'">
                <td>{{$t('material.futurePurchaseTaxAmount')}}</td>
                <td>
                  <el-form-item prop="futurePurchaseTaxAmount">
                    <el-input v-model.trim="createParams.futurePurchaseTaxAmount" @clear="clearfuturePurchaseTaxAmount" clearable :disabled="!(isPop || isToys || isConventionalMaterials)" :value="createParams.futurePurchaseTaxAmount | toFixed(6)" onkeyup="this.value= this.value.match(/\d+(\.\d{0,6})?/) ? this.value.match(/\d+(\.\d{0,6})?/)[0] : ''" maxlength="20" @blur="computeFutureExWorksWithTax"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.futurePurchaseTaxAmount==oldParams.futurePurchaseTaxAmount?'':'red')}">
                  {{oldParams.futurePurchaseTaxAmount}}
                </td>
                <td :style="{color:(createParams.futurePurchaseTaxAmount==contrastParams.futurePurchaseTaxAmount?'':'red')}">
                  {{contrastParams.futurePurchaseTaxAmount}}
                </td>
              </tr>
              <!-- Previous Ex Works Cost/Case -->
              <tr v-if="!isSup &&  createParams.futureFactoryRequiredPrice == 'Y'">
                <td>{{$t('material.previousExWorks')}}</td>
                <td>
                  <el-form-item prop="previousExWorks">
                    <el-input v-model.trim="createParams.previousExWorks" :value="createParams.previousExWorks | toFixed(6)" onkeyup="this.value= this.value.match(/\d+(\.\d{0,6})?/) ? this.value.match(/\d+(\.\d{0,6})?/)[0] : ''" maxlength="20" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.previousExWorks==oldParams.previousExWorks?'':'red')}">
                  {{oldParams.previousExWorks}}
                </td>
                <td :style="{color:(createParams.previousExWorks==contrastParams.previousExWorks?'':'red')}">
                  {{contrastParams.previousExWorks}}
                </td>
              </tr>
              <!-- Toy Service Fee Applicable -->
              <tr v-if="!isSup">
                <td>{{$t('material.ptoyServiceFeeApplicable')}}</td>
                <td>
                  <el-form-item>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" @change="onChange" v-model="createParams.ptoyServiceFeeApplicable" :disabled="isSup"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.ptoyServiceFeeApplicable" disabled></ic-select>
                  <span v-if="createParams.ptoyServiceFeeApplicable!=oldParams.ptoyServiceFeeApplicable && oldParams.ptoyServiceFeeApplicable">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.ptoyServiceFeeApplicable" disabled></ic-select>
                  <span v-if="createParams.ptoyServiceFeeApplicable!=contrastParams.ptoyServiceFeeApplicable && contrastParams.ptoyServiceFeeApplicable">!</span>
                </td>
              </tr>
              <!-- 每件玩具服务费 -->
              <tr v-show="!isSup && createParams.ptoyServiceFeeApplicable=='Y'">
                <td>{{$t('material.serviceChargePerToy')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.serviceChargePerToy" clearable @blur="serviceChargePerToyBlur" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.serviceChargePerToy==oldParams.serviceChargePerToy?'':'red')}">
                  {{oldParams.serviceChargePerToy}}
                </td>
                <td :style="{color:(createParams.serviceChargePerToy==contrastParams.serviceChargePerToy?'':'red')}">
                  {{contrastParams.serviceChargePerToy}}
                </td>
              </tr>
              <!-- 每件玩具服务费税率 -->
              <tr v-show="!isSup && createParams.ptoyServiceFeeApplicable=='Y'">
                <td>{{$t('material.toyServiceFeeTax')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.toyServiceFeeTax2" clearable disabled oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.toyServiceFeeTax==oldParams.toyServiceFeeTax?'':'red')}">
                  {{oldParams.toyServiceFeeTax}}
                </td>
                <td :style="{color:(createParams.toyServiceFeeTax==contrastParams.toyServiceFeeTax?'':'red')}">
                  {{contrastParams.toyServiceFeeTax}}
                </td>
              </tr>
              <!-- 每件玩具服务费（含税） -->
              <tr v-show="!isSup && createParams.ptoyServiceFeeApplicable=='Y'">
                <td>{{$t('material.toyServiceFeeWithTax')}}</td>
                <td>
                  <el-form-item>
                    <el-input :value="createParams.toyServiceFeeWithTax | toFixed(6)" clearable disabled oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.toyServiceFeeWithTax==oldParams.toyServiceFeeWithTax?'':'red')}">
                  {{oldParams.toyServiceFeeWithTax}}
                </td>
                <td :style="{color:(createParams.toyServiceFeeWithTax==contrastParams.toyServiceFeeWithTax?'':'red')}">
                  {{contrastParams.toyServiceFeeWithTax}}
                </td>
              </tr>
              <!-- 玩具服务商 -->
              <tr v-if="isToyVendor">
                <td>玩具服务商</td>
                <td>
                  <el-form-item>
                    <ic-select clearable v-model="createParams.toyVendor" table="TM_MATERIAL_RECORD" field="TOY_VENDOR"></ic-select>
                  </el-form-item>
                </td>
              </tr>
              <!-- Outbound运费 -->
              <tr v-if="!isSup">
                <td>{{$t('material.outboundFreight')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.outboundFreight" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.outboundFreight==oldParams.outboundFreight?'':'red')}">
                  {{oldParams.outboundFreight}}
                </td>
                <td :style="{color:(createParams.outboundFreight==contrastParams.outboundFreight?'':'red')}">
                  {{contrastParams.outboundFreight}}
                </td>
              </tr>
              <tr v-if="!isSup&&isHappyMealSet">
                <th class="card-title">外币金额</th>
              </tr>
              <tr v-if="!isSup&&isHappyMealSet">
                <td><span>*</span>是否需要外币结算</td>
                <td>
                  <el-form-item prop="isForeignCurrency" :rules="isHappyMealSet? rules.isForeignCurrency : [{required: false}]">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_FOREIGN_CURRENCY" @change="isForeignCurrencyChange" v-model="createParams.isForeignCurrency" :disabled="!isHappyMealSet"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_FOREIGN_CURRENCY" v-model="oldParams.isForeignCurrency" disabled></ic-select>
                  <span v-if="createParams.isForeignCurrency !=oldParams.isForeignCurrency  && oldParams.isForeignCurrency ">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_FOREIGN_CURRENCY" v-model="contrastParams.isForeignCurrency" disabled></ic-select>
                  <span v-if="createParams.isForeignCurrency !=contrastParams.isForeignCurrency  && contrastParams.isForeignCurrency ">!</span>
                </td>
              </tr>
              <tr v-if="!isSup&&isHappyMealSet">
                <td><span v-if="createParams.isForeignCurrency=='Y'">*</span>外币币种</td>
                <td>
                  <el-form-item ref="foreignCurrencyCode_rule" prop="foreignCurrencyCode" :rules="isHappyMealSet&&createParams.isForeignCurrency=='Y' ? rules.foreignCurrencyCode : [{required: false}]">
                    <ic-select clearable table="BASE" field="CURRENCY_CODE" @change="foreignCurrencyCodeChange(createParams.foreignCurrencyCode)" v-model="createParams.foreignCurrencyCode" :disabled="!isHappyMealSet||createParams.isForeignCurrency!=='Y'"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_FOREIGN_CURRENCY" v-model="oldParams.foreignCurrencyCode " disabled></ic-select>
                  <span v-if="createParams.foreignCurrencyCode !=oldParams.foreignCurrencyCode  && oldParams.foreignCurrencyCode ">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_FOREIGN_CURRENCY" v-model="contrastParams.foreignCurrencyCode " disabled></ic-select>
                  <span v-if="createParams.foreignCurrencyCode !=contrastParams.foreignCurrencyCode  && contrastParams.foreignCurrencyCode ">!</span>
                </td>
              </tr>
              <tr v-if="!isSup&&isHappyMealSet">
                <td><span v-if="createParams.isForeignCurrency=='Y'">*</span>汇率</td>
                <td>
                  <el-form-item prop="exchangeRate" :rules="isHappyMealSet&&createParams.isForeignCurrency=='Y' ? rules.exchangeRate : [{required: false}]">
                    <el-input v-model="createParams.exchangeRate" @blur="exchangeRateBlur(createParams.exchangeRate,createParams.foreignCurrencyAmount)" clearable onkeyup="this.value=this.value.match(/\d+\.?\d{0,4}/);" :disabled="!isHappyMealSet||createParams.isForeignCurrency!=='Y'"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.exchangeRate==oldParams.exchangeRate?'':'red')}">
                  {{oldParams.exchangeRate}}
                </td>
                <td :style="{color:(createParams.exchangeRate==contrastParams.exchangeRate?'':'red')}">
                  {{contrastParams.exchangeRate}}
                </td>
              </tr>
              <tr v-if="!isSup&&isHappyMealSet">
                <td>外币金额</td>
                <td>
                  <el-form-item :rules="isHappyMealSet&&createParams.isForeignCurrency=='Y' ? rules.foreignCurrencyAmount : [{required: false}]">
                    <el-input v-model="createParams.foreignCurrencyAmount" @blur="foreignCurrencyAmountBlur(createParams.exchangeRate,createParams.foreignCurrencyAmount)" onkeyup="this.value=this.value.match(/\d+\.?\d{0,6}/);" maxlength="20" :disabled="!isHappyMealSet||createParams.isForeignCurrency!=='Y'" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.foreignCurrencyAmount==oldParams.foreignCurrencyAmount?'':'red')}">
                  {{oldParams.foreignCurrencyAmount  }}
                </td>
                <td :style="{color:(createParams.foreignCurrencyAmount==contrastParams.foreignCurrencyAmount?'':'red')}">
                  {{contrastParams.foreignCurrencyAmount  }}
                </td>
              </tr>
            </table>
          </el-tab-pane>
          <el-tab-pane :label="$t('material.qualityInformation')">
            <table style="padding-top: 15px;">
              <tr style="height: 35px">
                <th colspan="2">{{$t('material.nowVersion')}}</th>
                <th v-if="oldRecordExists">{{$t('material.LastVersion')}}</th>
                <th>{{$t('material.contrast')}}</th>
              </tr>
              <tr>
                <th class="card-title">{{$t('material.basicInformation')}}</th>
              </tr>
              <!-- 结算单位名称/工厂名称 -->
              <tr>
                <td>{{$t('material.settlementUnitName')}}</td>
                <td><el-input v-model="createParams.settlementUnitName" disabled></el-input></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>{{$t('material.tmPlantName')}}</td>
                <td><el-input v-model="createParams.tmPlantName" disabled></el-input></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 230px;"><span>*</span>{{$t('material.chineseNameOfProduct')}}</td>
                <td style="width: 230px;">
                  <el-form-item prop="eightBitCodeName">
                    <el-input v-model="createParams.eightBitCodeName" clearable disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.eightBitCodeName==oldParams.eightBitCodeName?'':'red')}" style="width: 230px;">
                  {{oldParams.eightBitCodeName}}
                </td>
                <td :style="{color:(createParams.eightBitCodeName==contrastParams.eightBitCodeName?'':'red')}" style="width: 230px;">
                  {{contrastParams.eightBitCodeName}}
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.englishNameOfProduct')}}</td>
                <td>
                  <el-form-item prop="rawProductEName">
                    <el-input v-model="createParams.rawProductEName" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.rawProductEName==oldParams.rawProductEName?'':'red')}">
                  {{oldParams.rawProductEName}}
                </td>
                <td :style="{color:(createParams.rawProductEName==contrastParams.rawProductEName?'':'red')}">
                  {{contrastParams.rawProductEName}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 产品英文简称 -->
                <td>{{$t('material.englishAbbreviationOfProduct')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model="createParams.rawProductEAbbreviation" clearable disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.rawProductEAbbreviation==oldParams.rawProductEAbbreviation?'':'red')}">
                  {{oldParams.rawProductEAbbreviation}}
                </td>
                <td :style="{color:(createParams.rawProductEAbbreviation==contrastParams.rawProductEAbbreviation?'':'red')}">
                  {{contrastParams.rawProductEAbbreviation}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- WRIN编码 -->
                <td><span v-show="createParams.isWrin">*</span>{{$t('material.wrinCode')}}</td>
                <td>
                  <el-form-item prop="wrinCode">
                    <el-input v-model.trim="createParams.wrinCode" @blur="wrinInput(createParams.wrinCode)" clearable maxlength="9"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.wrinCode==oldParams.wrinCode?'':'red')}">
                  {{oldParams.wrinCode}}
                </td>
                <td :style="{color:(createParams.wrinCode==contrastParams.wrinCode?'':'red')}">
                  {{contrastParams.wrinCode}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 是否可追溯 -->
                <td><span>*</span>{{$t('material.isTraceable')}}</td>
                <td>
                  <el-form-item prop="isTraceable">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isTraceable"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isTraceable" disabled></ic-select>
                  <span v-if="createParams.isTraceable!=oldParams.isTraceable && oldParams.isTraceable">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isTraceable" disabled></ic-select>
                  <span v-if="createParams.isTraceable!=contrastParams.isTraceable && contrastParams.isTraceable">!</span>
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 是否进入Catellae系统 -->
                <td><span>*</span>{{$t('material.enterCatellaeSystem')}}</td>
                <td>
                  <el-form-item prop="enterCatellaeSystem">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.enterCatellaeSystem"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.enterCatellaeSystem" disabled></ic-select>
                  <span v-if="createParams.enterCatellaeSystem!=oldParams.enterCatellaeSystem && oldParams.enterCatellaeSystem">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.enterCatellaeSystem" disabled></ic-select>
                  <span v-if="createParams.enterCatellaeSystem!=contrastParams.enterCatellaeSystem && contrastParams.enterCatellaeSystem">!</span>
                </td>
              </tr>
              <!-- 多保质期标识 -->
              <tr v-if="!isPop&&emplFlag!=='S'">
                <td>{{$t('material.HasMultiShelfLife')}}</td>
                <td>
                  <el-form-item prop="hasMultiShelfLife">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.hasMultiShelfLife"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.hasMultiShelfLife" disabled></ic-select>
                  <span v-if="createParams.hasMultiShelfLife!=oldParams.hasMultiShelfLife && oldParams.hasMultiShelfLife">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.hasMultiShelfLife" disabled></ic-select>
                  <span v-if="createParams.hasMultiShelfLife!=contrastParams.hasMultiShelfLife && contrastParams.hasMultiShelfLife">!</span>
                </td>
              </tr>
              <tr>
                <th class="card-title">{{$t('material.productDetails')}}</th>
              </tr>
              <tr>
                <td style="width: 250px;"><span>*</span>{{$t('material.temperature')}}</td>
                <td style="width: 250px;">
                  <el-form-item prop="temperature">
                    <!-- 储存环境 -->
                    <ic-select clearable table="COMMON" field="TEMPERATURE" v-model="createParams.temperature"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="COMMON" field="TEMPERATURE" v-model="oldParams.temperature" disabled></ic-select>
                  <span v-if="createParams.temperature!=oldParams.temperature && oldParams.temperature">!</span>
                </td>
                <td>
                  <ic-select clearable table="COMMON" field="TEMPERATURE" v-model="contrastParams.temperature" disabled></ic-select>
                  <span v-if="createParams.temperature!=contrastParams.temperature && contrastParams.temperature">!</span>
                </td>
              </tr>
              <template v-if="!isPop">
                <tr>
                  <!-- 第二保质期 -->
                  <td>{{$t('material.secondShelfLife')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.secondShelfLife" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.secondShelfLife==oldParams.secondShelfLife?'':'red')}">
                    {{oldParams.secondShelfLife}}
                  </td>
                  <td :style="{color:(createParams.secondShelfLife==contrastParams.secondShelfLife?'':'red')}">
                    {{contrastParams.secondShelfLife}}
                  </td>
                </tr>
                <tr>
                  <!-- 第二保质期单位 -->
                  <td>{{$t('material.secondShelfLifeUnit')}}</td>
                  <td>
                    <el-form-item>
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="SHELF_LIFE_UOM" v-model="createParams.secondShelfLifeUnit"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SHELF_LIFE_UOM" v-model="oldParams.secondShelfLifeUnit" disabled></ic-select>
                    <span v-if="createParams.secondShelfLifeUnit!=oldParams.secondShelfLifeUnit && oldParams.secondShelfLifeUnit">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SHELF_LIFE_UOM" v-model="contrastParams.secondShelfLifeUnit" disabled></ic-select>
                    <span v-if="createParams.secondShelfLifeUnit!=contrastParams.secondShelfLifeUnit && contrastParams.secondShelfLifeUnit">!</span>
                  </td>
                </tr>
                <tr>
                  <!-- 第一保质期（天） -->
                  <td><span>*</span>{{$t('material.firstShelfLife')}}</td>
                  <td>
                    <el-form-item prop="firstShelfLife">
                      <el-input v-model.trim="createParams.firstShelfLife" @blur="computMinimumDcReceivingValidity" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.firstShelfLife==oldParams.firstShelfLife?'':'red')}">
                    {{oldParams.firstShelfLife}}
                  </td>
                  <td :style="{color:(createParams.firstShelfLife==contrastParams.firstShelfLife?'':'red')}">
                    {{contrastParams.firstShelfLife}}
                  </td>
                </tr>
                <tr>
                  <!-- 解冻后保质期 -->
                  <td>{{$t('material.shelfLifeAfterThawing')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.shelfLifeAfterThawing" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.shelfLifeAfterThawing==oldParams.shelfLifeAfterThawing?'':'red')}">
                    {{oldParams.shelfLifeAfterThawing}}
                  </td>
                  <td :style="{color:(createParams.shelfLifeAfterThawing==contrastParams.shelfLifeAfterThawing?'':'red')}">
                    {{contrastParams.shelfLifeAfterThawing}}
                  </td>
                </tr>
                <tr>
                  <!-- 解冻后保质期单位 -->
                  <td>{{$t('material.shelfLifeUnitAfterThawing')}}</td>
                  <td>
                    <el-form-item>
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="SHELF_LIFE_UOM" v-model="createParams.shelfLifeUnitAfterThawing"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SHELF_LIFE_UOM" v-model="oldParams.shelfLifeUnitAfterThawing" disabled></ic-select>
                    <span v-if="createParams.shelfLifeUnitAfterThawing!=oldParams.shelfLifeUnitAfterThawing && oldParams.shelfLifeUnitAfterThawing">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="SHELF_LIFE_UOM" v-model="contrastParams.shelfLifeUnitAfterThawing" disabled></ic-select>
                    <span v-if="createParams.shelfLifeUnitAfterThawing!=contrastParams.shelfLifeUnitAfterThawing && contrastParams.shelfLifeUnitAfterThawing">!</span>
                  </td>
                </tr>
                <tr>
                  <!-- 解冻时间（小时） -->
                  <td>{{$t('material.thawingTime')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.thawingTime" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.thawingTime==oldParams.thawingTime?'':'red')}">
                    {{oldParams.thawingTime}}
                  </td>
                  <td :style="{color:(createParams.thawingTime==contrastParams.thawingTime?'':'red')}">
                    {{contrastParams.thawingTime}}
                  </td>
                </tr>
                <tr>
                  <!-- 配方1 -->
                  <td>{{$t('material.formula1')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.formula1" maxlength="200" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.formula1==oldParams.formula1?'':'red')}">
                    {{oldParams.formula1}}
                  </td>
                  <td :style="{color:(createParams.formula1==contrastParams.formula1?'':'red')}">
                    {{contrastParams.formula1}}
                  </td>
                </tr>
                <tr>
                  <!-- 配方2 -->
                  <td>{{$t('material.formula2')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.formula2" maxlength="100" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.formula2==oldParams.formula2?'':'red')}">
                    {{oldParams.formula2}}
                  </td>
                  <td :style="{color:(createParams.formula2==contrastParams.formula2?'':'red')}">
                    {{contrastParams.formula2}}
                  </td>
                </tr>
                <tr>
                  <!-- 配方3 -->
                  <td>{{$t('material.formula3')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.formula3" maxlength="100" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.formula3==oldParams.formula3?'':'red')}">
                    {{oldParams.formula3}}
                  </td>
                  <td :style="{color:(createParams.formula3==contrastParams.formula3?'':'red')}">
                    {{contrastParams.formula3}}
                  </td>
                </tr>
                <tr>
                  <!-- 配方4 -->
                  <td>{{$t('material.formula4')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.formula4" maxlength="100" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.formula4==oldParams.formula4?'':'red')}">
                    {{oldParams.formula4}}
                  </td>
                  <td :style="{color:(createParams.formula4==contrastParams.formula4?'':'red')}">
                    {{contrastParams.formula4}}
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 是否需要解冻 -->
                  <td>{{$t('material.isNeedThaw')}}</td>
                  <td>
                    <el-form-item>
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isNeedThaw"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isNeedThaw" disabled></ic-select>
                    <span v-if="createParams.isNeedThaw!=oldParams.isNeedThaw && oldParams.isNeedThaw">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isNeedThaw" disabled></ic-select>
                    <span v-if="createParams.isNeedThaw!=contrastParams.isNeedThaw && contrastParams.isNeedThaw">!</span>
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 是否需要准备时间 -->
                  <td>{{$t('material.isNeedPreparationTime')}}</td>
                  <td>
                    <el-form-item>
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isNeedPreparationTime"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isNeedPreparationTime" disabled></ic-select>
                    <span v-if="createParams.isNeedPreparationTime!=oldParams.isNeedPreparationTime && oldParams.isNeedPreparationTime">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isNeedPreparationTime" disabled></ic-select>
                    <span v-if="createParams.isNeedPreparationTime!=contrastParams.isNeedPreparationTime && contrastParams.isNeedPreparationTime">!</span>
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 是否有害 -->
                  <td>{{$t('material.isHarmful')}}</td>
                  <td>
                    <el-form-item>
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isHarmful"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isHarmful" disabled></ic-select>
                    <span v-if="createParams.isHarmful!=oldParams.isHarmful && oldParams.isHarmful">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isHarmful" disabled></ic-select>
                    <span v-if="createParams.isHarmful!=contrastParams.isHarmful && contrastParams.isHarmful">!</span>
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 味道 -->
                  <td>{{$t('material.taste')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.taste" maxlength="200" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.taste==oldParams.taste?'':'red')}">
                    {{oldParams.taste}}
                  </td>
                  <td :style="{color:(createParams.taste==contrastParams.taste?'':'red')}">
                    {{contrastParams.taste}}
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 形状 -->
                  <td>{{$t('material.shape')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.shape" maxlength="40" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.shape==oldParams.shape?'':'red')}">
                    {{oldParams.shape}}
                  </td>
                  <td :style="{color:(createParams.shape==contrastParams.shape?'':'red')}">
                    {{contrastParams.shape}}
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 颜色 -->
                  <td>{{$t('material.color')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.color" maxlength="100" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.color==oldParams.color?'':'red')}">
                    {{oldParams.color}}
                  </td>
                  <td :style="{color:(createParams.color==contrastParams.color?'':'red')}">
                    {{contrastParams.color}}
                  </td>
                </tr>
                <tr>
                  <!-- 有效期检查 -->
                  <td><span>*</span>{{$t('material.validityDate')}}</td>
                  <td>
                    <el-form-item prop="validityDate">
                      <ic-select clearable table="TM_MATERIAL_RECORD" field="VALIDITY_DATE" v-model="createParams.validityDate"></ic-select>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="VALIDITY_DATE" v-model="oldParams.validityDate" disabled></ic-select>
                    <span v-if="createParams.validityDate!=oldParams.validityDate && oldParams.validityDate">!</span>
                  </td>
                  <td>
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="VALIDITY_DATE" v-model="contrastParams.validityDate" disabled></ic-select>
                    <span v-if="createParams.validityDate!=contrastParams.validityDate && contrastParams.validityDate">!</span>
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 在线第二保质期 -->
                  <td>{{$t('material.onlineSecondShelfLife')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.onlineSecondShelfLife" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.onlineSecondShelfLife==oldParams.onlineSecondShelfLife?'':'red')}">
                    {{oldParams.onlineSecondShelfLife}}
                  </td>
                  <td :style="{color:(createParams.onlineSecondShelfLife==contrastParams.onlineSecondShelfLife?'':'red')}">
                    {{contrastParams.onlineSecondShelfLife}}
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 准备方法 -->
                  <td>{{$t('material.preparationMethod')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.preparationMethod" maxlength="200" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.preparationMethod==oldParams.preparationMethod?'':'red')}">
                    {{oldParams.preparationMethod}}
                  </td>
                  <td :style="{color:(createParams.preparationMethod==contrastParams.preparationMethod?'':'red')}">
                    {{contrastParams.preparationMethod}}
                  </td>
                </tr>
                <tr v-if="!isPop">
                  <!-- 准备时间（小时） -->
                  <td>{{$t('material.preparationTime')}}</td>
                  <td>
                    <el-form-item>
                      <el-input v-model.trim="createParams.preparationTime" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="oldRecordExists" :style="{color:(createParams.preparationTime==oldParams.preparationTime?'':'red')}">
                    {{oldParams.preparationTime}}
                  </td>
                  <td :style="{color:(createParams.preparationTime==contrastParams.preparationTime?'':'red')}">
                    {{contrastParams.preparationTime}}
                  </td>
                </tr>

              </template>
              <tr>
                <!-- 最低保存温度 -->
                <td><span>*</span>{{$t('material.minimumStorageTemperature')}}</td>
                <td>
                  <el-form-item prop="minimumStorageTemperature">
                    <el-input v-model.trim="createParams.minimumStorageTemperature" maxLength='10'></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.minimumStorageTemperature==oldParams.minimumStorageTemperature?'':'red')}">
                  {{oldParams.minimumStorageTemperature}}
                </td>
                <td :style="{color:(createParams.minimumStorageTemperature==contrastParams.minimumStorageTemperature?'':'red')}">
                  {{contrastParams.minimumStorageTemperature}}
                </td>
              </tr>
              <tr>
                <!-- 最高保存温度 -->
                <td><span>*</span>{{$t('material.maximumStorageTemperature')}}</td>
                <td>
                  <el-form-item prop="maximumStorageTemperature">
                    <el-input v-model.trim="createParams.maximumStorageTemperature" maxLength='10'></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.maximumStorageTemperature==oldParams.maximumStorageTemperature?'':'red')}">
                  {{oldParams.maximumStorageTemperature}}
                </td>
                <td :style="{color:(createParams.maximumStorageTemperature==contrastParams.maximumStorageTemperature?'':'red')}">
                  {{contrastParams.maximumStorageTemperature}}
                </td>
              </tr>
              <tr>
                <th class="card-title">{{$t('material.yieldInformation')}}</th>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.mcdBuyingUnit')}}</td>
                <td>
                  <el-form-item prop="mcdBuyingUnit">
                    <!-- 麦当劳购买单位 -->
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="createParams.mcdBuyingUnit"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="oldParams.mcdBuyingUnit" disabled></ic-select>
                  <span v-if="createParams.mcdBuyingUnit!=oldParams.mcdBuyingUnit && oldParams.mcdBuyingUnit">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="contrastParams.mcdBuyingUnit" disabled></ic-select>
                  <span v-if="createParams.mcdBuyingUnit!=contrastParams.mcdBuyingUnit && contrastParams.mcdBuyingUnit">!</span>
                </td>
              </tr>
              <tr>
                <td>{{$t('material.uom')}}</td>
                <td>
                  <el-form-item prop="uom">
                    <!--UOM-->
                    <ic-select v-model="createParams.uom" table="TM_FIVE_BIT_CODE" field="UOM" disabled clearable></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_FIVE_BIT_CODE" field="UOM" v-model="oldParams.uom" disabled></ic-select>
                  <span v-if="createParams.uom!=oldParams.uom && oldParams.uom">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_FIVE_BIT_CODE" field="UOM" v-model="contrastParams.uom" disabled></ic-select>
                  <span v-if="createParams.uom!=contrastParams.uom && contrastParams.uom">!</span>
                </td>
              </tr>
              <tr>
                <td>{{$t('material.standardCopiesUom')}}</td>
                <td>
                  <el-form-item prop="standardCopiesUom">
                    <!--UOM标准生产份数-->
                    <el-input v-model="createParams.standardCopiesUom" :value="createParams.standardCopiesUom | toFixed(2)" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.standardCopiesUom==oldParams.standardCopiesUom?'':'red')}">
                  {{oldParams.standardCopiesUom}}
                </td>
                <td :style="{color:(createParams.standardCopiesUom==contrastParams.standardCopiesUom?'':'red')}">
                  {{contrastParams.standardCopiesUom}}
                </td>
              </tr>

              <tr v-if="!isPop">
                <td><span>*</span>{{$t('material.quantityUomInnerNum')}}</td>
                <td>
                  <el-form-item prop="quantityUomInnerNum">
                    <!--内包装内含UOM数量-->
                    <el-input v-model.trim="createParams.quantityUomInnerNum" @blur="computeQuantityUomOutsourceNum" @clear='clearQuantityUomInnerNum' clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.quantityUomInnerNum==oldParams.quantityUomInnerNum?'':'red')}">
                  {{oldParams.quantityUomInnerNum}}
                </td>
                <td :style="{color:(createParams.quantityUomInnerNum==contrastParams.quantityUomInnerNum?'':'red')}">
                  {{contrastParams.quantityUomInnerNum}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td><span>*</span>{{$t('material.quantityUomOutsourceNum')}}</td>
                <td>
                  <el-form-item prop="quantityUomOutsourceNum">
                    <!--外包装内含UOM数量-->
                    <el-input v-model.trim="createParams.quantityUomOutsourceNum" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.quantityUomOutsourceNum==oldParams.quantityUomOutsourceNum?'':'red')}">
                  {{oldParams.quantityUomOutsourceNum}}
                </td>
                <td :style="{color:(createParams.quantityUomOutsourceNum==contrastParams.quantityUomOutsourceNum?'':'red')}">
                  {{contrastParams.quantityUomOutsourceNum}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td>{{$t('material.quantityInnerGoodsNum')}}</td>
                <td>
                  <el-form-item>
                    <!--内包装物品数量-->
                    <el-input v-model.trim="createParams.quantityInnerGoodsNum" disabled oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.quantityInnerGoodsNum==oldParams.quantityInnerGoodsNum?'':'red')}">
                  {{oldParams.quantityInnerGoodsNum}}
                </td>
                <td :style="{color:(createParams.quantityInnerGoodsNum==contrastParams.quantityInnerGoodsNum?'':'red')}">
                  {{contrastParams.quantityInnerGoodsNum}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td><span>*</span>{{$t('material.outerPackageContainsNum')}}</td>
                <td>
                  <el-form-item prop="outerPackageContainsNum">
                    <!--外包装内含内包装数量-->
                    <el-input v-model.trim="createParams.outerPackageContainsNum" @blur="computeQuantityUomOutsourceNum" @clear='clearQuantityUomInnerNum' clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.outerPackageContainsNum==oldParams.outerPackageContainsNum?'':'red')}">
                  {{oldParams.outerPackageContainsNum}}
                </td>
                <td :style="{color:(createParams.outerPackageContainsNum==contrastParams.outerPackageContainsNum?'':'red')}">
                  {{contrastParams.outerPackageContainsNum}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td>{{$t('material.stackingHeightInsidePackage')}}</td>
                <td>
                  <el-form-item>
                    <!--外包装内堆积高度-->
                    <el-input v-model.trim="createParams.stackingHeightInsidePackage" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.stackingHeightInsidePackage==oldParams.stackingHeightInsidePackage?'':'red')}">
                  {{oldParams.stackingHeightInsidePackage}}
                </td>
                <td :style="{color:(createParams.stackingHeightInsidePackage==contrastParams.stackingHeightInsidePackage?'':'red')}">
                  {{contrastParams.stackingHeightInsidePackage}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td>{{$t('material.quantityInnerPackingNum')}}</td>
                <td>
                  <el-form-item>
                    <!--内包装数量-->
                    <el-input v-model.trim="createParams.quantityInnerPackingNum" disabled oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.quantityInnerPackingNum==oldParams.quantityInnerPackingNum?'':'red')}">
                  {{oldParams.quantityInnerPackingNum}}
                </td>
                <td :style="{color:(createParams.quantityInnerPackingNum==contrastParams.quantityInnerPackingNum?'':'red')}">
                  {{contrastParams.quantityInnerPackingNum}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td>{{$t('material.yield')}}</td>
                <!-- 应产率 -->
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.yield" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.yield==oldParams.yield?'':'red')}">
                  {{oldParams.yield}}
                </td>
                <td :style="{color:(createParams.yield==contrastParams.yield?'':'red')}">
                  {{contrastParams.yield}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td>{{$t('material.preferentialYield')}}</td>
                <!-- 偏好应产率 -->
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.preferentialYield" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')" @blur="blurPreferentialYield($event)" @clear='clearPreferentialYield'></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.preferentialYield==oldParams.preferentialYield?'':'red')}">
                  {{oldParams.preferentialYield}}
                </td>
                <td :style="{color:(createParams.preferentialYield==contrastParams.preferentialYield?'':'red')}">
                  {{contrastParams.preferentialYield}}
                </td>
              </tr>
              <tr>
                <th class="card-title">{{$t('material.storageInformation')}}</th>
              </tr>
              <tr>
                <!-- DC库存管理单位 -->
                <td><span>*</span>{{$t('material.dcManagementUnit')}}</td>
                <td>
                  <el-form-item prop="dcManagementUnit">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="createParams.dcManagementUnit"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="oldParams.dcManagementUnit" disabled></ic-select>
                  <span v-if="createParams.dcManagementUnit!=oldParams.dcManagementUnit && oldParams.dcManagementUnit">!</span>
                </td>
                <td>
                  <ic-select clearable table=" TM_MATERIAL_RECORD" field="MCD_BUYING_UNIT" v-model="contrastParams.dcManagementUnit" disabled></ic-select>
                  <span v-if="createParams.dcManagementUnit!=contrastParams.dcManagementUnit && contrastParams.dcManagementUnit">!</span>
                </td>
              </tr>
              <tr>
                <th class="card-title">{{$t('material.packagingInformation')}}</th>
              </tr>
              <tr>
                <!-- 是否有内包装 -->
                <td><span>*</span>{{$t('material.isInnerPacking')}}</td>
                <td>
                  <el-form-item prop="isInnerPacking">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" @change="changeIsInnerPacking" v-model="createParams.isInnerPacking"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isInnerPacking" disabled></ic-select>
                  <span v-if="createParams.isInnerPacking!=oldParams.isInnerPacking && oldParams.isInnerPacking">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isInnerPacking" disabled></ic-select>
                  <span v-if="createParams.isInnerPacking!=contrastParams.isInnerPacking && contrastParams.isInnerPacking">!</span>
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'N' && !isPop">
                <!-- 产品长度(cm) -->
                <td>{{$t('material.productLength')}}</td>
                <td>
                  <el-form-item :key="productLength" prop="productLength">
                    <el-input v-model.trim="createParams.productLength" @blur="createParams.productLength=onBlur(createParams.productLength,2)" @keyup.native="createParams.productLength=onInput(createParams.productLength)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.productLength==oldParams.productLength?'':'red')}">
                  {{oldParams.productLength}}
                </td>
                <td :style="{color:(createParams.productLength==contrastParams.productLength?'':'red')}">
                  {{contrastParams.productLength}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'N' && !isPop">
                <td>{{$t('material.productWidth')}}</td>
                <td>
                  <el-form-item prop="productWidth">
                    <el-input v-model.trim="createParams.productWidth" @blur="createParams.productWidth=onBlur(createParams.productWidth,2)" @keyup.native="createParams.productWidth=onInput(createParams.productWidth)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.productWidth==oldParams.productWidth?'':'red')}">
                  {{oldParams.productWidth}}
                </td>
                <td :style="{color:(createParams.productWidth==contrastParams.productWidth?'':'red')}">
                  {{contrastParams.productWidth}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'N' && !isPop">
                <td>{{$t('material.productHeight')}}</td>
                <td>
                  <el-form-item prop="productHeight">
                    <el-input v-model.trim="createParams.productHeight" @blur="createParams.productHeight=onBlur(createParams.productHeight,2)" @keyup.native="createParams.productHeight=onInput(createParams.productHeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.productHeight==oldParams.productHeight?'':'red')}">
                  {{oldParams.productHeight}}
                </td>
                <td :style="{color:(createParams.productHeight==contrastParams.productHeight?'':'red')}">
                  {{contrastParams.productHeight}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'N'">
                <td>{{$t('material.productWeight')}}</td>
                <td>
                  <!-- 产品净重(kg) -->
                  <el-form-item prop="productWeight">
                    <el-input v-model.trim="createParams.productWeight" @blur="createParams.productWeight=onBlur(createParams.productWeight,6)" @keyup.native="createParams.productWeight=onInput2(createParams.productWeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.productWeight==oldParams.productWeight?'':'red')}">
                  {{oldParams.productWeight}}
                </td>
                <td :style="{color:(createParams.productWeight==contrastParams.productWeight?'':'red')}">
                  {{contrastParams.productWeight}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'N' && !isPop">
                <!-- 产品毛重 -->
                <td>{{$t('material.productGrossWeight')}}</td>
                <td>
                  <el-form-item prop="productGrossWeight">
                    <el-input v-model.trim="createParams.productGrossWeight" @blur="createParams.productGrossWeight=onBlur(createParams.productGrossWeight,3)" @keyup.native="createParams.productGrossWeight=onInput2(createParams.productGrossWeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.productGrossWeight==oldParams.productGrossWeight?'':'red')}">
                  {{oldParams.productGrossWeight}}
                </td>
                <td :style="{color:(createParams.productGrossWeight==contrastParams.productGrossWeight?'':'red')}">
                  {{contrastParams.productGrossWeight}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'Y' && !isPop">
                <!-- 产品内包装类型 -->
                <td><span v-if="isFieldRequired('innerPackingType')">*</span>{{$t('material.innerPackingType')}}</td>
                <td>
                  <el-form-item :key="innerPackingType" prop="innerPackingType" :rules="isFieldRequired('innerPackingType')?[rules.requiredRules]:[]">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="INNER_PACKING_TYPE" v-model="createParams.innerPackingType"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="INNER_PACKING_TYPE" v-model="oldParams.innerPackingType" disabled></ic-select>
                  <span v-if="createParams.innerPackingType!=oldParams.innerPackingType && oldParams.innerPackingType">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="INNER_PACKING_TYPE" v-model="contrastParams.innerPackingType" disabled></ic-select>
                  <span v-if="createParams.innerPackingType!=contrastParams.innerPackingType && contrastParams.innerPackingType">!</span>
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'Y' && !isPop">
                <!-- 产品内包装长度(cm) -->
                <td>{{$t('material.innerPackageLength')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.innerPackageLength" @blur="createParams.innerPackageLength=onBlur(createParams.innerPackageLength,2)" @keyup.native="createParams.innerPackageLength=onInput(createParams.innerPackageLength)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.innerPackageLength==oldParams.innerPackageLength?'':'red')}">
                  {{oldParams.innerPackageLength}}
                </td>
                <td :style="{color:(createParams.innerPackageLength==contrastParams.innerPackageLength?'':'red')}">
                  {{contrastParams.innerPackageLength}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'Y' && !isPop">
                <!-- 产品内包装宽度 -->
                <td>{{$t('material.innerPackingWidth')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.innerPackingWidth" @blur="createParams.innerPackingWidth=onBlur(createParams.innerPackingWidth,2)" @keyup.native="createParams.innerPackingWidth=onInput(createParams.innerPackingWidth)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.innerPackingWidth==oldParams.innerPackingWidth?'':'red')}">
                  {{oldParams.innerPackingWidth}}
                </td>
                <td :style="{color:(createParams.innerPackingWidth==contrastParams.innerPackingWidth?'':'red')}">
                  {{contrastParams.innerPackingWidth}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'Y' && !isPop">
                <!-- 产品内包装高度(cm) -->
                <td>{{$t('material.innerPackingHeight')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.innerPackingHeight" @blur="createParams.innerPackingHeight=onBlur(createParams.innerPackingHeight,2)" @keyup.native="createParams.innerPackingHeight=onInput(createParams.innerPackingHeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.innerPackingHeight==oldParams.innerPackingHeight?'':'red')}">
                  {{oldParams.innerPackingHeight}}
                </td>
                <td :style="{color:(createParams.innerPackingHeight==contrastParams.innerPackingHeight?'':'red')}">
                  {{contrastParams.innerPackingHeight}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'Y' && !isPop">
                <!-- 产品内包装净重(kg) -->
                <td>{{$t('material.innerPackingWeight')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.innerPackingWeight" @blur="createParams.innerPackingWeight=onBlur(createParams.innerPackingWeight,3)" @keyup.native="createParams.innerPackingWeight=onInput2(createParams.innerPackingWeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.innerPackingWeight==oldParams.innerPackingWeight?'':'red')}">
                  {{oldParams.innerPackingWeight}}
                </td>
                <td :style="{color:(createParams.innerPackingWeight==contrastParams.innerPackingWeight?'':'red')}">
                  {{contrastParams.innerPackingWeight}}
                </td>
              </tr>

              <tr v-if="createParams.isInnerPacking == 'Y' && !isPop">
                <!-- 产品内包装毛重(kg) -->
                <td>{{$t('material.innerPackingGrossWeight')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.innerPackingGrossWeight" @blur="createParams.innerPackingGrossWeight=onBlur(createParams.innerPackingGrossWeight,3)" @keyup.native="createParams.innerPackingGrossWeight=onInput2(createParams.innerPackingGrossWeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.innerPackingGrossWeight==oldParams.innerPackingGrossWeight?'':'red')}">
                  {{oldParams.innerPackingGrossWeight}}
                </td>
                <td :style="{color:(createParams.innerPackingGrossWeight==contrastParams.innerPackingGrossWeight?'':'red')}">
                  {{contrastParams.innerPackingGrossWeight}}
                </td>
              </tr>
              <tr v-if="createParams.isInnerPacking == 'Y' && !isPop">
                <!-- 产品内包装容量(m^3) -->
                <td>{{$t('material.innerPackingCapacity')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.innerPackingCapacity" @blur="createParams.innerPackingCapacity=onBlur(createParams.innerPackingCapacity,6)" @keyup.native="createParams.innerPackingCapacity=onInput2(createParams.innerPackingCapacity)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.innerPackingCapacity==oldParams.innerPackingCapacity?'':'red')}">
                  {{oldParams.innerPackingCapacity}}
                </td>
                <td :style="{color:(createParams.innerPackingCapacity==contrastParams.innerPackingCapacity?'':'red')}">
                  {{contrastParams.innerPackingCapacity}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 语言 -->
                <td>{{$t('material.language')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.language" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.language==oldParams.language?'':'red')}">
                  {{oldParams.language}}
                </td>
                <td :style="{color:(createParams.language==contrastParams.language?'':'red')}">
                  {{contrastParams.language}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <td>{{$t('material.graphics')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.graphics" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.graphics==oldParams.graphics?'':'red')}">
                  {{oldParams.graphics}}
                </td>
                <td :style="{color:(createParams.graphics==contrastParams.graphics?'':'red')}">
                  {{contrastParams.graphics}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 产品外包装类型 -->
                <td><span v-if="isFieldRequired('productPackagingType')">*</span>{{$t('material.productPackagingType')}}</td>
                <td>
                  <el-form-item prop="productPackagingType" :rules="isFieldRequired('productPackagingType')?[rules.requiredRules]:[]">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="PRODUCT_PACKAGING_TYPE" v-model="createParams.productPackagingType"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="PRODUCT_PACKAGING_TYPE" v-model="oldParams.productPackagingType" disabled></ic-select>
                  <span v-if="createParams.productPackagingType!=oldParams.productPackagingType && oldParams.productPackagingType">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="PRODUCT_PACKAGING_TYPE" v-model="contrastParams.productPackagingType" disabled></ic-select>
                  <span v-if="createParams.productPackagingType!=contrastParams.productPackagingType && contrastParams.productPackagingType">!</span>
                </td>
              </tr>

              <tr v-if="!isPop">
                <!-- 产品外包装长度(cm) -->
                <td><span v-if="isFieldRequired('externalPackagingLength')">*</span>{{$t('material.externalPackagingLength')}}</td>
                <td>
                  <el-form-item prop="externalPackagingLength" :rules="isFieldRequired('externalPackagingLength')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.externalPackagingLength" @blur="createParams.externalPackagingLength=onBlur(createParams.externalPackagingLength,2)" @keyup.native="createParams.externalPackagingLength=onInput(createParams.externalPackagingLength)" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.externalPackagingLength==oldParams.externalPackagingLength?'':'red')}">
                  {{oldParams.externalPackagingLength}}
                </td>
                <td :style="{color:(createParams.externalPackagingLength==contrastParams.externalPackagingLength?'':'red')}">
                  {{contrastParams.externalPackagingLength}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 产品外包装宽度(cm) -->
                <td><span v-if="isFieldRequired('externalPackagingWidth')">*</span>{{$t('material.externalPackagingWidth')}}</td>
                <td>
                  <el-form-item prop="externalPackagingWidth" :rules="isFieldRequired('externalPackagingWidth')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.externalPackagingWidth" @blur="createParams.externalPackagingWidth=onBlur(createParams.externalPackagingWidth,2)" @keyup.native="createParams.externalPackagingWidth=onInput(createParams.externalPackagingWidth)" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.externalPackagingWidth==oldParams.externalPackagingWidth?'':'red')}">
                  {{oldParams.externalPackagingWidth}}
                </td>
                <td :style="{color:(createParams.externalPackagingWidth==contrastParams.externalPackagingWidth?'':'red')}">
                  {{contrastParams.externalPackagingWidth}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 产品外包装高度(cm) -->
                <td><span v-if="isFieldRequired('externalPackagingHeight')">*</span>{{$t('material.externalPackagingHeight')}}</td>
                <td>
                  <el-form-item prop="externalPackagingHeight" :rules="isFieldRequired('externalPackagingHeight')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.externalPackagingHeight" @blur="createParams.externalPackagingHeight=onBlur(createParams.externalPackagingHeight,2)" @keyup.native="createParams.externalPackagingHeight=onInput(createParams.externalPackagingHeight)" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.externalPackagingHeight==oldParams.externalPackagingHeight?'':'red')}">
                  {{oldParams.externalPackagingHeight}}
                </td>
                <td :style="{color:(createParams.externalPackagingHeight==contrastParams.externalPackagingHeight?'':'red')}">
                  {{contrastParams.externalPackagingHeight}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 产品外包装净重(kg) -->
                <td><span v-if="isFieldRequired('externalPackagingNetweight')">*</span>{{$t('material.externalPackagingNetweight')}}</td>
                <td>
                  <el-form-item prop="externalPackagingNetweight" :rules="isFieldRequired('externalPackagingNetweight')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.externalPackagingNetweight" @blur="createParams.externalPackagingNetweight=externalPackagingNetweightBlur(createParams.externalPackagingNetweight,3)" @keyup.native="createParams.externalPackagingNetweight=onInput2(createParams.externalPackagingNetweight)" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.externalPackagingNetweight==oldParams.externalPackagingNetweight?'':'red')}">
                  {{oldParams.externalPackagingNetweight}}
                </td>
                <td :style="{color:(createParams.externalPackagingNetweight==contrastParams.externalPackagingNetweight?'':'red')}">
                  {{contrastParams.externalPackagingNetweight}}
                </td>
              </tr>

              <tr v-if="!isPop">
                <!-- 产品外包装毛重 -->
                <td><span v-if="isFieldRequired('externalPackagingGrossweight')">*</span>{{$t('material.externalPackagingGrossweight')}}</td>
                <td>
                  <el-form-item prop="externalPackagingGrossweight" :rules="isFieldRequired('externalPackagingGrossweight')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.externalPackagingGrossweight" @blur="createParams.externalPackagingGrossweight=externalPackagingGrossweightBlur(createParams.externalPackagingGrossweight,3)" @keyup.native="createParams.externalPackagingGrossweight=onInput2(createParams.externalPackagingGrossweight)" clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.externalPackagingGrossweight==oldParams.externalPackagingGrossweight?'':'red')}">
                  {{oldParams.externalPackagingGrossweight}}
                </td>
                <td :style="{color:(createParams.externalPackagingGrossweight==contrastParams.externalPackagingGrossweight?'':'red')}">
                  {{contrastParams.externalPackagingGrossweight}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 产品运输托盘类型 -->
                <td>{{$t('material.productTransportPalletType')}}</td>
                <td>
                  <!-- <el-form-item prop="productTransportPalletType"> -->
                  <el-form-item prop="productTransportPalletType" :rules="createParams.disType == 'SUPPLIER' || isRequired ? rules.productTransportPalletType : [{required: false}]">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="PRODUCT_TRANSPORT_PALLET_TYPE" @change="changeProductTransportPalletType" v-model="createParams.productTransportPalletType"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="PRODUCT_TRANSPORT_PALLET_TYPE" v-model="oldParams.productTransportPalletType" disabled></ic-select>
                  <span v-if="createParams.productTransportPalletType!=oldParams.productTransportPalletType && oldParams.productTransportPalletType">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="PRODUCT_TRANSPORT_PALLET_TYPE" v-model="contrastParams.productTransportPalletType" disabled></ic-select>
                  <span v-if="createParams.productTransportPalletType!=contrastParams.productTransportPalletType && contrastParams.productTransportPalletType">!</span>
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 每层箱数 -->
                <td><span v-if="isFieldRequired('palletLayerBoxNumber')">*</span>{{$t('material.palletLayerBoxNumber')}}</td>
                <td>
                  <el-form-item prop="palletLayerBoxNumber" :rules="isFieldRequired('palletLayerBoxNumber')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.palletLayerBoxNumber" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.palletLayerBoxNumber==oldParams.palletLayerBoxNumber?'':'red')}">
                  {{oldParams.palletLayerBoxNumber}}
                </td>
                <td :style="{color:(createParams.palletLayerBoxNumber==contrastParams.palletLayerBoxNumber?'':'red')}">
                  {{contrastParams.palletLayerBoxNumber}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 托盘层数 -->
                <td><span v-if="isFieldRequired('palletLayerNumber')">*</span>{{$t('material.palletLayerNumber')}}</td>
                <td>
                  <el-form-item prop="palletLayerNumber" :rules="isFieldRequired('palletLayerNumber')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.palletLayerNumber" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.palletLayerNumber==oldParams.palletLayerNumber?'':'red')}">
                  {{oldParams.palletLayerNumber}}
                </td>
                <td :style="{color:(createParams.palletLayerNumber==contrastParams.palletLayerNumber?'':'red')}">
                  {{contrastParams.palletLayerNumber}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 托盘上物品长度(cm) -->
                <td><span v-if="isFieldRequired('palletItemsLength')">*</span>{{$t('material.palletItemsLength')}}</td>
                <!-- 除了LocalSums和toys 其他必填-->
                <td>
                  <el-form-item prop="palletItemsLength" :rules="isFieldRequired('palletItemsLength')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.palletItemsLength" clearable @blur="createParams.palletItemsLength=blurPalletItemsLength(createParams.palletItemsLength,2)" @keyup.native="createParams.palletItemsLength=onInput(createParams.palletItemsLength)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.palletItemsLength==oldParams.palletItemsLength?'':'red')}">
                  {{oldParams.palletItemsLength}}
                </td>
                <td :style="{color:(createParams.palletItemsLength==contrastParams.palletItemsLength?'':'red')}">
                  {{contrastParams.palletItemsLength}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 托盘上物品宽度(cm) -->
                <td><span v-if="isFieldRequired('palletItemsWidth')">*</span>{{$t('material.palletItemsWidth')}}</td>
                <td>
                  <el-form-item prop="palletItemsWidth" :rules="isFieldRequired('palletItemsWidth')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.palletItemsWidth" clearable @blur="createParams.palletItemsWidth=blurPalletItemsWidth(createParams.palletItemsWidth,2)" @keyup.native="createParams.palletItemsWidth=onInput(createParams.palletItemsWidth)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.palletItemsWidth==oldParams.palletItemsWidth?'':'red')}">
                  {{oldParams.palletItemsWidth}}
                </td>
                <td :style="{color:(createParams.palletItemsWidth==contrastParams.palletItemsWidth?'':'red')}">
                  {{contrastParams.palletItemsWidth}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 托盘上物品高度(cm) -->
                <td><span v-if="isFieldRequired('palletItemsHeight')">*</span>{{$t('material.palletItemsHeight')}}</td>
                <td>
                  <el-form-item prop="palletItemsHeight" :rules="isFieldRequired('palletItemsHeight')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.palletItemsHeight" clearable @blur="createParams.palletItemsHeight=blurPalletItemsHeight(createParams.palletItemsHeight,2)" @keyup.native="createParams.palletItemsHeight=onInput(createParams.palletItemsHeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.palletItemsHeight==oldParams.palletItemsHeight?'':'red')}">
                  {{oldParams.palletItemsHeight}}
                </td>
                <td :style="{color:(createParams.palletItemsHeight==contrastParams.palletItemsHeight?'':'red')}">
                  {{contrastParams.palletItemsHeight}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 托盘上物品净重(kg) -->
                <td>{{$t('material.palletItemsWeight')}}</td>
                <td>
                  <el-form-item prop="palletItemsWeight">
                    <el-input v-model.trim="createParams.palletItemsWeight" @blur="createParams.palletItemsWeight=blurPalletItemsWeight(createParams.palletItemsWeight,3)" @keyup.native="createParams.palletItemsWeight=onInput2(createParams.palletItpalletItemsWeightemsHeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.palletItemsWeight==oldParams.palletItemsWeight?'':'red')}">
                  {{oldParams.palletItemsWeight}}
                </td>
                <td :style="{color:(createParams.palletItemsWeight==contrastParams.palletItemsWeight?'':'red')}">
                  {{contrastParams.palletItemsWeight}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 托盘上物品毛重(kg) -->
                <td>{{$t('material.palletItemsGrossWeight')}}</td>
                <td>
                  <el-form-item prop="palletItemsGrossWeight">
                    <el-input v-model.trim="createParams.palletItemsGrossWeight" @blur="createParams.palletItemsGrossWeight=blurPalletItemsGrossWeight(createParams.palletItemsGrossWeight,3)" @keyup.native="createParams.palletItemsGrossWeight=onInput2(createParams.palletItemsGrossWeight)"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.palletItemsGrossWeight==oldParams.palletItemsGrossWeight?'':'red')}">
                  {{oldParams.palletItemsGrossWeight}}
                </td>
                <td :style="{color:(createParams.palletItemsGrossWeight==contrastParams.palletItemsGrossWeight?'':'red')}">
                  {{contrastParams.palletItemsGrossWeight}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 运输堆叠层数 -->
                <td>{{$t('material.transportStackingLayers')}}</td>
                <td>
                  <el-form-item prop="transportStackingLayers">
                    <el-input v-model.trim="createParams.transportStackingLayers" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.transportStackingLayers==oldParams.transportStackingLayers?'':'red')}">
                  {{oldParams.transportStackingLayers}}
                </td>
                <td :style="{color:(createParams.transportStackingLayers==contrastParams.transportStackingLayers?'':'red')}">
                  {{contrastParams.transportStackingLayers}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 储存堆叠层数 -->
                <td>{{$t('material.storageStackLayersNum')}}</td>
                <td>
                  <el-form-item prop="storageStackLayersNum">
                    <el-input v-model.trim="createParams.storageStackLayersNum" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.storageStackLayersNum==oldParams.storageStackLayersNum?'':'red')}">
                  {{oldParams.storageStackLayersNum}}
                </td>
                <td :style="{color:(createParams.storageStackLayersNum==contrastParams.storageStackLayersNum?'':'red')}">
                  {{contrastParams.storageStackLayersNum}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 运输高度 -->
                <td>{{$t('material.transportHeight')}}</td>
                <td>
                  <el-form-item prop="transportHeight">
                    <el-input v-model.trim="createParams.transportHeight" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.transportHeight==oldParams.transportHeight?'':'red')}">
                  {{oldParams.transportHeight}}
                </td>
                <td :style="{color:(createParams.transportHeight==contrastParams.transportHeight?'':'red')}">
                  {{contrastParams.transportHeight}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <!-- 存储高度 -->
                <td><span v-if="isFieldRequired('storageHeight')">*</span>{{$t('material.storageHeight')}}</td>
                <td>
                  <el-form-item prop="storageHeight" :rules="isFieldRequired('storageHeight')?[rules.requiredRules]:[]">
                    <el-input v-model.trim="createParams.storageHeight" oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.storageHeight==oldParams.storageHeight?'':'red')}">
                  {{oldParams.storageHeight}}
                </td>
                <td :style="{color:(createParams.storageHeight==contrastParams.storageHeight?'':'red')}">
                  {{contrastParams.storageHeight}}
                </td>
              </tr>
              <tr v-if="!isPop">
                <th class="card-title">{{$t('material.storageInformation')}}</th>
              </tr>
              <tr>
                <!-- 重量计算单位 -->
                <td><span>*</span>{{$t('material.weightUnit')}}</td>
                <td>
                  <el-form-item prop="weightUnit">
                    <el-input v-model.trim="createParams.weightUnit" disabled></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.weightUnit==oldParams.weightUnit?'':'red')}">
                  {{oldParams.weightUnit}}
                </td>
                <td :style="{color:(createParams.weightUnit==contrastParams.weightUnit?'':'red')}">
                  {{contrastParams.weightUnit}}
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.minimumDcReceivingValidity')}}</td>
                <td>
                  <el-form-item prop="minimumDcReceivingValidity">
                    <el-input v-model.trim="createParams.minimumDcReceivingValidity" clearable oninput="value=value.replace(/^\.+|[^\d.]/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.minimumDcReceivingValidity==oldParams.minimumDcReceivingValidity?'':'red')}">
                  {{oldParams.minimumDcReceivingValidity}}
                </td>
                <td :style="{color:(createParams.minimumDcReceivingValidity==contrastParams.minimumDcReceivingValidity?'':'red')}">
                  {{contrastParams.minimumDcReceivingValidity}}
                </td>
              </tr>
              <tr>
                <th class="card-title">{{$t('material.materialFactoryDetails')}}</th>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.isFresh')}}</td>
                <td>
                  <el-form-item prop="isFresh">
                    <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="createParams.isFresh"></ic-select>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists">
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="oldParams.isFresh" disabled></ic-select>
                  <span v-if="createParams.isFresh!=oldParams.isFresh && oldParams.isFresh">!</span>
                </td>
                <td>
                  <ic-select clearable table="TM_MATERIAL_RECORD" field="IS_NOT" v-model="contrastParams.isFresh" disabled></ic-select>
                  <span v-if="createParams.isFresh!=contrastParams.isFresh && contrastParams.isFresh">!</span>
                </td>
              </tr>
              <tr>
                <td><span>*</span>{{$t('material.originCountry')}}</td>
                <td>
                  <el-form-item>
                    <el-input v-model.trim="createParams.originCountry" disabled clearable></el-input>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.originCountry==oldParams.originCountry?'':'red')}">
                  {{oldParams.originCountry}}
                </td>
                <td :style="{color:(createParams.originCountry==contrastParams.originCountry?'':'red')}">
                  {{contrastParams.originCountry}}
                </td>
              </tr>

              <tr>
                <!--关联工厂-->
                <th class="card-title">{{$t('material.affiliatedFactory')}}</th>
              </tr>
              <tr>
                <!--工厂名称-->
                <td><span>*</span>{{$t('material.tmPlantName')}}</td>
                <td>
                  <el-form-item prop="tmPlantName">
                    <el-tooltip class="item" :content=createParams.tmPlantName placement="top">
                      <el-input v-model.trim="createParams.tmPlantName" clearable disabled></el-input>
                    </el-tooltip>
                  </el-form-item>
                </td>
                <td v-if="oldRecordExists" :style="{color:(createParams.tmPlantName==oldParams.tmPlantName?'':'red')}">
                  {{oldParams.tmPlantName}}
                </td>
                <td :style="{color:(createParams.tmPlantName==contrastParams.tmPlantName?'':'red')}">
                  {{contrastParams.tmPlantName}}
                </td>
              </tr>
            </table>
          </el-tab-pane>
          <el-tab-pane :label="$t('material.freightInfo')" v-if="showFreightInfo">
            <div>
              <el-button v-if="canEditFreightInfo" @click="addFreightRow" type="primary">{{$t("common.add")}}</el-button>
              <el-button v-if="canEditFreightInfo" @click="delFreightRow" type="primary">{{$t("common.del")}}</el-button>
              <el-table ref="freightInfoTable" :data="createParams.freightInfo">
                <el-table-column type="selection" v-if="canEditFreightInfo"></el-table-column>
                <el-table-column align="center" sortable prop="dcName" label="到货仓库（DC）">
                  <template slot-scope="scope">
                    <ic-select :disabled="!canEditFreightInfo" :options="selectedDcs" v-model="scope.row.tmDcId"></ic-select>
                  </template>
                </el-table-column>
                <el-table-column align="center" sortable prop="pickupPoint" label="提货点" width="150">
                  <template slot-scope="scope">
                    <ic-select :filterable="true" :disabled="!canEditFreightInfo" v-model="scope.row.tmPickupId" table="BASE" field="PICKUP_POINT"></ic-select>
                  </template>
                </el-table-column>
                <el-table-column align="center" sortable prop="transportaionMethod" label="运输方式" width="140">
                  <template slot-scope="scope">
                    <ic-select :disabled="!canEditFreightInfo" v-model="scope.row.transportaionMethod" table="COMMON" field="TRANSPORTAION_METHOD"></ic-select>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="freshPreparationTime" label="鲜货准备时间" width="150">
                  <template slot-scope="scope">
                    <el-input :disabled="!canEditFreightInfo" style="width:100%" v-model="scope.row.freshPreparationTime" type="number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="inboundTransferTime" label="Inbound物流运输时间" width="200">
                  <template slot-scope="scope">
                    <el-input :disabled="!canEditFreightInfo" style="width:100%" v-model="scope.row.inboundTransferTime" type="number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="freight" label="产品运费（不含税）" width="200">
                  <template slot-scope="scope">
                    <!-- isPop:是否POP物料;http://localhost:3000/adminconsole/five-bit-code/findOneByCode?fiveBitCode=SP获取 -->
                    <!-- isToys:是否category2为Toys -->
                    <!-- isConventionalMaterials:是否非常常规物料 -->
                    <!-- categoryLevel2Name:GRI第二层分类 -->
                    <!-- !(isPop || isToys || createParams.isConventionalMaterials == 'Y' || griInfo.categoryLevel2Name == 'Local Sums') -->
                    <el-input :disabled="isDisabled" style="width:100%" v-model="scope.row.freight" type="number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="effectiveBeginDate" label="价格有效起始日期" width="150">
                  <template slot-scope="scope">
                    <el-date-picker v-if="createParams.isNewDc==='Y'" style="width:100%" value-format="yyyy-MM-dd" v-model="scope.row.effectiveBeginDate" type="date"></el-date-picker>
                    <p v-else>{{scope.row.effectiveBeginDate|dateFormatFilter("YYYY-MM-DD")}}</p>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="spTime" label="运费状态" width="150">
                  <template slot-scope="scope">
                    {{scope.row.feightStatus | ic('COMMON','STATUS')}}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('common.approvalLog')">
            <el-table :data="workFlowLogList" stripe border highlight-current-row class="table">
              <el-table-column prop="createDate" :label="$t('common.OperationTime') ">
                <template slot-scope="scope">
                  {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}
                </template>
              </el-table-column>
              <el-table-column prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
              <el-table-column prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
              <el-table-column prop="comments" :label="$t('common.opinion') "></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
    <el-dialog :title="$t('material.isConversionCoefficient')" :visible.sync="showConversionCoefficient" width="400px">
      <el-form class="form_border" label-width="110px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('material.conversionCoefficient')" required>
              <ic-select clearable table="TM_MATERIAL_RECORD" field="CONVERSION_COEFFICIENT" v-model="createParams.conversionCoefficient" :disabled="isSup"></ic-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="saveConversion()">{{$t('common.submit')}}</el-button>
        <el-button type="primary" @click="showConversionCoefficient = false">{{$t('common.close')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="showApproval" width="500px">
      <el-form :model="info" ref="info" class="form_border" :label-position="labelPosition" label-width="110px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.auditor')" placeholder="">
              <el-input v-model="username" class="handle-input" disabled />
            </el-form-item>

            <el-form-item :label="$t('common.approvalTime') " placeholder="">
              <el-input v-model="date" class="handle-input" disabled />
            </el-form-item>
            <el-form-item :label="$t('common.approvalResults') " placeholder="" prop="approvalType">
              <el-radio v-model="info.approvalType" label="1">{{$t('common.pass')}}</el-radio>
              <el-radio v-model="info.approvalType" label="2">{{$t('common.noPass')}}</el-radio>
            </el-form-item>

            <el-form-item :label="$t('common.approvalRemarks') " placeholder="" prop="approvalDescription">
              <el-input type="textarea" v-model="info.approvalDescription" class="handle-input" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="save(3)">{{$t('common.submit')}}</el-button>
        <el-button type="primary" @click="showApproval = false">{{$t('common.close')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('material.showContrast') " :visible.sync="showContrast" width="800px">
      <el-form :model="queryCondition" ref="queryCondition" class="form_border" :label-position="labelPosition" label-width="110px">
        <el-row>
          <!--Category1-->
          <el-col :span="8">
            <el-form-item label="Category1" prop="categoryLevel1Id">
              <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1Contrast()">
                <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--Category2-->
          <el-col :span="8">
            <el-form-item label="Category2" prop="categoryLevel2Id">
              <el-select v-model="queryCondition.categoryLevel2Id" clearable @change="changeCategory2Contrast()">
                <el-option :key="index" v-for="(item,index) in categoryList2Contrast" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--Category3-->
          <el-col :span="8">
            <el-form-item label="Category3" prop="categoryLevel3Id">
              <el-select v-model="queryCondition.categoryLevel3Id" clearable>
                <el-option :key="index" v-for="(item,index) in categoryList3Contrast" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!--物料编码-->
          <el-col :span="8">
            <el-form-item :label="$t('material.eightBitCode')" prop="eightBitCode" label-width="110px">
              <el-input v-model.trim="queryCondition.eightBitCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <!--物料名称-->
          <el-col :span="8">
            <el-form-item :label="$t('material.eightBitCodeName')" prop="eightBitCodeName" label-width="110px">
              <el-input v-model.trim="queryCondition.eightBitCodeName" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="4">
            <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm('queryCondition')" type="primary">{{$t('common.reset')}}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div style="padding-top: 15px;"></div>
      <el-table sortable max-height="435" :data="tableData" ref="tableData" row-key="tmMaterialId" stripe border highlight-current-row class="table">
        <el-table-column align="center" width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.row.tmMaterialId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="eightBitCode" :label="$t('material.eightBitCode')"></el-table-column>
        <el-table-column prop="eightBitCodeName" :label="$t('material.eightBitCodeName')"></el-table-column>
        <el-table-column prop="supplierName" :label="$t('material.supplier')"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--==分页组件==-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="confirmContrast">{{$t('material.determine')}}</el-button>
        <el-button type="primary" @click="showContrast = false">{{$t('common.close')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('material.listOfAttachments')" :visible.sync="showFileTable" width="800px">
      <el-table :data="fileList" stripe border highlight-current-row class="table">
        <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
          <!--文件-->
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="tmDocumentId" min-width="130px">
          <template slot-scope="scope">
            <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <settlement-unit-dialog :is-show.sync="showSettlementUnitDialog" :create-fun="onConfirmSettlementUnit" @hideDialog="showSettlementUnitDialog = false" />
    <planDialog :is-show.sync="showPlanDialog" :scoped="true" :create-fun="onConfirmPlan" :parent-id="parentId" @hideDialog="showPlanDialog = false" />
    <gri-dialog :is-show.sync="showGriDialog" :create-fun="onConfirmGri" ref='Grichild' :materialType='materialType' :is-conventional-materials.sync="isConventionalMaterials" @hideDialog="showGriDialog = false" />
  </div>
</template>
<script>
import { apiService } from "../../../../api/material/material-master-data";
import commonFunction from "../../../../utils/dataTableUtils"
import { Message } from "element-ui";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
import commonFun from "@/utils/commonFun";
import settlementUnitDialog from "@/components/page/material/material-master-data/settlement-unit-dialog";
import planDialog from "@/components/page/material/material-master-data/plan-dialog";
import griDialog from "@/components/page/material/material-master-data/gri-dialog";
/*import dcDialog from "@/components/page/material/material-master-data/dc-dialog";*/
import { inputChoiceService } from "@/api/common/input-choice";
import PickupPointSel from "@/components/page/base-data/pickup-point-sel";
import unit from "@/api/unit/unit";
import gtinValid from "@/utils/gtinValid";
import Barcoder from 'barcoder'
import { Decimal } from "decimal.js";
export default {
  name: 'material-master-add',
  components: { PickupPointSel, IcSelect, settlementUnitDialog, planDialog, griDialog },
  data() {
    let validaProjectOrCategoryLeader = (rule, value, callback) => {
      if (this.isPop && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaDepartment = (rule, value, callback) => {
      if (this.isPop && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaFormarkets = (rule, value, callback) => {
      if (this.isPop && value && value.length < 1) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaSizeMm = (rule, value, callback) => {
      if (this.isPop && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaForStoreTier = (rule, value, callback) => {
      if (this.isPop && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaInternalAndExternalAreas = (rule, value, callback) => {
      if (this.isPop && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaFutureExWorksWithTax = (rule, value, callback) => {
      if (this.createParams.futureFactoryRequiredPrice === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaFutureExWorksNotTax = (rule, value, callback) => {
      if (this.createParams.futureFactoryRequiredPrice === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaFuturePriceEffectiveDate = (rule, value, callback) => {
      if (this.createParams.futureFactoryRequiredPrice === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaFuturePurchaseTaxAmount = (rule, value, callback) => {
      if (this.createParams.futureFactoryRequiredPrice === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaPreviousExWorks = (rule, value, callback) => {
      if (this.createParams.futureFactoryRequiredPrice === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaWrinCode = (rule, value, callback) => {
      console.log('value', value);
      if (this.createParams.isWrin && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        if (value) {
          if (value.indexOf('-') !== -1) {
            if (value.split('-')[0].length !== 5) {
              callback(new Error('格式需满足XXXXX-XXX'));
            } else if (value.split('-')[1].length !== 3) {
              callback(new Error('格式需满足XXXXX-XXX'));
            } else {
              callback();
            }
          } else {
            var reg = /^(0|[1-9][0-9]*)$/
            if (!reg.test(value)) {
              callback(new Error('WRIN编码只能输入正整数和0'));
            } else if (value.length > 8) {
              callback(new Error('WRIN编码最多输入8位数字'));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      }
    };
    let validaGtin = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else if (value.length != 14 || !Barcoder.validate(value)) {
        callback(new Error('GTIN校验错误'));
      } else {
        callback();
      }
    };
    let validaGtin2 = (rule, value, callback) => {
      if (value) {
        if (value.length != 14 || !Barcoder.validate(value)) {
          callback(new Error('GTIN校验错误'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let validStopSaleDate = (rule, value, callback) => {
      console.log('this.categoryLevel1Code', this.categoryLevel1Code);
      console.log('validStopSaleDatevalue', value);
      if (this.categoryLevel1Code === '40') {
        if (!value) {
          callback(new Error(this.$t("visitPlan.noEmpty")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let validaTaxClassificationCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else if (value.length > 19 || value.length < 19) {
        callback(new Error('税收分类编码固定19位'));
      } else {
        callback();
      }
    };
    let validaServiceChargePerToy = (rule, value, callback) => {
      if (this.createParams.ptoyServiceFeeApplicable === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaRawProductStatus = (rule, value, callback) => {
      if (!this.isSup && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaRawProductEName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        var reg = /^[^\u4E00-\u9FFF]*$/
        if (!reg.test(value)) {
          callback(new Error('不允许输入中文'));
        } else {
          callback();
        }
      }
    };
    let validaFiveBitCode = (rule, value, callback) => {
      if (!this.isSup && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validFreightInfoFreight = (rule, value, callback) => {
      if (this.isPop || this.isToys || this.isConventionalMaterials || this.createParams.isNewDc === 'Y') {
        if (commonFun.isEmpty(value)) {
          callback("运费价格不能为空");
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let validEffectiveBeginDate = (rule, value, callback) => {
      if (this.createParams.isNewDc === 'Y') {
        if (commonFun.isEmpty(value)) {
          callback("产品有效开始日期不能为空");
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let validFreightInfoFreshPreparationTime = (rule, value, callback) => {
      if (this.createParams.isFresh == 'Y' && commonFun.isEmpty(value)) {
        callback(new Error("运费信息鲜货准备时间不能为空"));
      } else {
        callback();
      }
    };
    let validaConversionCoefficient = (rule, value, callback) => {
      if (!this.isSup && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaExchangeRate = (rule, value, callback) => {
      if (!this.isSup && !value) {
        callback(new Error('请输入汇率'));
      } else {
        if (value == 0) {
          callback(new Error('汇率不能为0'));
        } else {
          callback();
        }
      }
    };
    // let validaInventoryCountingFrequency = (rule, value, callback) => {
    //   if (!this.isSup && !value) {
    //     callback(new Error(this.$t("visitPlan.noEmpty")));
    //   } else {
    //     callback();
    //   }
    // };
    let validaIsCtcDirectMining = (rule, value, callback) => {
      if (this.createParams.canCtcSettle === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaIsCtcImport = (rule, value, callback) => {
      if (this.createParams.canCtcSettle === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validIsCqsAudit = (rule, value, callback) => {
      if (this.createParams.isConventionalMaterials === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validCqsAuditor = (rule, value, callback) => {
      if (this.createParams.isConventionalMaterials === 'Y' && this.createParams.isCqsAudit === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validIsFinanceAudit = (rule, value, callback) => {
      if (this.createParams.isConventionalMaterials === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validFinanceAuditor = (rule, value, callback) => {
      if (this.createParams.isConventionalMaterials === 'Y' && this.createParams.isFinanceAudit === 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaApprovedBy = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaEightBitCode = (rule, value, callback) => {
      console.log('griInfo', this.griInfo);
      const emplFlag = localStorage.getItem("ms_emplFlag");
      if ((this.$route.query.type !== 'copy' && this.isPop) || (this.$route.query.type == 'copy' && emplFlag !== 'SUP' && this.griInfo.categoryLevel2Name == 'POP')) {
        if (!value) {
          callback(new Error(this.$t("visitPlan.noEmpty")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let validaInnerPackingType = (rule, value, callback) => {
      let that = this
      if (that.createParams.isInnerPacking == 'Y' && !value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaDCs = (rule, value, callback) => {
      let that = this
      if ((that.createParams.disType == 'DC' || that.createParams.disType == 'DC_self_lifting') && value.length < 1) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaEmpty = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    let validaDisType = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入配送类型'));
      } else {
        console.log('this.createParams.conductStatus', this.createParams.conductStatus);
        console.log('disTypeTemp', this.disTypeTemp);
        console.log('value', value);
        if (this.$route.query.type !== 'copy') {
          if (
            this.createParams.conductStatus == 'supplier_newly_build' ||
            this.createParams.conductStatus == 'mdm_newly_build' ||
            this.createParams.conductStatus == 'mdm_perfection' ||
            (this.createParams.conductStatus == 'wait_business_review' && this.createParams.currentReviewer == '待HGS预审') ||
            (this.createParams.conductStatus == 'return' && this.createParams.isApprovedLog === false)) {
            callback();
          } else {
            if ((this.disTypeTemp == 'DC_SUPPLIER_DC' || this.disTypeTemp == "SUPPLIER_DC" || this.disTypeTemp == "DC") && value === 'SUPPLIER') {
              callback(new Error('无法修改为直送门店配送类型'));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      }
    };
    return {
      // isLoading: false,
      isDisabled: false,
      // isCqsAuditFlag: true,
      ms_Permission: null,
      isShowParams: true,
      categoryLevel1Code: "",
      text: "",
      isEightBitCode: false,
      disTypeTemp: "",
      isShowFile: false,
      isDisType: false,
      isToyVendor: false,
      griInfo: {},
      isRequired: false,
      isLocalSums: '',
      isToys: false,
      isUnconventional: '',//非常规
      sixBitCode: '',
      manualVerificationClass: false,
      isPackaging: false,
      totalCount: 0,
      tableData: [],
      labelPosition: 'right',
      createParams: {},
      oldParams: {},// 上一个版本
      contrastParams: {},// 对比物料
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      categoryList1Contrast: [],
      categoryList2Contrast: [],
      categoryList3Contrast: [],
      cTableData: [],
      isOrNo: [{ lable: 'Y', value: 'Y' }, { lable: 'N', value: 'N' }],
      factoryList: [],//工厂List
      dcList: [],
      showApproval: false,
      showContrast: null,
      oldRecordExists: false,//true表示老版本存在，false则不存在
      id: null,
      showFileTable: false,
      fileList: [],
      info: {
        approvalType: '1',
        approvalDescription: null,
        createBy: null,
        createDate: null
      },
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        categoryLevel3Id: null,
        eightBitCode: '',
        eightBitCodeName: '',
        isPop: this.isPop,
        isConventionalMaterials: this.isConventionalMaterials,
        scoped: true
      },// 选择对比物物料弹框From
      radioVal: null,
      emplFlag: null,
      dcs: [],
      alternativeDc: [],//备选dcs
      oldDcs: [],
      oldAlternativeDc: [],//old 备选dcs
      contrastDcs: [],// contrast dcs
      contrastAlternativeDc: [],//contrast 备选dcs
      workFlowLogList: [],//审批日志
      username: null,
      data: null,
      isExamine: null,//判断是否可以审批
      oldDcsFlag: false,
      oldAlternativeDcFlag: false,
      contrastDcsFlag: false,
      contrastAlternativeDcFlag: false,
      isSup: false,
      showSettlementUnitDialog: false,
      showPlanDialog: false,
      showDcDialog: false,
      parentId: null,
      dialogType: null,
      isPop: false,
      isFpa: false,
      isHappyMealSet: false,
      isConventionalMaterials: false,
      showConversionCoefficient: false,//修改折算系数弹框
      showGriDialog: false,
      disaForm: false,// 是否禁用表单
      disaSettlementUnitCode: false,// 是否结算状态
      disaHead: false,// 是否禁用表头信息
      collectDisa: false,//判断是否['NFC', 'SS', 'CQS', 'SC','MDM']
      leaderList: [],//审批人
      cqsAuditorLists: [],//CQS审批人
      financeAuditorLists: [],//Finance审批人
      isNewDcList: [
        {
          label: "是",
          value: "Y",
          disabled: false,
        },
        {
          label: "否",
          value: "N",
          disabled: false,
        }
      ],
      isConventionalMaterialsList: [
        {
          value: "Y",
          label: "Y"
        },
        {
          value: "N",
          label: "N"
        }
      ],
      isShow: true,//非常规物料标识是否展示
      urchaseTaxRateList: [],//采购税率
      roterType: null,//判断进来的类型
      formarkets: [],//ForMarkets--改为支持多选
      oldFormarkets: [],
      contrastFormarkets: [],
      oldFormarketsFlag: false,
      contrastFormarketsFlag: false,
      isNewProducts: false,//是否新品
      // disIsLto: false,//是否新品是否需要禁用
      formarketsList: [],
      freightInfoRules: {
        tmDcId: [{ required: true, message: '运费DC不能为空', trigger: 'change' }],
        tmPickupId: [{ required: true, message: '运费提货点不能为空', trigger: 'change' }],
        transportaionMethod: [{ required: true, message: '运费运输方式不能为空', trigger: 'change' }],
        freshPreparationTime: [{ required: true, message: '运费鲜货准备时间不能为空', trigger: 'change', validator: validFreightInfoFreshPreparationTime }],
        inboundTransferTime: [{ required: true, message: '运费inbound运输时间不能为空', trigger: 'change' }],
        freight: [{ validator: validFreightInfoFreight, message: '运费价格不能为空', trigger: 'blur' }],
        effectiveBeginDate: [{ validator: validEffectiveBeginDate, message: '产品有效开始日期不能为空', trigger: 'change' }]
      },
      rules: {
        settlementUnitCode: [{ required: true, message: '不能为空', trigger: 'change' }],
        requiredRules: { required: true, message: '不能为空', trigger: 'change' },
        fiveBitCode: [{ required: true, validator: validaFiveBitCode, trigger: 'change' }],
        eightBitCode: [{ validator: validaEightBitCode, trigger: 'change' }],
        sumsSort: [{ required: true, message: '请选择SUMSSort', trigger: 'change' }],
        isLto: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
        isPromotionalItem: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
        drawings: [{required: true, message: "不能为空", trigger: 'blur'}],
        mainMaterial: [{required: true, message: "不能为空", trigger: 'blur'}],
        specifiUom: [{ required: true, message: '请选择SpecifiUOM', trigger: 'change' }],
        projectOrCategoryLeader: [{ required: true, validator: validaProjectOrCategoryLeader, trigger: 'blur' }],
        department: [{ required: true, message: '不能为空', trigger: 'change' }],
        isCqsAudit: [{ required: true, validator: validIsCqsAudit, trigger: 'change' }],
        cqsAuditor: [{ required: true, validator: validCqsAuditor, trigger: 'change' }],
        isFinanceAudit: [{ required: true, validator: validIsFinanceAudit, trigger: 'change' }],
        financeAuditor: [{ required: true, validator: validFinanceAuditor, trigger: 'change' }],
        approvedBy: [{ required: true, validator: validaApprovedBy, trigger: 'change' }],
        isConventionalMaterials: [{ required: true, message: '请选择非常规物料标识', trigger: 'change' }],
        formarkets: [{ required: true, validator: validaFormarkets, trigger: 'change' }],
        sizeMm: [{ required: true, message: '不能为空', trigger: 'blur' }],
        forStoreTier: [{ required: true, validator: validaForStoreTier, trigger: 'blur' }],
        internalAndExternalAreas: [{ required: true, validator: validaInternalAndExternalAreas, trigger: 'change' }],
        status: [{ required: true, validator: validaRawProductStatus, trigger: 'change' }],
        settlementClassification: [{ required: true, message: '请输入结算分类', trigger: 'change' }],
        purchasers: [{ required: true, message: '请输入采购商', trigger: 'blur' }],
        purchasingManager: [{ required: true, message: '请输入采购经理', trigger: 'change' }],
        rpEffectiveDate: [{ required: true, message: '请选择RP生效日期', trigger: 'change' }],
        includedInStoreBag: [{ required: true, message: '请输入包含在开店包中', trigger: 'change' }],
        purchasingStatus: [{ required: true, message: '请输入采购状态', trigger: 'blur' }],
        purchasingCategory: [{ required: true, message: '不能为空', trigger: 'change' }],
        eightBitCodeName: [{ required: true, message: '请输入Raw Product中文名称', trigger: 'blur' }],
        rawProductEName: [{ required: true, message: '请输入Raw Product英文名称', trigger: 'blur' }],
        rawProductEAbbreviation: [{ required: true, validator: validaRawProductEName, trigger: 'blur' }],
        marketTime: [{ required: true, message: '请选择上市时间', trigger: 'change' }],
        stopSaleDate: [{ required: true, validator: validStopSaleDate, message: '请选择停售日期', trigger: 'change' }],
        useArea: [{ required: true, message: '请输入使用区域', trigger: 'change' }],
        canCtcSettle: [{ required: true, message: '请输入是否CTC可结算', trigger: 'change' }],
        taxClassificationCode: [{ required: true, validator: validaTaxClassificationCode, trigger: 'change' }],
        dcManagementUnit: [{ required: true, message: '不能为空', trigger: 'change' }],
        fpaFreight: [{ required: true, message: '不能为空', trigger: 'blur' }],
        remarks: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        graphics: [{ required: true, message: '请输入Graphics', trigger: 'blur' }],
        weightUnit: [{ required: true, message: '请输入重量计算单位', trigger: 'blur' }],
        rawProductType: [{ required: true, message: '请输入Raw Product Type', trigger: 'blur' }],
        factoryProductName: [{ required: true, message: '请输入工厂产品名称', trigger: 'blur' }],
        factoryProductStatus: [{ required: true, message: '请输入工厂产品状态', trigger: 'change' }],
        gtin: [{ required: true, validator: validaGtin, trigger: 'blur' }],
        gtin2: [{ validator: validaGtin2, trigger: 'blur' }],
        priceType: [{ required: true, message: '请输入价格类型', trigger: 'change' }],
        disType: [{ required: true, validator: validaDisType, trigger: 'change' }],
        conversionCoefficient: [{ required: true, validator: validaConversionCoefficient, trigger: 'change' }],
        // inventoryCountingFrequency: [{ required: true, validator: validaInventoryCountingFrequency, trigger: 'change' }],
        minimumOrderUnit: [{ required: true, message: '请输入最小订单单位', trigger: 'change' }],
        minimumOrders: [{ required: true, message: '不能为空', trigger: 'blur' }],
        urchaseTaxRate: [{ required: true, message: '请输入采购税率', trigger: 'change' }],
        exFactoryExcUnitPrice: [{ required: true, message: '请输入出厂不含税单价', trigger: 'blur' }],
        isForeignCurrency: [{ required: true, message: '请选择是否需要外币结算', trigger: 'change' }],
        foreignCurrencyCode: [{ required: true, message: '请选择外币币种', trigger: 'change' }],
        exchangeRate: [{ required: true, validator: validaExchangeRate, trigger: 'blur' }],

        priceEffectiveStartingTime: [{ required: true, message: '请选择价格有效起始日期', trigger: 'change' }],
        futureFactoryRequiredPrice: [{ required: true, message: '请输入未来出厂价', trigger: 'change' }],
        packagingServiceFeeNotTax: [{ required: true, message: '请输入Packaging Service Fee (w/o tax)', trigger: 'blur' }],
        packagingTaxAmount: [{ required: true, message: '请输入Packaging Tax Amount', trigger: 'blur' }],
        packagingVendor: [{ required: true, message: '请输入PackagingVendor', trigger: 'blur' }],
        facilityReference: [{ required: true, message: '请输入FacilityReference', trigger: 'blur' }],
        extendInventory: [{ required: true, message: '请输入是否延伸库存', trigger: 'change' }],
        alternativeDc: [{ required: true, message: '请输入备选DC', trigger: 'blur' }],
        feedTime: [{ required: true, message: '请选择FeedTime', trigger: 'change' }],
        tmPlantName: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
        serviceChargePerToy: [{ required: true, validator: validaServiceChargePerToy, trigger: 'change' }],
        temperature: [{ required: true, message: '请选择储存环境', trigger: 'change' }],
        wrinCode: [{ required: true, validator: validaWrinCode, trigger: 'change' }],
        isCtcDirectMining: [{ required: true, validator: validaIsCtcDirectMining, trigger: 'change' }],
        isCtcImport: [{ required: true, validator: validaIsCtcImport, trigger: 'change' }],
        supplierReference: [{ required: true, message: '请输入SupplierReference', trigger: 'blur' }],
        isTraceable: [{ required: true, message: '请输入是否可追溯', trigger: 'change' }],
        secondShelfLife: [{ required: true, message: '请输入第二保质期', trigger: 'blur' }],
        secondShelfLifeUnit: [{ required: true, message: '请输入第二保质期单位', trigger: 'blur' }],
        enterCatellaeSystem: [{ required: true, message: '请输入是否进入Catellae系统', trigger: 'change' }],
        firstShelfLife: [{ required: true, message: '请输入第一保质期（天）', trigger: 'blur' }],
        shelfLifeAfterThawing: [{ required: true, message: '请输入解冻后保质期', trigger: 'blur' }],
        shelfLifeUnitAfterThawing: [{ required: true, message: '请输入解冻后保质期单位', trigger: 'blur' }],
        thawingTime: [{ required: true, message: '请输入解冻时间（小时）', trigger: 'blur' }],
        formula1: [{ required: true, message: '请输入配方1', trigger: 'blur' }],
        formula2: [{ required: true, message: '请输入配方2', trigger: 'blur' }],
        formula3: [{ required: true, message: '请输入配方3', trigger: 'blur' }],
        formula4: [{ required: true, message: '请输入配方4', trigger: 'blur' }],
        isNeedThaw: [{ required: true, message: '请输入是否需要解冻', trigger: 'change' }],
        isNeedPreparationTime: [{ required: true, message: '请输入是否需要准备时间', trigger: 'change' }],
        isHarmful: [{ required: true, message: '请输入是否有害', trigger: 'change' }],
        taste: [{ required: true, message: '请输入味道', trigger: 'blur' }],
        shape: [{ required: true, message: '请输入形状', trigger: 'blur' }],
        color: [{ required: true, message: '请输入颜色', trigger: 'blur' }],
        validityDate: [{ required: true, message: '请输入有效期检查', trigger: 'change' }],
        preparationMethod: [{ required: true, message: '请输入准备方法', trigger: 'blur' }],
        preparationTime: [{ required: true, message: '请输入准备时间（小时）', trigger: 'blur' }],
        minimumStorageTemperature: [{ required: true, message: '请输入最低保存温度', trigger: 'blur' }],
        maximumStorageTemperature: [{ required: true, message: '请输入最高保存温度', trigger: 'blur' }],
        mcdBuyingUnit: [{ required: true, message: '请输入麦当劳购买单位', trigger: 'change' }],
        quantityUomInnerNum: [{ required: true, message: '请输入内包装内含UOM数量', trigger: 'blur' }],
        outerPackageContainsNum: [{ required: true, message: '请输入外包装内含内包装数量', trigger: 'blur' }],
        stackingHeightInsidePackage: [{ required: true, message: '请输入外包装内堆积高度', trigger: 'blur' }],
        yield: [{ required: true, message: '请输入应产率', trigger: 'blur' }],
        preferentialYield: [{ required: true, message: '请输入偏好应产率', trigger: 'blur' }],
        innerPackageLength: [{ required: true, message: '请输入产品内包装长度(cm)', trigger: 'blur' }],
        innerPackingHeight: [{ required: true, message: '请输入产品内包装高度(cm)', trigger: 'blur' }],
        innerPackingWeight: [{ required: true, message: '请输入产品内包装净重(kg)', trigger: 'blur' }],
        innerPackingWidth: [{ required: true, message: '请输入产品内包装宽度(cm)', trigger: 'blur' }],
        innerPackingType: [{ required: true, validator: validaInnerPackingType, trigger: 'change' }],
        palletLayerBoxNumber: [{ required: true, message: '不能为空', trigger: 'blur' }],
        isInnerPacking: [{ required: true, message: '请输入是否有内包装', trigger: 'change' }],
        palletItemsLength: [{ required: true, message: '不能为空', trigger: 'blur' }],
        palletLayerNumber: [{ required: true, message: '不能为空', trigger: 'blur' }],
        palletItemsHeight: [{ required: true, message: '不能为空', trigger: 'blur' }],
        palletItemsWidth: [{ required: true, message: '不能为空', trigger: 'blur' }],
        language: [{ required: true, message: '请输入语言', trigger: 'blur' }],
        measurementReceivingUnit: [{ required: true, message: '请输入收货体积计量单位', trigger: 'blur' }],
        storageHeight: [{ required: true, message: '请输入存储高度', trigger: 'blur' }],
        minimumDcReceivingValidity: [{ required: true, message: '请输入最小DC收货有效期(天)', trigger: 'blur' }],
        isFresh: [{ required: true, message: '请输入是否鲜货', trigger: 'change' }],
        originCountry: [{ required: true, message: '不能为空', trigger: 'blur' }],
        ptoyServiceFeeApplicable: [{ required: true, message: '请输入Toy Service Fee Applicable', trigger: 'change' }],
        fpaToyServiceFeeNumber: [{ required: true, message: '请输入玩具服务费FPA编号', trigger: 'blur' }],
      },
    }
  },
  computed: {
    packageInfo() {
      let { innerPackageLength, innerPackingHeight, innerPackingWidth, isInnerPacking } = this.createParams;
      return { innerPackageLength, innerPackingHeight, innerPackingWidth, isInnerPacking };
    },
    isFieldRequired() {
      let that = this;
      let griInfo = that.griInfo;
      let categoryLevel1Name = griInfo.categoryLevel1Name;
      let categoryLevel2Name = griInfo.categoryLevel2Name;
      let categoryLevel1Code = griInfo.categoryLevel1Code;
      return (field) => {
        switch (field) {
          case "useArea":
            // return categoryLevel1Name == "Food" || categoryLevel1Name == "Packaging" ||  categoryLevel2Name == "Gifts and promotion items" || categoryLevel2Name == "Chemical";
            return categoryLevel1Name != "POP";
          case "canCtcSettle":
            return categoryLevel2Name == "POP";
          case "innerPackingType":
            return that.createParams.isInnerPacking == 'Y';
          case "productPackagingType":
            return categoryLevel2Name != "POP";
          case "externalPackagingLength":
          case "externalPackagingWidth":
          case "externalPackagingHeight":
          case "externalPackagingNetweight":
          case "externalPackagingGrossweight":
          case "storageHeight":
          case "palletLayerBoxNumber":
          case "palletLayerNumber":
            return categoryLevel1Name == "Food" || categoryLevel1Name == "Packaging" || categoryLevel2Name == "Toys" || categoryLevel2Name == "Chemical" || this.isSup == true;
          case "palletItemsLength":
          case "palletItemsWidth":
          case "palletItemsHeight":
            return categoryLevel1Name == "Food" || categoryLevel1Name == "Packaging" || categoryLevel2Name == "Chemical" || this.isSup == true;
          case "stopSaleDate":
            return categoryLevel1Code == '40';
        }
      }
    },
    showFreightInfo() {
      if (this.createParams.disType == 'SUPPLIER_DC' || this.createParams.disType == 'DC_SUPPLIER_DC') {
        if (this.createParams.freightInfo == null) {
          this.createParams.freightInfo = [];
        }
        return true;
      }
    },
    canEditFreightInfo() {
      return true;
    },
    selectedDcs() {
      let dcs = this.dcs;
      let selectDcs = {};
      var tmDcIds = []
      this.createParams.freightInfo.filter(ele => {
        return dcs.indexOf(ele.tmDcId) === -1
      }).forEach(el => {
        tmDcIds.push(Number(el.tmDcId))
      })
      this.dcList.forEach(dc => {
        if (dcs.indexOf(dc.tmSupplierId) >= 0 || tmDcIds.indexOf(dc.tmSupplierId) >= 0) {
          selectDcs[dc.tmSupplierId] = dc.supplierName;
        }
      })
      return selectDcs;
    },
    isDisabled() {
      if (this.createParams.isNewDc === 'Y') {
        return false
      } else {
        if (this.isPop || this.isToys || this.createParams.isConventionalMaterials == 'Y' || this.griInfo.categoryLevel2Name == 'Local Sums') {
          return false
        } else {
          return true
        }
      }
    }
  },
  watch: {
    packageInfo: {
      handler(newVal) {
        console.log("🚀 ~ file: material-master-add.vue:3201 ~ packageInfo ~ newVal:", newVal)
        let { innerPackageLength, innerPackingHeight, innerPackingWidth, isInnerPacking } = newVal;
        if (isInnerPacking == 'Y') {
          if (commonFun.isNotEmpty(innerPackageLength) && commonFun.isNotEmpty(innerPackingHeight) && commonFun.isNotEmpty(innerPackingWidth)) {
            var mulNum = this.commonFun.mul(innerPackageLength, innerPackingWidth, innerPackingHeight)
            console.log("🚀 ~ file: material-master-add.vue:3215 ~ handler ~ mulNum:", mulNum)
            this.createParams.innerPackingCapacity = this.commonFun.div(mulNum, 1000000).toFixed(6)
            console.log("🚀 ~ file: material-master-add.vue:3214 ~ packageInfo ~ this.createParams.innerPackingCapacity:", this.createParams.innerPackingCapacity)
          } else {
            this.createParams.innerPackingCapacity = 0;
          }
        }
      },
      deep: true
    },
    dcs: {
      handler(val) {
        this.oldDcsFlag = JSON.stringify(val) != JSON.stringify((this.oldDcs))
        this.contrastDcsFlag = JSON.stringify(val) != JSON.stringify((this.contrastDcs))
      },
      deep: true
    },
    alternativeDc: {
      handler(val) {
        this.oldAlternativeDcFlag = JSON.stringify(val) != JSON.stringify((this.oldAlternativeDc))
        this.contrastAlternativeDcFlag = JSON.stringify(val) != JSON.stringify((this.contrastAlternativeDc))
      },
      deep: true
    },
    formarkets: {
      handler(val) {
        this.oldFormarketsFlag = JSON.stringify(val) != JSON.stringify((this.oldFormarkets))
        this.contrastFormarketsFlag = JSON.stringify(val) != JSON.stringify((this.contrastFormarkets))
      },
      deep: true
    },
  },
  filters: {
    toFixed: function (value, len) {
      if (value) {
        value = Number(value).toFixed(len);
      }
      return value
    }
  },
  created() {
    this.getCategoryList()
    //用户所属系统(SUP供应商)
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'S';
      this.isSup = true;
    } else {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {//是否MDM
          this.emplFlag = 'M';
        }
      }
    }
    this.roterType = this.$route.query.type;
    this.id = this.$route.query.id;
    this.materialType = this.$route.query.materialType;
    //审核人：获取当前账号对应账号名称
    // 审核日期：系统当前日期
    this.username = localStorage.getItem("ms_username");
    this.date = this.$options.filters["dateFormatFilter"](new Date())
    const param = {
      supplierName: null,
      supplierCode: null,
      sixBitCode: null,
      eightBitCodeName: null,
      conductStatusI18n: null,
      rawProductEName: null,
      rawProductEAbbreviation: null,
      sumsSort: null,
      status: 'formal',
      purchasingCategory: null,
      settlementClassification: null,
      isLto: null,
      isPromotionalItem: null,
      isCqsAudit: '',
      cqsAuditor: '',
      isFinanceAudit: '',
      financeAuditor: '',
      approvedBy: '',
      purchasingManager: null,
      rpEffectiveDate: null,
      includedInStoreBag: 'Y',
      purchasingStatus: null,
      marketTime: null,
      useArea: null,
      canCtcSettle: null,
      urchaseTaxRate: null,
      wrinCode: null,
      purchasers: null,
      enterCatellaeSystem: null,
      hasMultiShelfLife: null,
      taxClassificationCode: null,
      dcManagementUnit: null,
      dimensionUom: 'CM',
      importedOrNot: '',
      supplierReference: null,
      externalPackagingLength: null,
      externalPackagingHeight: null,
      externalPackagingNetweight: null,
      externalPackagingWidth: null,
      productPackagingType: null,
      externalPackagingGrossweight: null,
      palletLayerBoxNumber: null,
      palletLayerNumber: null,
      rawProductType: null,
      /*rawProductEAbbreviation: null,
      supplierCode: null,*/
      temperature: null,
      secondShelfLife: null,
      secondShelfLifeUnit: null,
      firstShelfLife: null,
      shelfLifeAfterThawing: null,
      shelfLifeUnitAfterThawing: null,
      thawingTime: null,
      formula1: null,
      formula2: null,
      formula3: null,
      formula4: null,
      isNeedThaw: null,
      taste: null,
      shape: null,
      color: null,
      validityDate: null,
      onlineSecondShelfLife: null,
      preparationMethod: null,
      preparationTime: null,
      minimumStorageTemperature: null,
      maximumStorageTemperature: null,
      mcdBuyingUnit: null,
      quantityUomInnerNum: null,
      quantityUomOutsourceNum: null,
      quantityInnerGoodsNum: null,
      outerPackageContainsNum: null,
      stackingHeightInsidePackage: null,
      quantityInnerPackingNum: null,
      yield: null,
      preferentialYield: null,
      productLength: null,
      productHeight: null,
      productWeight: null,
      productWidth: null,
      productGrossWeight: null,
      innerPackageLength: null,
      innerPackingHeight: null,
      innerPackingWeight: null,
      innerPackingWidth: null,
      innerPackingType: null,
      innerPackingGrossWeight: null,
      innerPackingCapacity: null,
      productTransportPalletType: null,
      isInnerPacking: null,
      palletItemsLength: null,
      palletItemsHeight: null,
      palletItemsWeight: null,
      palletItemsWidth: null,
      palletItemsGrossWeight: null,
      language: null,
      transportStackingLayers: null,
      measurementReceivingUnit: null,
      storageStackLayersNum: null,
      storageHeight: null,
      transportHeight: null,
      minimumDcReceivingValidity: null,
      isFresh: null,
      originCountry: null,
      priceEffectiveStartingTime: null,
      feedTime: null,
      futurePriceEffectiveDate: null,
      isNeedPreparationTime: null,
      isHarmful: null,
      tmSupplierId: null,
      remarks: null,
      futureExWorksWithTax: null,
      futureExWorksNotTax: null,
      futurePurchaseTaxAmount: null,
      previousExWorks: null,
      tmPlantId: null,
      tmPlantCode: null,
      tmPlantName: null,
      supplierMaterialCode: null,
      isCtcDirectMining: null,
      isCtcImport: null,
      disType: null,
      ptoyServiceFeeApplicable: null,
      alternativeDc: null,
      dcs: [],
      approvalType: 1,
      approvalDescription: null,
      createBy: null,
      createDate: null,
      isConventionalMaterials: 'N',
      serviceChargePerToy: null,
      toyServiceFeeWithTax: null,
      toyServiceFeeTax: null,
      isExistsLineQuotation: null,
      outboundFreight: null,
      fpaToyServiceFeeNumber: null,
      hmToyFpaNumber: null,
      categoryLevel1Name: null,
      categoryLevel2Name: null,
      categoryLevel3Name: null,
      settlementUnitName: null,
      settlementUnitCode: null,
      invitationCode: null,
      fiveBitCode: null,
      inventoryCountingFrequency: null,
      isHM: null,
      isSave: true,
      isSubmit: true,
      isWrin: false,
      isLeader: null,
      isConversionCoefficient: false,
      isNfcSubmit: false,
      isSsOrCqs: false,
      approvalRole: false,//审批角色
      isUnderApproval: false,//是否审批中
      department: null,
      formarkets: null,
      sizeMm: null,
      uom: null,
      standardCopiesUom: null,
      priceTypeText: '',
      eightBitCode: null,
    }
    this.createParams = { ...param }
    if (!this.createParams.weightUnit) {
      this.createParams.weightUnit = 'KG'
    }
    // this.createParams.weightUnit = 'KG'
    // this.createParams.stopSaleDate = '2099-12-31'
    this.$set(this.createParams, 'stopSaleDate', '2099-12-31')
    this.createParams.hasMultiShelfLife = 'N'
    this.createParams.toyServiceFeeTax = '0.06'
    this.createParams.toyServiceFeeTax2 = '6%'
    this.createParams.freightInfo = []
    this.oldParams = { ...param }
    this.contrastParams = { ...param }
    if (this.roterType === 'conven') {
      this.createParams.isConventionalMaterials = 'Y'
      this.isConventionalMaterials = true
    }
    if (this.$route.query.materialType == "new_conventional_material") {
      this.$set(this.createParams, 'isLto', "N")//点击新增紧急物料按钮，是否新品字段设置为默认为否 不可编辑，
      this.queryPrimaryKey()
    }
    if (this.materialType == "new_conventional_material" && (!this.createParams.conductStatus || this.createParams.conductStatus === 'mdm_newly_build')) {
      this.isShowFile = true
    } else {
      this.isShowFile = false
    }
    //判断是从主数据列表来，还是待办
    if (this.id) {
      if (this.roterType) {
        this.findMaterialRecordEdition(this.id)
      } else {
        this.findNewMaterialRecord(this.id)
      }
    } else {
      this.getLeaderList()
    }
    if (this.roterType === 'add' || this.roterType === 'conven') {
      this.findDcsList1()
    }
    this.getInputChoiceValues();
    this.queryData(1);
  },
  mounted() {
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    this.ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
    if (ms_roles.indexOf('MDM_TEAM') != -1) {
      this.isShow = true
    } else {
      this.isShow = false
    }
    if (this.ms_Permission.indexOf('unconventional_approval_configuration') !== -1) {
      this.isShowParams = true
    } else {
      this.isShowParams = false
    }
  },
  methods: {
    foreignCurrencyCodeChange(val) {
      console.log("GY🚀 ~ file: material-master-add.vue:3607 ~ foreignCurrencyCodeChange ~ val:", val);
      if (val) {
        this.$refs.foreignCurrencyCode_rule.clearValidate();
      }
    },
    isCqsAuditChange(e) {
      if (e === 'Y') {
        this.getCqsAuditor('change')
      } else {
        this.createParams.cqsAuditor = null
      }
    },
    getCqsAuditor(val) {
      if (!this.createParams.fiveBitCode) {
        this.$message.error('请选择GRI')
        return false
      }
      apiService.findCqsAuditor({}, this.createParams.fiveBitCode).then((res) => {
        this.cqsAuditorLists = res.data;
        if (val == 'change') {
          this.createParams.cqsAuditor = res.data[0].tmUserId
        }
      });
    },
    isFinanceAuditChange(e) {
      if (e === 'Y') {
        this.getFinanceAuditor('change')
      } else {
        this.createParams.financeAuditor = null
      }
    },
    getFinanceAuditor(val) {
      apiService.findFinanceAuditor({}).then((res) => {
        this.financeAuditorLists = res.data;
        if (val === 'change') {
          this.createParams.financeAuditor = res.data[0].tmUserId
        }
      });
    },
    delTrim(val, str) {
      switch (str) {
        case 'eightBitCodeName':
          if (commonFun.isNotEmpty(val)) {
            this.createParams.eightBitCodeName = this.createParams.eightBitCodeName.trim();
          } else {
            this.createParams.eightBitCodeName = '';
          }
          break;
        case 'rawProductEName':
          if (commonFun.isNotEmpty(val)) {
            this.createParams.rawProductEName = this.createParams.rawProductEName.trim();
          } else {
            this.createParams.rawProductEName = '';
          }
          break;
        case 'remarks':
          if (commonFun.isNotEmpty(val)) {
            this.createParams.remarks = this.createParams.remarks.trim();
          } else {
            this.createParams.remarks = '';
          }
          break;
      }
    },
    onChange(e) {
      if (e === 'Y' && this.griInfo.categoryLevel1Name === "Non-Food" && this.griInfo.categoryLevel2Name === 'Toys') {
        this.isToyVendor = true
      } else {
        this.isToyVendor = false
        this.createParams.toyVendor = ''
      }
    },
    wrinInput(e) {
      if (!e) {
        return false
      }
      var reg = /^(0|[1-9][0-9]*)$/
      if (reg.test(e)) {
        if (e.length === 1) {
          var str = '00000' + '-' + '00' + e
          this.createParams.wrinCode = str
        } else if (e.length === 2) {
          var str = '00000' + '-' + '0' + e
          this.createParams.wrinCode = str
        } else if (e.length === 3) {
          var str = '00000' + '-' + e
          this.createParams.wrinCode = str
        } else if (e.length === 4) {
          var startStr = e.substring(0, 1)
          var endStr = e.substring(e.length - 3, e.length)
          var str = '0000' + startStr + '-' + endStr
          this.createParams.wrinCode = str
        } else if (e.length === 5) {
          var startStr = e.substring(0, 2)
          var endStr = e.substring(e.length - 3, e.length)
          var str = '000' + startStr + '-' + endStr
          this.createParams.wrinCode = str
        } else if (e.length === 6) {
          var startStr = e.substring(0, 3)
          var endStr = e.substring(e.length - 3, e.length)
          var str = '00' + startStr + '-' + endStr
          this.createParams.wrinCode = str
        } else if (e.length === 7) {
          var startStr = e.substring(0, 4)
          var endStr = e.substring(e.length - 3, e.length)
          var str = '0' + startStr + '-' + endStr
          this.createParams.wrinCode = str
        } else if (e.length === 8) {
          var startStr = e.substring(0, 5)
          var endStr = e.substring(e.length - 3, e.length)
          var str = startStr + '-' + endStr
          this.createParams.wrinCode = str
        }
      }
    },
    addFreightRow() {
      if (commonFun.isEmpty(this.createParams.tmPlantId)) {
        Message.warning("请选择工厂");
        return;
      }
      unit.getDefaultPickupPointOfPlant(this.createParams.tmPlantId).then(res => {
        if (res.code == '200') {
          let pickupPointId = res.data;
          // isNewDc:是否新增DC
          let newDc = this.createParams.isNewDc;
          if (newDc == "Y") {
            // 如果运费信息不存在或者列表中存在产品运费（不含税）为空
            if (
              commonFun.isEmpty(this.createParams.freightInfo) ||
              this.createParams.freightInfo.some(freightInfo => commonFun.isEmpty(freightInfo.freight))) {
              Message.error("不满足“是否新增DC”为是的条件，无法直接添加运费；请检查.");
              return;
            } else {
              // 如果产品运费（不含税）不相同
              let firstFreightInfo = this.createParams.freightInfo[0];
              if (this.createParams.freightInfo.some(freightInfo => freightInfo.freight != firstFreightInfo.freight)) {
                Message.error("不满足“是否新增DC”为是的条件，无法直接添加运费；请检查.");
                return;
              }
              this.createParams.freightInfo.push({
                tmPickupId: pickupPointId,
                freight: firstFreightInfo.freight,
                effectiveBeginDate: firstFreightInfo.effectiveBeginDate
              });
            }
          } else {
            this.createParams.freightInfo.push({ tmPickupId: pickupPointId });
          }
        }
      });
    },
    delFreightRow() {
      let selection = this.$refs.freightInfoTable.selection;
      for (var i = this.createParams.freightInfo.length - 1; i >= 0; i--) {
        if (selection.indexOf(this.createParams.freightInfo[i]) >= 0) {
          this.createParams.freightInfo.splice(i, 1);
        }
      }
      this.$refs.freightInfoTable.clearSelection();
    },
    queryPrimaryKey() {
      let that = this
      apiService.queryPrimaryKey().then(res => {
        if (res.code === '200') {
          that.id = res.data;
          that.sixBitCode = res.data;
          that.createParams.sixBitCode = res.data;
        }
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList1 = res.data;
      });
    },
    //新增时查询DCS(不分页)
    findDcsList1() {
      apiService.findDcsList().then((res) => {
        if (res.data) {
          //按照id排序
          let arr = res.data
          arr.sort((a, b) => { return a.tmSupplierId - b.tmSupplierId })
          this.dcList = arr;
        }
      });
    },
    // 修改时获取dcs列表
    findDcsList2() {
      apiService.findDcsList().then((res) => {
        if (res.data) {
          let arr = res.data
          //按照id排序
          arr.sort((a, b) => { return a.tmSupplierId - b.tmSupplierId })
          this.dcList = arr;
          var tmSupplierIds = this.createParams.dcList.filter(ele => {
            return this.dcs.indexOf(ele.tmSupplierId) !== -1
          })
          this.dcList = this.dcList.concat(tmSupplierIds)
          // 去重
          var hash = {}
          this.dcList = this.dcList.reduce(function (item, next) {
            hash[next.tmSupplierId] ? '' : hash[next.tmSupplierId] = true && item.push(next)
            return item
          }, [])
        }
      });
    },
    //物料主数据查询  给 选择对比物料使用
    queryData(val) {
      let that = this
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      apiService.findListPage(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    //物料数据查询详情
    findOne(id) {
      apiService.findOne(id).then((res) => {
        this.contrastParams = res.data;
        //对比物料dc
        if (res.data.dcs) {
          this.contrastDcs = res.data.dcs.split(',').map(Number)
        }
        if (res.data.alternativeDc) {
          this.contrastAlternativeDc = res.data.alternativeDc.split(',').map(Number)
        }
        if (res.data.formarkets) {
          this.contrastFormarkets = res.data.formarkets.split(',')
        }
      });
    },
    //查询结算单位(根据编码)
    findSettlementUnitByCode() {
      if (this.createParams.settlementUnitCode) {
        let that = this
        apiService.findSettlementUnitByCode(this.createParams.settlementUnitCode).then((res) => {
          if (res.data) {
            if (res.data.supplierName) {
              that.createParams.settlementUnitName = res.data.supplierName;
              that.createParams.invitationCode = res.data.invitationCode;
              that.factoryList = res.data.suppliers
              that.createParams.tmSupplierId = res.data.tmSupplierId;
              that.parentId = res.data.tmSupplierId;
            } else {
              Message({ message: '请确认结算单位信息后重新填写', type: "warning" });
            }
          }
        });
      }
    },
    //进入详情时GRI详情(通过GRI编码)
    findOneByCode(type) {
      let that = this
      if (this.createParams.fiveBitCode) {
        this.getCqsAuditor()
        apiService.findOneByCode(this.createParams.fiveBitCode).then((res) => {
          this.categoryLevel1Code = res.data.categoryLevel1Code
          let that = this
          if (res.data) {
            that.griInfo = res.data;
            if (res.data.categoryLevel1Name === 'Non-Food' && res.data.categoryLevel2Name === 'Toys') {
              if (this.createParams.ptoyServiceFeeApplicable && this.createParams.ptoyServiceFeeApplicable === 'Y') {
                this.isToyVendor = true
              } else {
                this.isToyVendor = false
                this.createParams.toyVendor = ''
              }
            } else {
              this.isToyVendor = false
              this.createParams.toyVendor = ''
            }
            //除LOCAL SUMS,Toys外，托盘上物品长宽高等必填
            // 除Local Sums,Toys品类外，其他品类托盘的物品长宽高等、产品运输托盘类型、运输堆叠层数、储存堆叠层数、运输高度为必填
            // debugger
            if (!(res.data.isLocalSums == true || res.data.isToys == true)) {
              // that.isLocalSums = res.data.isLocalSums
              that.isRequired = true
            } else {
              that.isRequired = false
            }
            //  pop，玩具，非常规 必填
            if (type == "change") {
              if (res.data.isToys) {
                that.isToys = true
                //带出当前生效日期最晚的玩具服务费FPA的每件玩具服务费（不含税）
                apiService.fpaByLately().then((res) => {
                  if (res.data) {
                    that.createParams.serviceChargePerToy = res.data.agreedPriceWithoutVat
                    let toyServiceFeeWithTax = Number(res.data.agreedPriceWithoutVat) * Number(1 + 0.06);
                    that.$set(that.createParams, 'toyServiceFeeWithTax', toyServiceFeeWithTax)
                  } else {
                    that.createParams.serviceChargePerToy = ''
                    that.createParams.toyServiceFeeWithTax = ''
                  }
                });
              } else {
                that.createParams.serviceChargePerToy = ''
                that.createParams.toyServiceFeeWithTax = ''
                that.isToys = false
              }
            }
            that.createParams.uom = res.data.uom;
            // if (that.roterType !== 'copy') {
            //   that.createParams.inventoryCountingFrequency = res.data.inventoryCountingFrequency
            // }
            that.createParams.standardCopiesUom = res.data.standardCopiesUom;
            if (res.data.isPackaging) {
              //显示出厂价格
              this.isPackaging = true
            } else {
              this.isPackaging = false
              that.createParams.packagingServiceFeeWithTax = ''
              that.createParams.packagingServiceFeeNotTax = ''
              that.createParams.packagingTaxAmount = ''
            }
            if (that.createParams.fiveBitCode) {
              let purchasingCategory = ''
              if (res.data.categoryLevel1Name) {
                purchasingCategory = purchasingCategory + res.data.categoryLevel1Name
              }
              if (res.data.categoryLevel2Name) {
                purchasingCategory = purchasingCategory + '/' + res.data.categoryLevel2Name
              }
              if (res.data.categoryLevel3Name) {
                purchasingCategory = purchasingCategory + '/' + res.data.categoryLevel3Name
              }
              that.createParams.purchasingCategory = purchasingCategory
            }
            that.createParams.isHM = res.data.isHM
            that.createParams.isWrin = res.data.isWrin
            that.isPop = res.data.isPop
            that.isHappyMealSet = res.data.isHappyMealSet
            if (!res.data.isHappyMealSet) {
              that.createParams.isForeignCurrency = null;//是否需要外币结算
              that.createParams.foreignCurrencyCode = null;//外币币种
              that.createParams.exchangeRate = null;//汇率
              that.createParams.foreignCurrencyAmount = null;//外币金额
            }
            //如果是POP物料，清空常规品物料的字段值
            if (res.data.isPop) {
              that.createParams.purchasingManager = null
              that.createParams.rpEffectiveDate = null
              that.createParams.useArea = null
              that.createParams.includedInStoreBag = null
              that.createParams.marketTime = null
              that.createParams.wrinCode = null
              that.createParams.isTraceable = null
              that.createParams.enterCatellaeSystem = null
              that.createParams.hasMultiShelfLife = null
              that.createParams.storageEnvironment = null
              that.createParams.secondShelfLife = null
              that.createParams.secondShelfLifeUnit = null
              that.createParams.firstShelfLife = null
              that.createParams.isNeedThaw = null
              that.createParams.isNeedPreparationTime = null
              that.createParams.isHarmful = null
              that.createParams.taste = null
              that.createParams.shape = null
              that.createParams.color = null
              that.createParams.validityDate = null
              that.createParams.onlineSecondShelfLife = null
              that.createParams.preparationMethod = null
              that.createParams.preparationTime = null
              that.createParams.secondShelfLife = null
              that.createParams.secondShelfLifeUnit = null
              that.createParams.firstShelfLife = null
              that.createParams.shelfLifeAfterThawing = null
              that.createParams.shelfLifeUnitAfterThawing = null
              that.createParams.thawingTime = null
              that.createParams.formula1 = null
              that.createParams.formula2 = null
              that.createParams.formula3 = null
              that.createParams.formula4 = null
            } else {
              that.createParams.sumsSort = null
              that.createParams.specifiUom = null
              that.createParams.projectOrCategoryLeader = null
              that.createParams.department = null
              that.createParams.formarkets = null
              that.formarkets = []
              that.createParams.sizeMm = null
              that.createParams.forStoreTier = null
              that.createParams.internalAndExternalAreas = null
            }
            //清空验证信息
            that.$nextTick(() => {
              that.$refs.createParams.clearValidate();
            })
            //如果 偏好应产率 为空 UOM标准生产份数不为空 * 外包装内含UOM数量不为空 
            if (commonFun.isEmpty(that.createParams.preferentialYield) && commonFun.isNotEmpty(that.createParams.standardCopiesUom) && commonFun.isNotEmpty(that.createParams.quantityUomOutsourceNum)) {
              that.createParams.yield = (that.createParams.standardCopiesUom * 1000000) * (that.createParams.quantityUomOutsourceNum * 1000000) / (1000000 * 1000000);
            } else {
              that.createParams.yield = that.createParams.preferentialYield;
            }
          } else {
            that.$message.error(res.msg || this.$t("common.operateError"));
          }

        });
      }
    },
    //获取上个版本和现版本
    findMaterialRecordEdition(id) {
      apiService.findMaterialRecordEdition(id).then((res) => {
        if (res.data) {
          let that = this
          if (res.data.newRecord) {
            that.categoryLevel1Code = res.data.newRecord.categoryLevel1Code
            that.disTypeTemp = res.data.newRecord.disType
            that.sixBitCode = res.data.newRecord.sixBitCode
            if (this.$route.query.type !== 'copy') {
              that.getFiles(res.data.newRecord.sixBitCode)
            }
            that.createParams = res.data.newRecord;
            that.materialType = res.data.newRecord.materialType;
            if (res.data.newRecord.disType !== "DC_SUPPLIER_DC" && res.data.newRecord.disType !== "SUPPLIER_DC") {
              that.isNewDcList.forEach(ele => {
                if (ele.value === 'Y') {
                  that.createParams.isNewDc = ''
                  that.$set(ele, 'disabled', true)
                } else {
                  that.$set(ele, 'disabled', false)
                }
              })
            } else {
              that.isNewDcList.forEach(ele => {
                that.$set(ele, 'disabled', false)
              })
            }
            if (that.materialType == "new_conventional_material") {
              that.$set(that.createParams, 'isLto', "N")//点击新增常规物料按钮，是否新品字段设置为默认为否 不可编辑，
            }
            if (that.materialType == "new_conventional_material" && (!that.createParams.conductStatus || that.createParams.conductStatus === 'mdm_newly_build')) {
              that.isShowFile = true
            } else {
              that.isShowFile = false
            }
            // 现在新增了非常规物料标识字段.所以这个判断先注释 暂时用不到了
            // if (that.materialType == "new_unconventional_materials") {//非常规
            //   that.isConventionalMaterials = true
            // }
            if (that.createParams.isConventionalMaterials === 'Y') {
              that.isConventionalMaterials = true
            }

            if (res.data.newRecord.gri) {
              that.isToys = res.data.newRecord.gri.isToys;
            }
            //现版本dc
            if (res.data.newRecord.dcs) {
              that.dcs = res.data.newRecord.dcs.split(',').map(Number)
            }
            if (res.data.newRecord.alternativeDc) {
              that.alternativeDc = res.data.newRecord.alternativeDc.split(',').map(Number)
            }
            if (res.data.newRecord.formarkets) {
              that.formarkets = res.data.newRecord.formarkets.split(',')
            }
            //审批日志
            if (that.roterType !== 'copy') {
              if (res.data.newRecord.workFlowLogList) {
                that.workFlowLogList = res.data.newRecord.workFlowLogList
              }
            }
            //判断是否可以审批
            if (res.data.newRecord.isExamine) {
              that.isExamine = res.data.newRecord.isExamine
            }
            //根据GRI查询
            that.findOneByCode()
            if (this.createParams.fiveBitCode) {
              this.getCqsAuditor()
              this.getFinanceAuditor()
            }
            //SS和NFC和CQS和SC Finance在审批物料时可以进行修改，除了结算单位编码和GRI字段不支持支持修改外其他字段都支持修改。
            //如果在审批中
            if (that.createParams.isUnderApproval) {
              //判断是否符合这些状态，否则就禁用表单
              if (["NFC", "SS", "CQS", "SC", "MDM"].includes(that.createParams.approvalRole)) {
                that.disaForm = false
                // 禁用结算单位
                that.disaSettlementUnitCode = true
                //禁用头部
                if (["NFC", "SS", "CQS", "SC"].includes(that.createParams.approvalRole)) {
                  that.disaHead = true
                }
              } else {
                that.disaForm = true
              }
            }
            // 有Dummy编码就是FPA
            if (that.createParams.dummyCode) {
              that.isFpa = true
            }
            if (((res.data.newRecord.conductStatus == 'wait_business_review' || res.data.newRecord.conductStatus == 'sc_finance_audit') && res.data.newRecord.currentReviewer !== '待HGS预审') || (this.$route.query.type !== 'copy' && res.data.newRecord.isApprovedLog && res.data.newRecord.disType == 'SUPPLIER')) {
              this.isDisType = true
            } else {
              this.isDisType = false
            }
          }
          if (res.data.oldRecord && this.roterType !== 'copy') {
            that.oldParams = res.data.oldRecord
            // 上个版本dc
            if (res.data.oldRecord.dcs) {
              that.oldDcs = res.data.oldRecord.dcs.split(',').map(Number)
            }
            if (res.data.oldRecord.alternativeDc) {
              that.oldAlternativeDc = res.data.oldRecord.alternativeDc.split(',').map(Number)
            }
            if (res.data.oldRecord.formarkets) {
              that.oldFormarkets = res.data.oldRecord.formarkets.split(',')
            }
          }
          // 是否存在上个版本
          if (res.data.oldRecordExists) {
            that.oldRecordExists = res.data.oldRecordExists
          }
          // 如果有结算单位编码，则手动触发查询工厂
          if (that.createParams.settlementUnitCode) {
            that.findSettlementUnitByCode()
          }
          if (!that.createParams.weightUnit) {
            that.createParams.weightUnit = 'KG'
          }
          that.createParams.toyServiceFeeTax2 = '6%'

          if (that.roterType == 'copy') {
            //如果是copy进来的，需要id置空
            that.createParams.tmMaterialRecordId = null;
            that.createParams.tmMaterialId = null;
            that.createParams.sixBitCode = null;
            that.createParams.isGift = null;//是否赠品
            that.createParams.toyVendor = null;//玩具服务商
            that.createParams.eightBitCode = null;//物料编码
            that.createParams.isNewDc = null;//是否新增DC
            that.createParams.isConventionalMaterials = null;//非常规物料标识
            that.createParams.purchasingCategory = null;//采购分类
            that.createParams.isSrmIssue = null;
            that.createParams.isExFactoryPriceIssue = null;
            that.createParams.isInboundFreightIssue = null;
            that.createParams.createBy = null;
            that.createParams.createUserName = null;//创建人
            that.createParams.createDate = null;//创建日期
            that.createParams.edition = null;//版本
            that.createParams.isStraightFreightIssue = null;
            that.createParams.isMdmReceive = null;
            that.createParams.isExFactoryPriceReceive = null;
            that.createParams.isMaterialInboundIssue = null;
            that.createParams.isFreightReceivedMdm = null;
            that.createParams.conductStatus = null;//状态
            that.createParams.conductStatusI18n = null;//状态
            that.createParams.isUpdateSettlementUnit = null;
            that.createParams.currentReviewer = null;
            that.createParams.dummyCode = null;
            that.createParams.exFactoryUnitPrice = null;//出厂含税单价
            that.createParams.urchaseTaxRate = null;//采购税率
            that.createParams.exFactoryExcUnitPrice = null;//出厂不含税单价
            that.createParams.purchaseTax = null;//采购税额
            that.createParams.priceEffectiveStartingTime = null;//价格有效起始日期
            that.createParams.futureFactoryRequiredPrice = null;//需要填写未来出厂价
            that.createParams.fpaFreight = null;//Freight
            that.createParams.ptoyServiceFeeApplicable = null;//Toy Service Fee Applicable
            that.createParams.serviceChargePerToy = null;//每件玩具服务费
            that.createParams.toyServiceFeeTax = null;//每件玩具服务费税率
            that.createParams.toyServiceFeeTax2 = null;
            that.createParams.toyServiceFeeWithTax = null;//每件玩具服务费（含税）
            that.createParams.isExistsLineQuotation = null;
            that.createParams.outboundFreight = null;//Outbound运费
            that.createParams.isForeignCurrency = null;//是否需要外币结算
            that.createParams.foreignCurrencyCode = null;//外币币种
            that.createParams.exchangeRate = null;//汇率
            that.createParams.foreignCurrencyAmount = null;//外币金额

            that.createParams.rpEffectiveDate = null;//RP生效日期
            that.createParams.fiveBitCode = null//GRI
            that.createParams.inventoryCountingFrequency = null//门店存货盘点频率
            that.createParams.settlementClassification = null//结算分类
            that.createParams.purchasingCategory = null//采购分类
            that.createParams.approvedBy = null//提交审批人
            that.createParams.isCqsAudit = null//CQS是否审批
            that.createParams.cqsAuditor = null//CQS审批人
            that.createParams.isFinanceAudit = null//Finance是否审批
            that.createParams.financeAuditor = null//Finance审批人
            that.createParams.drawings = null//画稿
            that.createParams.mainMaterial = null//主要材质

            that.createParams.hasMultiShelfLife = 'N'//多保质期标识
            that.createParams.stopSaleDate = '2099-12-31'//停售日期
            if (commonFun.isNotEmpty(that.createParams.freightInfo)) {
              that.createParams.freightInfo.forEach(freight => {
                freight.tmMaterialRecordFreightId = null;
              });
            }
          }
          that.funcB(res.data.newRecord)
          this.findDcsList2()
        }
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.createParams.categoryLevel2Id = null
      this.createParams.categoryLevel3Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.createParams.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.createParams.categoryLevel3Id = null
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 3, pid: this.createParams.categoryLevel2Id }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1Contrast() {
      this.queryCondition.categoryLevel2Id = null
      this.queryCondition.categoryLevel3Id = null
      this.categoryList2Contrast = []
      this.categoryList3Contrast = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList2Contrast = res.data;
      });
    },
    //待办进来查真正的id
    findNewMaterialRecord() {
      apiService.findNewMaterialRecord(this.id).then((res) => {
        if (res.data) {
          this.id = res.data
          this.findMaterialRecordEdition(this.id)
        }
      });
    },
    //根据选中Category2查询Category3
    changeCategory2Contrast() {
      this.queryCondition.categoryLevel3Id = null
      this.categoryList3Contrast = []
      apiService.findCategory({ categoryLevel: 3, pid: this.queryCondition.categoryLevel2Id }).then((res) => {
        res.data = res.data.map(item => ({
          ...item,
          name: item.name || ' '
        }))
        this.categoryList3Contrast = res.data;
      });
    },
    //分类负责人查询
    //是新品，就传SS，不是新品，就传NFC
    //如果是非常规物料，传ADMIN
    getLeaderList() {
      this.leaderList = []
      // 当非常规物料是是时,提交审批人为Admin角色
      console.log('this.createParams.isConventionalMaterials', this.createParams.isConventionalMaterials);
      if (this.createParams.isConventionalMaterials == 'Y') {
        apiService.categoryLeaderList({ type: 'ADMIN' }).then((res) => {
          console.log("🚀 ~ file: material-master-add.vue ~ line 4113 ~ apiService.categoryLeaderList ~ res", res)
          this.leaderList = res.data;
        });
      } else {
        // 当非常规物料是否时,如果LTO是Y,则提交审批人为Nfc角色,否则,是SS
        apiService.categoryLeaderList({ type: this.createParams.isLto == 'Y' ? 'NFC' : 'SS' }).then((res) => {
          console.log("🚀 ~ file: material-master-add.vue ~ line 4119 ~ apiService.categoryLeaderList ~ res", res)
          this.leaderList = res.data;
        });
      }
    },
    // 默认第一次进入详情
    funcA(result) {
      this.leaderList = []
      console.log('this.createParams.isConventionalMaterials', this.createParams.isConventionalMaterials);
      if (this.createParams.isConventionalMaterials == 'Y') {
        // 当非常规物料是是时,提交审批人为Admin角色
        return new Promise((resolve, reject) => {
          apiService.categoryLeaderList({ type: 'ADMIN' }).then((res1) => {
            console.log("🚀 ~ file: material-master-add.vue ~ line 4129 ~ apiService.categoryLeaderList ~ res1", res1)
            resolve(res1)
          });
        })
      } else {
        // 当非常规物料是否时,如果LTO是Y,则提交审批人为Nfc角色,否则,是SS
        return new Promise((resolve, reject) => {
          apiService.categoryLeaderList({ type: this.createParams.isLto == 'Y' ? 'NFC' : 'SS' }).then((res2) => {
            console.log("🚀 ~ file: material-master-add.vue ~ line 4137 ~ apiService.categoryLeaderList ~ res2", res2)
            resolve(res2)
          });
        })
      }
    },
    async funcB(result) {
      var resB = await this.funcA(result)
      if (resB.code === '200') {
        this.leaderList = resB.data
        var bool = this.leaderList.every(ele => {
          return ele.tmUserId !== result.approvedBy
        })
        if (bool) {
          this.createParams.approvedBy = ''
        }
      }
    },
    // 非常规审批切换
    isConventionalMaterialsChange(e) {
      console.log("🚀 ~ file: material-master-add.vue ~ line 4159 ~ isConventionalMaterialsChange ~ e", e)
      this.createParams.approvedBy = ''
      if (this.materialType === 'new_toy_material' || this.materialType === 'new_conventional_material') {
        this.getLeaderList()
        return
      }
      // 非常规时
      if (e === 'Y') {
        this.isConventionalMaterials = true
        this.materialType = 'new_unconventional_materials'
      } else {
        this.isConventionalMaterials = false
        this.materialType = ''
      }
      this.getLeaderList()
    },
    //校验折算系数
    saveConversion() {
      if (this.createParams.conversionCoefficient) {
        this.showConversionCoefficient = false
        this.save(1)
      } else {
        Message({ message: '请填写必填的数据', type: "error" });
        return false;
      }
    },

    //保存、提交、新增  申请状态(1、保存 2、提交 3、审批)
    save(type) {
      let that = this
      if (!that.createParams.eightBitCodeName) {
        Message({ message: '产品中文名称不能为空', type: "warning" });
        return
      }
      if (!that.createParams.rawProductEName) {
        Message({ message: '产品英文名称不能为空', type: "warning" });
        return
      }
      //校验dcs和备选dcs 是否有相同的值
      const a = that.verifyDcs()
      if (!a) {
        return;
      }
      that.createParams.applyType = type
      console.log("GY🚀 ~ file: material-master-add.vue:4359 ~ save ~ that.createParams.exchangeRate:", that.createParams.exchangeRate);
      that.createParams.exchangeRate = that.createParams.exchangeRate ? Number(that.createParams.exchangeRate).toFixed(4) : null
      if (type === 1 || type === 2) {
        if (that.materialType === 'new_conventional_material' && (that.createParams.conductStatus === 'approved' || that.createParams.conductStatus === 'mdm_maintenance')) {
          that.createParams.materialType = ''
        } else {
          that.createParams.materialType = that.materialType
        }
      } else {
        that.createParams.materialType = that.materialType
      }
      if (that.dcs) {
        that.createParams.dcs = that.dcs.join(',')
      }
      if (that.alternativeDc) {
        that.createParams.alternativeDc = that.alternativeDc.join(',')
      }
      if (that.formarkets) {
        that.createParams.formarkets = that.formarkets.join(',')
      }
      //如果是copy进来的，需要id置空
      if (that.roterType === 'copy') {
        that.createParams.tmMaterialRecordId = null
        that.createParams.sixBitCode = null
        // that.createParams.eightBitCode = null//物料编码不能清空
        that.createParams.isSrmIssue = null
        that.createParams.isExFactoryPriceIssue = null
        that.createParams.isInboundFreightIssue = null
        that.createParams.isStraightFreightIssue = null
        that.createParams.isMdmReceive = null
        that.createParams.isExFactoryPriceReceive = null
        that.createParams.isMaterialInboundIssue = null
        that.createParams.isFreightReceivedMdm = null
        that.createParams.conductStatus = null
        that.createParams.conductStatus = null
        that.createParams.hasMultiShelfLife = 'N'//多保质期标识
        that.createParams.stopSaleDate = '2099-12-31'//停售日期
        if (commonFun.isNotEmpty(that.createParams.freightInfo)) {
          that.createParams.freightInfo.forEach(freight => {
            freight.tmMaterialRecordFreightId = null;
          });
        }
      }
      //提交要校验必填
      if (type === 1) {//保存
        //保存为草稿校验结算单位和工厂必填
        const p1 = new Promise((resolve, reject) => {
          that.$refs["createParams"].validateField('settlementUnitCode', errMsg => {
            if (!errMsg) resolve()
          });
        })
        const p2 = new Promise((resolve, reject) => {
          that.$refs["createParams"].validateField('tmPlantName', errMsg => {
            if (!errMsg) resolve()
          })
        })
        Promise.all([p1, p2]).then(() => {
          // this.isLoading = true
          this.isDisabled = true
          apiService.add(that.createParams).then((res) => {
            // this.isLoading = false
            this.isDisabled = false
            if (res.code === '200') {
              Message({ message: that.$t('common.operateSuccess'), type: "success" });
              that.findMaterialRecordEdition(res.data)
              that.id = res.data
              //如果是copy成功了，在当前页面就是查看详情
              if (that.roterType === 'copy') {
                that.roterType = 'detail'
              }
            } else {
              Message({ message: that.$t('common.operateError'), type: "error" });
            }
          });
        })
      } else {
        if (type === 3) {//审批
          if (that.info.approvalType == '2' && !that.info.approvalDescription) {
            Message({ message: '不通过，需要填写审批备注', type: "warning" });
            return
          }
          that.createParams.approvalType = that.info.approvalType
          that.createParams.approvalDescription = that.info.approvalDescription
        }

        //是否通过 不通过时候 不校验必填 that.info.approvalType == '2'
        if (type === 3 && that.info.approvalType == '2') {
          // this.isLoading = true
          this.isDisabled = true
          apiService.add(that.createParams).then((res) => {
            // this.isLoading = false
            this.isDisabled = false
            if (res.code === '200') {
              that.routerBack();
              Message({ message: that.$t('common.operateSuccess'), type: "success" });
            } else {
              Message({ message: that.$t('common.operateError'), type: "error" });
            }
          });
        }

        if (type === 2 || (type === 3 && that.info.approvalType != '2')) {
          if (this.showFreightInfo && ['SUPPLIER_DC', 'DC_SUPPLIER_DC'].indexOf(this.createParams.disType) >= 0) {
            if (commonFun.isEmpty(this.createParams.freightInfo)) {
              Message.error('DC_SUPPLIER_DC' == this.createParams.disType ? "请维护至少一个DC的运费信息" : "请维护运费信息");
              return false;
            } else if ('DC_SUPPLIER_DC' == this.createParams.disType) {
              if (!commonFun.validForm(this.createParams.freightInfo, this.freightInfoRules, '运费信息页')) {
                return;
              }
            } else if ('SUPPLIER_DC' == this.createParams.disType) {
              let freightInfoDcIds = this.createParams.freightInfo.map(dc => Number(dc.tmDcId));
              let errorFlag = false;
              var existsFlag = this.dcs.every(ele => {
                return freightInfoDcIds.includes(ele)
              })
              console.log('existsFlag', existsFlag);
              if (!existsFlag) {
                Message.error("请对核对运费信息");
                return false;
              }
              this.dcs.forEach(dcId => {
                let existsFlag = false;
                freightInfoDcIds.forEach(freightInfoDcId => {
                  if ((dcId - 0) == (freightInfoDcId - 0)) {
                    existsFlag = true;
                  }
                })
                errorFlag = !existsFlag;
              });
              if (errorFlag) {
                Message.error("请对核对运费信息");
                return false;
              }
              freightInfoDcIds.forEach(dcId => {
                let existsFlag = false;
                this.dcs.forEach(freightInfoDcId => {
                  if ((dcId - 0) == (freightInfoDcId - 0)) {
                    existsFlag = true;
                  }
                })
                errorFlag = !existsFlag;
              });
              if (errorFlag) {
                Message.error("请对核对运费信息");
                return false;
              }
              if (!commonFun.validForm(this.createParams.freightInfo, this.freightInfoRules, '运费信息页')) {
                return;
              }
            }
          }
          if ((that.createParams.disType == 'DC_SUPPLIER_DC' || that.createParams.disType == 'DC' || that.createParams.disType == 'SUPPLIER_DC') && that.dcs.length < 1) {
            Message({ message: 'DCs不能为空', type: "warning" });
            return false
          }
          //如果为POP物料则，ForMarkets必填
          if (that.isPop && that.formarkets.length < 1) {
            Message({ message: 'ForMarkets不能为空', type: "warning" });
            return false
          }
          if (that.fileList.length < 1 && this.materialType == "new_conventional_material" && (!this.createParams.conductStatus || this.createParams.conductStatus === 'mdm_newly_build')) {//常规物料
            Message({ message: '请上传附件', type: "warning" });
            return false
          }
          //产品外包装毛重校验大于净重
          if (parseFloat(that.createParams.externalPackagingNetweight) >= parseFloat(that.createParams.externalPackagingGrossweight)) {
            Message({ message: this.$t("material.GrossWeightBigWeight"), type: "warning" });
            return false
          }
          that.$refs['createParams'].validate((valid) => {
            if (valid) {
              // this.isLoading = true
              this.isDisabled = true
              apiService.add(that.createParams).then((res) => {
                // this.isLoading = false
                this.isDisabled = false
                if (res.code === '200') {
                  that.routerBack();
                  Message({ message: that.$t('common.operateSuccess'), type: "success" });
                } else {
                  Message({ message: that.$t('common.operateError'), type: "error" });
                }
              });
            } else {
              Message({ message: '请检查物料字段信息是否填写完整和符合规则，如不符合对应字段框线将标红；请修正.', type: "error" });
              return false;
            }
          });
        }
      }
    },
    //确定选中对比物料
    confirmContrast() {
      if (!!this.radioVal) {
        this.findOne(this.radioVal)
        this.showContrast = false
      } else {
        Message({ message: '请选择需要对比的数据', type: "error" });
      }
    },
    //校验dcs和备选dcs 是否有相同的值
    verifyDcs() {
      for (const i of this.dcs) {
        for (const j of this.alternativeDc) {
          if (i === j) {
            Message({ message: 'DCs和备选DC不可以存在相同的元素', type: "warning" });
            return false
          }
        }
      }
      this.dcs.sort((a, b) => { return a - b });
      this.alternativeDc.sort((a, b) => { return a - b })
      return true
    },
    verifyDcs2() {
      if (this.dcs.length > 0) {
        this.$refs['dcs'].clearValidate()
      }
      for (const i of this.dcs) {
        for (const j of this.alternativeDc) {
          if (i === j) {
            Message({ message: 'DCs和备选DC不可以存在相同的元素', type: "warning" });
            return false
          }
        }
      }
      return true
    },
    //渲染结算单位
    onConfirmSettlementUnit(data) {
      this.createParams.settlementUnitName = data.supplierName
      this.createParams.settlementUnitCode = data.supplierCode
      this.parentId = data.tmSupplierId
      this.createParams.tmPlantId = null
      this.createParams.tmPlantName = null
      this.findSettlementUnitByCode()
      this.showSettlementUnitDialog = false
    },
    //渲染工厂
    onConfirmPlan(data) {
      this.createParams.tmPlantId = data.tmSupplierId
      this.createParams.tmPlantName = data.supplierName
      this.showPlanDialog = false
    },
    //渲染GRI
    onConfirmGri(data) {
      console.log('data', data);
      //清空所有的校验，否则校验信息 错位显示
      this.$nextTick(() => {
        this.$refs.createParams.clearValidate();
      })
      this.createParams.fiveBitCode = data.fiveBitCode
      this.createParams.inventoryCountingFrequency = data.inventoryCountingFrequency
      this.$refs.createParams.validateField("fiveBitCode");
      //根据GRI查询
      this.findOneByCode('change')
      var ms_emplFlag = localStorage.getItem('ms_emplFlag')
      // 供应商复制创建 物料编码不能填写不能校验 MDM复制创建 可以
      if (this.$route.query.type == 'copy' && ms_emplFlag !== 'SUP' && data.categoryLevel2Name === 'POP') {
        this.isEightBitCode = true
      } else {
        this.isEightBitCode = false
      }
      this.showGriDialog = false
    },
    serviceChargePerToyBlur() {
      if (this.createParams.serviceChargePerToy) {
        //每件玩具服务费（含税）=每件玩具服务费（不含税）*（1+每件玩具服务费税率）
        let toyServiceFeeWithTax = Number(this.createParams.serviceChargePerToy) * Number(1 + 0.06);
        // let toyServiceFeeWithTax = Number(this.createParams.serviceChargePerToy) * Number(1+this.createParams.toyServiceFeeTax);
        this.$set(this.createParams, 'toyServiceFeeWithTax', toyServiceFeeWithTax)
      }
    },
    computePurchaseTax() {
      if (this.createParams.exFactoryExcUnitPrice) {
        //采购税额 = 采购税率*出厂不含税单价
        let purchaseTaxRate = new Decimal(this.createParams.urchaseTaxRate);
        console.log("GY🚀 ~ computePurchaseTax ~ this.createParams.urchaseTaxRate:", this.createParams.urchaseTaxRate);
        let exFactoryExcUnitPrice = new Decimal(this.createParams.exFactoryExcUnitPrice);
        let purchaseTax = purchaseTaxRate.times(exFactoryExcUnitPrice).toFixed(6);
        this.$set(this.createParams, 'purchaseTax', purchaseTax)
        //出厂含税单价 = 出厂不含税单价+采购税额
        let exFactoryUnitPrice = exFactoryExcUnitPrice.plus(purchaseTax);
        this.$set(this.createParams, 'exFactoryUnitPrice', exFactoryUnitPrice)
      }
    },
    //Future Ex Works Cost/Case (with tax) = Future Ex Works Cost/Case (w/o tax)*（1+FuturePurchaseTaxAmount）
    computeFutureExWorksWithTax() {
      if (this.createParams.futureExWorksNotTax && this.createParams.urchaseTaxRate) {
        let futureExWorksWithTax = this.createParams.futureExWorksNotTax * (1 + this.createParams.urchaseTaxRate * 1);
        let futurePurchaseTaxAmount = this.createParams.futureExWorksNotTax * this.createParams.urchaseTaxRate;
        this.$set(this.createParams, 'futureExWorksWithTax', futureExWorksWithTax);
        this.$set(this.createParams, 'futurePurchaseTaxAmount', futurePurchaseTaxAmount);
      } else {
        this.$set(this.createParams, 'futureExWorksWithTax', null);
        this.$set(this.createParams, 'futurePurchaseTaxAmount', null);
      }
    },
    computePackagingServiceFeeWithTax() {
      if (this.createParams.packagingServiceFeeNotTax && this.createParams.packagingTaxAmount) {
        let packagingServiceFeeWithTax = Number(this.createParams.packagingServiceFeeNotTax) * (1 + Number(this.createParams.packagingTaxAmount))
        this.$set(this.createParams, 'packagingServiceFeeWithTax', packagingServiceFeeWithTax)
      }
    },
    //最小DC收货有效期(天)--自动计算可以修改，计算规则：第一保质期（天）*2/3（结果取整，不计算小数）
    computMinimumDcReceivingValidity() {
      if (this.createParams.firstShelfLife) {
        let minimumDcReceivingValidity = Number(this.createParams.firstShelfLife) * 2 / 3
        this.$set(this.createParams, 'minimumDcReceivingValidity', Math.trunc(minimumDcReceivingValidity))
      }
    },
    //外包装内含UoM数量=内包装内容UoM数量*外包装内含内包装数量
    computeQuantityUomOutsourceNum() {
      let that = this
      if (this.createParams.quantityUomInnerNum && this.createParams.outerPackageContainsNum) {
        let quantityUomOutsourceNum = Number(this.createParams.quantityUomInnerNum) * Number(this.createParams.outerPackageContainsNum)
        this.$set(this.createParams, 'quantityUomOutsourceNum', quantityUomOutsourceNum)
      }
      //如果 偏好应产率为空 UOM标准生产份数不为空   应产率为UOM标准生产份数*外包装内含UOM数量
      if (commonFun.isEmpty(that.createParams.preferentialYield) && commonFun.isNotEmpty(that.createParams.standardCopiesUom)) {
        that.createParams.yield = that.createParams.standardCopiesUom * that.createParams.quantityUomOutsourceNum
      } else {
        that.createParams.yield = that.createParams.preferentialYield;
      }
      //内包装物品数量 = 内包装内含UOM数量
      that.createParams.quantityInnerGoodsNum = that.createParams.quantityUomInnerNum
      //内包装数量 = 外包装内含内包装数量
      that.createParams.quantityInnerPackingNum = that.createParams.outerPackageContainsNum
    },
    clearQuantityUomInnerNum() {
      this.createParams.quantityUomOutsourceNum = ''//清空 外包装内含UOM数量
      if (commonFun.isEmpty(this.createParams.preferentialYield)) { //如果 偏好应产率为空 清空应产率
        this.createParams.yield = ''
      }
      if (commonFun.isEmpty(this.createParams.quantityUomInnerNum)) {
        this.createParams.quantityInnerGoodsNum = ''
      }
      if (commonFun.isEmpty(this.createParams.outerPackageContainsNum)) {
        this.createParams.quantityInnerPackingNum = ''
      }
    },
    //下拉列表数据获取
    getInputChoiceValues: function () {
      let mapObj = {};
      mapObj["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"] = "TM_MATERIAL_RECORD:URCHASE_TAX_RATE";
      mapObj["TM_MATERIAL_RECORD:FORMARKETS"] = "TM_MATERIAL_RECORD:FORMARKETS";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.urchaseTaxRateList = res["TM_MATERIAL_RECORD:URCHASE_TAX_RATE"];
        this.formarketsList = res["TM_MATERIAL_RECORD:FORMARKETS"];
      });
    },
    //切换：是否CTC可结算时，清空是否CTC进口和是否CTC直采
    changeCanCtcSettle() {
      this.$set(this.createParams, 'isCtcImport', 'N')
      this.$set(this.createParams, 'isCtcDirectMining', 'N')
    },
    //切换：需要填写未来出厂价(为"是"展示，为"否"时不展示)
    changeFutureFactoryRequiredPrice() {
      this.$set(this.createParams, 'futureExWorksNotTax', null)
      this.$set(this.createParams, 'futureExWorksWithTax', null)
      this.$set(this.createParams, 'futurePriceEffectiveDate', null)
      this.$set(this.createParams, 'futurePurchaseTaxAmount', null)
      this.$set(this.createParams, 'previousExWorks', null)
    },
    //切换：是否有内包装为“是”时
    changeIsInnerPacking() {
      this.$set(this.createParams, 'innerPackingType', null)
      this.$set(this.createParams, 'innerPackageLength', null)
      this.$set(this.createParams, 'innerPackingHeight', null)
      this.$set(this.createParams, 'innerPackingWeight', null)
      this.$set(this.createParams, 'innerPackingWidth', null)
      this.$set(this.createParams, 'innerPackingGrossWeight', null)
      this.$set(this.createParams, 'innerPackingCapacity', null)
      this.$set(this.createParams, 'productLength', null)
      this.$set(this.createParams, 'productHeight', null)
      this.$set(this.createParams, 'productWeight', null)
      this.$set(this.createParams, 'productWidth', null)
      this.$set(this.createParams, 'productGrossWeight', null)
    },
    isShowPlan(val) {
      if (!val) {
        this.showPlanDialog = true
      }
    },
    selectApprovedBy(id) {
      let selectedName = {};
      selectedName = this.leaderList.find((item) => {
        return item.tmUserId === id;
        //筛选出匹配数据，是对应数据的整个对象
      });
      this.createParams.purchasingManager = selectedName.userName
    },
    changeProductTransportPalletType() {
      this.$refs.createParams.validateField('productTransportPalletType');
    },
    importedOrNotBlur(event) {
      this.$refs.createParams.validateField('gtin');
    },
    minimumOrdersBlur(event) {
      this.$refs.createParams.validateField('minimumOrders');
    },
    blurPalletItemsLength(value, num) {
      this.$refs.createParams.validateField('palletItemsLength');
      return this.onBlur(value, num)
    },
    blurPalletItemsWidth(value, num) {
      this.$refs.createParams.validateField('palletItemsWidth');
      return this.onBlur(value, num)
    },
    blurPalletItemsHeight(value, num) {
      this.$refs.createParams.validateField('palletItemsHeight');
      return this.onBlur(value, num)
    },
    blurPalletItemsWeight(value, num) {
      this.$refs.createParams.validateField('palletItemsWeight');
      return this.onBlur(value, num)
    },
    clearPackagingServiceFeeNotTax() {
      let that = this
      that.createParams.packagingServiceFeeWithTax = ''
    },
    clearfuturePurchaseTaxAmount() {
      let that = this
      that.createParams.futureExWorksWithTax = ''
      that.createParams.futurePurchaseTaxAmount = ''
    },

    importedOrNotChange(val) {
      let that = this
      if (val == 'Y') {
        that.$nextTick(() => {
          that.$refs['createParams'].clearValidate(['gtin']);
        })

      }
    },
    formarketsChange(val) {
      let that = this
      //这些代码都没效果
      if (val.length > 0) {
        that.$refs['createParams'].clearValidate(['formarkets']);

        that.$nextTick(() => {
          that.$refs['createParams'].clearValidate(['formarkets']);
        })
      }
    },
    externalPackagingNetweightBlur(value, num) {
      let that = this
      if (parseFloat(that.createParams.externalPackagingNetweight) >= parseFloat(that.createParams.externalPackagingGrossweight)) {
        Message({ message: this.$t("material.GrossWeightBigWeight"), type: "warning" });
      }
      if (!value) {
        return;
      }
      var a, b, c, i;
      a = value.toString();
      b = a.indexOf(".");
      c = a.length;
      if (num == 0) {
        if (b != -1) {
          a = a.substring(0, b);
        }
      } else {//如果没有小数bai点
        if (b == -1) {
          a = a + ".";
          for (i = 1; i <= num; i++) {
            a = a + "0";
          }
        } else {//有小数点，超出位数自动截取，否则补0
          a = a.substring(0, b + num + 1);
          for (i = c; i <= b + num; i++) {
            a = a + "0";
          }
        }
      }
      return a;
    },
    externalPackagingGrossweightBlur(value, num) {
      let that = this
      if (parseFloat(that.createParams.externalPackagingGrossweight) <= parseFloat(that.createParams.externalPackagingNetweight)) {
        Message({ message: this.$t("material.GrossWeightBigWeight"), type: "warning" });
      }
      if (!value) {
        return;
      }
      var a, b, c, i;
      a = value.toString();
      b = a.indexOf(".");
      c = a.length;
      if (num == 0) {
        if (b != -1) {
          a = a.substring(0, b);
        }
      } else {//如果没有小数bai点
        if (b == -1) {
          a = a + ".";
          for (i = 1; i <= num; i++) {
            a = a + "0";
          }
        } else {//有小数点，超出位数自动截取，否则补0
          a = a.substring(0, b + num + 1);
          for (i = c; i <= b + num; i++) {
            a = a + "0";
          }
        }
      }
      return a;
    },
    blurPreferentialYield(event) {
      let preferentialYield = event.target.value;
      let that = this;
      if (commonFun.isEmpty(that.createParams.preferentialYield) && commonFun.isNotEmpty(that.createParams.standardCopiesUom) && commonFun.isNotEmpty(that.createParams.quantityUomOutsourceNum)) {
        that.createParams.yield = (that.createParams.standardCopiesUom * 1000000) * (that.createParams.quantityUomOutsourceNum * 1000000) / (1000000 * 1000000);
      } else {
        this.createParams.yield = preferentialYield;
      }
    },
    clearPreferentialYield() {
      let that = this;
      if (commonFun.isNotEmpty(that.createParams.standardCopiesUom) && commonFun.isNotEmpty(that.createParams.quantityUomOutsourceNum)) {
        that.createParams.yield = (that.createParams.standardCopiesUom * 1000000) * (that.createParams.quantityUomOutsourceNum * 1000000) / (1000000 * 1000000);
      }
    },

    disTypeChange(e) {
      console.log('e', e);
      this.$refs['createParams'].clearValidate(['palletItemsLength']);
      this.$refs['createParams'].clearValidate(['palletItemsWidth']);
      this.$refs['createParams'].clearValidate(['palletItemsHeight']);
      this.$refs['createParams'].clearValidate(['palletItemsWeight']);
      this.$refs['createParams'].clearValidate(['palletItemsGrossWeight']);
      if (e !== "DC_SUPPLIER_DC" && e !== "SUPPLIER_DC") {
        this.isNewDcList.forEach(ele => {
          if (ele.value === 'Y') {
            this.createParams.isNewDc = ''
            this.$set(ele, 'disabled', true)
          } else {
            this.$set(ele, 'disabled', false)
          }
        })
      } else {
        this.isNewDcList.forEach(ele => {
          this.$set(ele, 'disabled', false)
        })
      }
      if (this.createParams.disType == "SUPPLIER") {
        this.$set(this.createParams, "factoryPriceIncludeFreight", "N");
      }
    },
    isForeignCurrencyChange(val) {
      console.log("GY🚀 ~ file: material-master-add.vue:4865 ~ isForeignCurrencyChange ~ val:", val);
      if (val == 'N') {
        this.$set(this.createParams, 'foreignCurrencyCode', null)
        this.$set(this.createParams, 'foreignCurrencyAmount', null)
        this.$set(this.createParams, 'exchangeRate', null)
        this.createParams.foreignCurrencyCode = null
        this.createParams.foreignCurrencyAmount = null;//汇率
        this.createParams.exchangeRate = null
      }
    },
    foreignCurrencyAmountBlur(exchangeRate, foreignCurrencyAmount) {
      console.log("GY🚀 ~ foreignCurrencyAmountBlur ~ foreignCurrencyAmount:", foreignCurrencyAmount);
      console.log("GY🚀 ~ foreignCurrencyAmountBlur ~ exchangeRate:", exchangeRate);
      if (foreignCurrencyAmount) {
        var foreignCurrencyAmount = commonFun.getFloatStr(foreignCurrencyAmount, 6)
        this.$set(this.createParams, 'foreignCurrencyAmount', foreignCurrencyAmount)
      }
      if (exchangeRate && foreignCurrencyAmount) {
        const [integerPart, decimalPart = ''] = foreignCurrencyAmount.split('.');
        console.log("分割整数和小数部分 ~ 小数:", decimalPart);
        console.log("分割整数和小数部分 ~ 整数:", integerPart);
        // 5. 截断超过6位的小数部分（不四舍五入）
        const truncatedDecimal = decimalPart.slice(0, 6);
        console.log("截断超过6位的小数部分（不四舍五入）:", truncatedDecimal);
        const processedValue = decimalPart.length > 0 ? `${integerPart}.${truncatedDecimal}` : integerPart;
        console.log("GY🚀 ~ foreignCurrencyAmountBlur ~ processedValue:", processedValue);
        var num = this.utils.mul(exchangeRate, processedValue, 6)
        console.log("GY🚀 ~ foreignCurrencyAmountBlur ~ num:", num);
        // 出厂不含税单价=汇率*外币金额
        this.$set(this.createParams, 'exFactoryExcUnitPrice', num)
        if (num) {
          //采购税额 = 采购税率*出厂不含税单价
          let purchaseTax = this.utils.mul(this.createParams.urchaseTaxRate, num, 6)
          this.$set(this.createParams, 'purchaseTax', purchaseTax)
          //出厂含税单价 = 出厂不含税单价+采购税额
          // let exFactoryUnitPrice = exFactoryExcUnitPrice.plus(purchaseTax);
          let exFactoryUnitPrice = this.utils.add([num, purchaseTax], 6)
          this.$set(this.createParams, 'exFactoryUnitPrice', exFactoryUnitPrice)
        }
      } else {
        this.$set(this.createParams, 'exFactoryExcUnitPrice', null)
      }
    },
    exchangeRateBlur(exchangeRate, foreignCurrencyAmount) {
      console.log("GY🚀 ~ exchangeRateBlur ~ foreignCurrencyAmount:", foreignCurrencyAmount);
      console.log("GY🚀 ~ exchangeRateBlur ~ exchangeRate:", exchangeRate);
      if (exchangeRate) {
        var exchangeRate = commonFun.getFloatStr(exchangeRate, 4)
        this.$set(this.createParams, 'exchangeRate', exchangeRate)
      }
      if (exchangeRate && foreignCurrencyAmount) {
        const [integerPart, decimalPart = ''] = foreignCurrencyAmount.split('.');
        console.log("分割整数和小数部分 ~ 小数:", decimalPart);
        console.log("分割整数和小数部分 ~ 整数:", integerPart);
        // 5. 截断超过6位的小数部分（不四舍五入）
        const truncatedDecimal = decimalPart.slice(0, 6);
        console.log("截断超过6位的小数部分（不四舍五入）:", truncatedDecimal);
        const processedValue = decimalPart.length > 0 ? `${integerPart}.${truncatedDecimal}` : integerPart;
        console.log("GY🚀 ~ foreignCurrencyAmountBlur ~ processedValue:", processedValue);
        var num = this.utils.mul(exchangeRate, processedValue, 6)
        console.log("GY🚀 ~ foreignCurrencyAmountBlur ~ num:", num);
        this.$set(this.createParams, 'exFactoryExcUnitPrice', num)
      } else {
        this.$set(this.createParams, 'exFactoryExcUnitPrice', null)
      }
    },
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then(res => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.seq = "1";
        attachment.documents = res.data;
        attachment.tsRecId = this.sixBitCode;
        attachment.tsReckindId = "MATERIAL-FILE";
        fileService.saveFile(attachment).then(saveRes => {
          _this.getFiles(this.sixBitCode);
        });
      }).catch(error => {
        //文件上传失败
        _this.$message({
          type: "error",
          message: _this.$t("common.fileUploadFailed")
        });
      });
    },
    //文件列表pdf数据获取
    getFiles: function (id) {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = id;
      attachment.tsReckindId = 'MATERIAL-FILE';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      if (tmDocumentId) {
        fileService.deleteFile(tmDocumentId).then((res) => {
          files.splice(index, 1);
        })
      } else {//还没保存
        files.splice(index, 1);
      }
    },
    showGriDialogFun() {

      this.showGriDialog = true
      this.$refs.Grichild.queryData();
    },
    //模版下载
    downloadTemplate: function (path, name) {
      fileService.downloadTemplate(path, name)
    },
    onInput(num) {
      var str = num
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      var lenLast = str.substr(str.length - 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1)
      }
      //第一位不能是.
      if (len1 == ".") {
        str = ""
      }
      //最后一位不能是.
      if (str.length == 8 && lenLast == ".") {
        str = ""
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1)
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
      str = (str.match(/^\d*(\.?\d{0,2})/g)[0]) || null
      // 小数点后只能输两位
      return str
      // return this.onBlur(str,2)
    },
    onBlur(value, num) {
      if (value) {
        var a, b, c, i;
        a = value.toString();
        b = a.indexOf(".");
        c = a.length;
        if (num == 0) {
          if (b != -1) {
            a = a.substring(0, b);
          }
        } else {//如果没有小数bai点
          if (b == -1) {
            a = a + ".";
            for (i = 1; i <= num; i++) {
              a = a + "0";
            }
          } else {//有小数点，超出位数自动截取，否则补0
            a = a.substring(0, b + num + 1);
            for (i = c; i <= b + num; i++) {
              a = a + "0";
            }
          }
        }
        return a;
      }
    },
    onInput2(num) {
      var str = num
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      var lenLast = str.substr(str.length - 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1)
      }
      //第一位不能是.
      if (len1 == ".") {
        str = ""
      }
      //最后一位不能是.
      if (str.length == 8 && lenLast == ".") {
        str = ""
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1)
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
      str = (str.match(/^\d*(\.?\d{0,6})/g)[0]) || null// 小数点后只能输6位
      str = str.replace(/^\D*(\d*(?:\.\d{0,3})?).*$/g, '$1')//补0
      return str
    }
  },
  extends: commonFunction
}
</script>
<style scoped lang="scss">
table {
  border-collapse: collapse;
}

table,
td,
th {
  border: 1px solid #ebeef5;
  color: #606266;
  height: 45px;

  span {
    color: red;
    padding-left: 7px;
  }

  .card-title {
    background-color: #f5f7fa;
  }
}

.el-input {
  width: 90%;
}

.el-select {
  width: 87%;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
}
.el-form-item__error {
  color: #f56c6c;
  font-size: 10px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
.fixed-tip {
  position: absolute;
  left: 0; /* 与 label 的左对齐 */
  /* top 值会由 .el-form-item__error 的 padding-top 和 line-height 控制 */
}
</style>
<style lang="scss">
.materialMasterAdd {
  .manualVerificationClass {
    .el-form-item__content .el-select .el-input__inner {
      border-color: #f56c6c;
    }
    .manualVerificationMassage {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      position: absolute;
      display: block;
      padding-top: 2px;
      top: 100%;
      left: -7px;
    }
  }
  .searchBox_bottom {
    margin-bottom: 20px;
    display: flex;
    position: relative;
    .el-upload {
      display: block;
      height: 100% !important;
      .el-button {
        height: 100%;
      }
    }
    .MaterialTemplate {
      right: 0;
      position: absolute;
    }
  }
}
</style>

